import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ApplicationLicenseTypeEnum: { input: any; output: any; }
  AttachmentSourceTypeEnum: { input: any; output: any; }
  AttachmentStatusEnum: { input: any; output: any; }
  AuthMethodEnum: { input: any; output: any; }
  ChartTypeEnum: { input: any; output: any; }
  ChatSourceEnum: { input: any; output: any; }
  ChatStatusEnum: { input: any; output: any; }
  ChatTypeEnum: { input: any; output: any; }
  /** Date custom scalar type as ISO formatted string */
  Date: { input: any; output: any; }
  EventChannelObjectEnum: { input: any; output: any; }
  EventChannelTypeEnum: { input: any; output: any; }
  EventSourceEnum: { input: any; output: any; }
  ExportableDataTypeEnum: { input: any; output: any; }
  FindRolesOptionsBaseRolesFilterEnum: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  MachineConnectionTypeEnum: { input: any; output: any; }
  MachineMaintenanceScheduleDayOfWeekEnum: { input: any; output: any; }
  PermissionTypeEnum: { input: any; output: any; }
  PlanEntitlementKeyEnum: { input: any; output: any; }
  PlanLicenseQuantitySynchronizationTypeEnum: { input: any; output: any; }
  PlanLicenseTypeEnum: { input: any; output: any; }
  PreferenceTargetTypeEnum: { input: any; output: any; }
  PriceRecurringIntervalEnum: { input: any; output: any; }
  ScratchpadAppModeEnum: { input: any; output: any; }
  ScratchpadBucketScopeEnum: { input: any; output: any; }
  ScratchpadBucketTypeEnum: { input: any; output: any; }
  ScratchpadRecommendationRequestTypeEnum: { input: any; output: any; }
  ScratchpadSortColumnTypeEnum: { input: any; output: any; }
  SortDirectionTypeEnum: { input: any; output: any; }
  TeamRoleEnum: { input: any; output: any; }
  UserDeviceTypeEnum: { input: any; output: any; }
};

export type Application = {
  __typename?: 'Application';
  appStoreAppId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  licenseType: Scalars['ApplicationLicenseTypeEnum']['output'];
  maxLicenseCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  usedLicenseCount?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationLicense = {
  __typename?: 'ApplicationLicense';
  applicationVersion: ApplicationVersion;
  applicationVersionId: Scalars['String']['output'];
  assignedTo: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  licenseFormValues: Scalars['JSON']['output'];
};

export type ApplicationLicenseForm = {
  __typename?: 'ApplicationLicenseForm';
  form: EmbeddedForm;
  type: Scalars['ApplicationLicenseTypeEnum']['output'];
};

export enum ApplicationLicenseType {
  MACHINE = 'machine'
}

export type ApplicationList = {
  __typename?: 'ApplicationList';
  items?: Maybe<Array<Application>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationVersion = {
  __typename?: 'ApplicationVersion';
  application?: Maybe<Application>;
  applicationId: Scalars['String']['output'];
  baseFilePath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  licenseForm: ApplicationLicenseForm;
  version: Scalars['String']['output'];
};

export type AssignApplicationLicenseInput = {
  applicationVersionId: Scalars['String']['input'];
  assignedTo: Scalars['String']['input'];
  licenseFormValues: Scalars['JSON']['input'];
};

export type Attachment = {
  __typename?: 'Attachment';
  contentType: Scalars['String']['output'];
  createdBy: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  sources?: Maybe<Array<AttachmentSource>>;
  status: Scalars['AttachmentStatusEnum']['output'];
  /**
   * @deprecated this field was previously used in the attachment type in chat.types.ts.
   *     the attachment.types.ts defines the currently used fields for generic attachments
   */
  thumbUrl?: Maybe<Scalars['String']['output']>;
  /**
   * @deprecated this field was previously used in the attachment type in chat.types.ts.
   *     the attachment.types.ts defines the currently used fields for generic attachments
   */
  url?: Maybe<Scalars['String']['output']>;
};

export type AttachmentList = {
  __typename?: 'AttachmentList';
  items?: Maybe<Array<Attachment>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AttachmentSource = {
  __typename?: 'AttachmentSource';
  attachmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  source: Scalars['AttachmentSourceTypeEnum']['output'];
  sourceId: Scalars['String']['output'];
};

export enum AttachmentSourceType {
  CHAT = 'chat',
  CHAT_MESSAGE = 'chat_message',
  MACHINE = 'machine',
  SCRATCHPAD = 'scratchpad',
  USER_AVATAR = 'user_avatar'
}

export enum AttachmentStatus {
  COMPLETED = 'completed',
  FAILED = 'failed',
  IN_PROGRESS = 'in_progress'
}

export type AuthChallenge = {
  __typename?: 'AuthChallenge';
  challengeName: Scalars['String']['output'];
  session: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export enum AuthMethod {
  MAGIC_LINK = 'magic_link',
  PASSWORD = 'password'
}

export type Author = {
  __typename?: 'Author';
  /** @deprecated deprecated in favor of avatarAttachment */
  avatar?: Maybe<Scalars['String']['output']>;
  avatarAttachment?: Maybe<Attachment>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type BuildFormInput = {
  context: Scalars['JSON']['input'];
  formId: Scalars['JSON']['input'];
  values: Scalars['JSON']['input'];
};

export type BuildFormResponse = {
  __typename?: 'BuildFormResponse';
  form: Form;
  values: Scalars['JSON']['output'];
};

export type Chart = {
  __typename?: 'Chart';
  chartType: Scalars['String']['output'];
  displayOrder: Scalars['Float']['output'];
  fields: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  parentId: Scalars['String']['output'];
  template?: Maybe<ChartTemplate>;
  templateId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ChartData = {
  __typename?: 'ChartData';
  id: Scalars['ID']['output'];
  options: ChartOptions;
  results: Array<ChartDataResult>;
  timezone: Scalars['String']['output'];
};

export type ChartDataResult = {
  __typename?: 'ChartDataResult';
  groupBy?: Maybe<Scalars['String']['output']>;
  interval: Scalars['String']['output'];
  label: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type ChartList = {
  __typename?: 'ChartList';
  items?: Maybe<Array<Chart>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ChartOptions = {
  __typename?: 'ChartOptions';
  chartType: Scalars['ChartTypeEnum']['output'];
  title: Scalars['String']['output'];
  yAxisLabel?: Maybe<Scalars['String']['output']>;
};

export type ChartTemplate = {
  __typename?: 'ChartTemplate';
  description: Scalars['String']['output'];
  displayOrder: Scalars['String']['output'];
  form: Form;
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentObject: Scalars['String']['output'];
};

export type ChartTemplateList = {
  __typename?: 'ChartTemplateList';
  items: Array<ChartTemplate>;
  total: Scalars['Int']['output'];
};

export enum ChartType {
  BAR = 'bar',
  LINE = 'line',
  PLOT = 'plot'
}

export type Chat = {
  __typename?: 'Chat';
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['ChatTypeEnum']['output'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  attachments?: Maybe<Array<Attachment>>;
  author: Author;
  chatId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  draft?: Maybe<ChatMessage>;
  editedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  replies?: Maybe<Array<ChatMessage>>;
  source: Scalars['ChatSourceEnum']['output'];
  sourceId: Scalars['String']['output'];
  status?: Maybe<Scalars['ChatStatusEnum']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  totalReplies?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type ChatMessageList = {
  __typename?: 'ChatMessageList';
  items: Array<ChatMessage>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  prevCursor?: Maybe<Scalars['String']['output']>;
};

export type ChatMessageReplyList = {
  __typename?: 'ChatMessageReplyList';
  items: Array<ChatMessage>;
  total: Scalars['Int']['output'];
};

export enum ChatSource {
  MACHINE = 'machine',
  USER = 'user'
}

export enum ChatStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published'
}

export enum ChatType {
  TEAM = 'team'
}

export type CompileScratchpadInput = {
  appData: Scalars['JSON']['input'];
  appId: Scalars['String']['input'];
};

export type ConfirmForgotPasswordRequest = {
  confirmationCode: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateAttachmentInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<CreateAttachmentSourcesInput>>;
};

export type CreateAttachmentSourcesInput = {
  source?: InputMaybe<Scalars['AttachmentSourceTypeEnum']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChartInput = {
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  fields?: InputMaybe<Scalars['JSON']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateChatMessageInput = {
  chatId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  status?: InputMaybe<Scalars['ChatStatusEnum']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEventChannelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  builtin?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  supportedObjects?: InputMaybe<Array<Scalars['EventChannelObjectEnum']['input']>>;
  type?: InputMaybe<Scalars['EventChannelTypeEnum']['input']>;
};

export type CreateEventSubscriptionInput = {
  eventChannelId: Scalars['String']['input'];
  eventDefinitionId: Scalars['String']['input'];
};

export type CreateFileUploadInput = {
  basePath?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateMachineInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  connectionType?: InputMaybe<Scalars['MachineConnectionTypeEnum']['input']>;
  demo?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  softwareVersion?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRoleInput = {
  role: RoleInputType;
  teamIds: Array<Scalars['ID']['input']>;
};

export type CreateScratchpadBucketInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  reusable?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<Scalars['ScratchpadBucketScopeEnum']['input']>;
  scratchpadAppSlug?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['ScratchpadBucketTypeEnum']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateScratchpadInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  appData?: InputMaybe<Scalars['JSON']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
  bucket1Id?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  executedAt?: InputMaybe<Scalars['Date']['input']>;
  loaded?: InputMaybe<Scalars['Boolean']['input']>;
  machineId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateScratchpadPlaylistInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  canRestore?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<ScratchpadPlaylistItemInput>>;
  machineId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateScratchpadRecommendationFeedbackInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  scratchpadRecommendationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateScratchpadRecommendationRequestInput = {
  appSlug: Scalars['String']['input'];
  inputs: Scalars['JSON']['input'];
  type: Scalars['ScratchpadRecommendationRequestTypeEnum']['input'];
};

export type CreateTeamInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['TeamRoleEnum']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTenantInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  authMethod?: InputMaybe<Scalars['AuthMethodEnum']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  avatarAttachment?: InputMaybe<EntityRelationshipInput>;
  billingManager?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinCode?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Credentials = {
  __typename?: 'Credentials';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Float']['output'];
  idToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type DeleteAttachmentInput = {
  id: Scalars['ID']['input'];
};

export type DeleteRoleInput = {
  id: Scalars['ID']['input'];
};

export type DirectConnectGetSyncDataInput = {
  machineId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type DirectConnectGetSyncDataResponse = {
  __typename?: 'DirectConnectGetSyncDataResponse';
  applications: Array<DirectConnectSyncDataScratchpadApplication>;
  currentUser: DirectConnectSyncDataCurrentUser;
  entitlements: Array<DirectConnectSyncDataEntitlement>;
  machine: DirectConnectSyncDataMachine;
  /** @deprecated Use `plans` instead. */
  plan: DirectConnectSyncDataPlan;
  plans: Array<DirectConnectSyncDataPlan>;
  preferences: Array<DirectConnectSyncDataPreference>;
  team: DirectConnectSyncDataTeam;
  teamUsers: Array<DirectConnectSyncDataTeamUser>;
  tenant: DirectConnectSyncDataTenant;
};

export type DirectConnectProvisionMachineInput = {
  certificatePem: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  privateKey: Scalars['String']['input'];
};

export type DirectConnectProvisionMachineResponse = {
  __typename?: 'DirectConnectProvisionMachineResponse';
  ok: Scalars['Boolean']['output'];
};

export type DirectConnectSyncDataApplicationInput = {
  appStoreAppId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  licenseType?: InputMaybe<Scalars['ApplicationLicenseTypeEnum']['input']>;
  maxLicenseCount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  usedLicenseCount?: InputMaybe<Scalars['Int']['input']>;
};

export type DirectConnectSyncDataApplicationLicenseFormInput = {
  form: EmbeddedFormInput;
  type?: InputMaybe<Scalars['ApplicationLicenseTypeEnum']['input']>;
};

export type DirectConnectSyncDataApplicationLicenseInput = {
  applicationVersion: DirectConnectSyncDataApplicationVersionInput;
  applicationVersionId?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  licenseFormValues?: InputMaybe<Scalars['JSON']['input']>;
};

export type DirectConnectSyncDataApplicationVersionInput = {
  application: DirectConnectSyncDataApplicationInput;
  applicationId?: InputMaybe<Scalars['String']['input']>;
  baseFilePath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  licenseForm: DirectConnectSyncDataApplicationLicenseFormInput;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type DirectConnectSyncDataCurrentUser = {
  __typename?: 'DirectConnectSyncDataCurrentUser';
  id: Scalars['ID']['output'];
};

export type DirectConnectSyncDataCurrentUserInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DirectConnectSyncDataEntitlement = {
  __typename?: 'DirectConnectSyncDataEntitlement';
  key: Scalars['PlanEntitlementKeyEnum']['output'];
  value: Scalars['String']['output'];
};

export type DirectConnectSyncDataEntitlementInput = {
  key?: InputMaybe<Scalars['PlanEntitlementKeyEnum']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DirectConnectSyncDataInput = {
  applications?: InputMaybe<Array<DirectConnectSyncDataScratchpadApplicationInput>>;
  currentUser: DirectConnectSyncDataCurrentUserInput;
  entitlements?: InputMaybe<Array<DirectConnectSyncDataEntitlementInput>>;
  machine: DirectConnectSyncDataMachineInput;
  plan: DirectConnectSyncDataPlanInput;
  preferences?: InputMaybe<Array<DirectConnectSyncDataPreferenceInput>>;
  team: DirectConnectSyncDataTeamInput;
  teamUsers: Array<DirectConnectSyncDataTeamUserInput>;
  tenant: DirectConnectSyncDataTenantInput;
};

export type DirectConnectSyncDataMachine = {
  __typename?: 'DirectConnectSyncDataMachine';
  configuration?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  maintenanceState?: Maybe<MachineMaintenanceState>;
  name: Scalars['String']['output'];
};

export type DirectConnectSyncDataMachineInput = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maintenanceState?: InputMaybe<MachineMaintenanceStateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DirectConnectSyncDataPlan = {
  __typename?: 'DirectConnectSyncDataPlan';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sku: Scalars['String']['output'];
};

export type DirectConnectSyncDataPlanInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type DirectConnectSyncDataPreference = {
  __typename?: 'DirectConnectSyncDataPreference';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  targetType: Scalars['PreferenceTargetTypeEnum']['output'];
  value: Scalars['JSON']['output'];
};

export type DirectConnectSyncDataPreferenceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<Scalars['PreferenceTargetTypeEnum']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type DirectConnectSyncDataResponse = {
  __typename?: 'DirectConnectSyncDataResponse';
  ok: Scalars['Boolean']['output'];
};

export type DirectConnectSyncDataScratchpadApplication = {
  __typename?: 'DirectConnectSyncDataScratchpadApplication';
  license: ApplicationLicense;
  scratchpadAppId: Scalars['String']['output'];
  scratchpadAppName: Scalars['String']['output'];
  scratchpadAppSlug: Scalars['String']['output'];
  scratchpadCompilerSchema?: Maybe<Scalars['JSON']['output']>;
  scratchpadMode: Scalars['ScratchpadAppModeEnum']['output'];
  scratchpadProgram?: Maybe<Scalars['String']['output']>;
};

export type DirectConnectSyncDataScratchpadApplicationInput = {
  license: DirectConnectSyncDataApplicationLicenseInput;
  scratchpadAppId?: InputMaybe<Scalars['String']['input']>;
  scratchpadAppName?: InputMaybe<Scalars['String']['input']>;
  scratchpadAppSlug?: InputMaybe<Scalars['String']['input']>;
  scratchpadCompilerSchema?: InputMaybe<Scalars['JSON']['input']>;
  scratchpadMode?: InputMaybe<Scalars['ScratchpadAppModeEnum']['input']>;
  scratchpadProgram?: InputMaybe<Scalars['String']['input']>;
};

export type DirectConnectSyncDataTeam = {
  __typename?: 'DirectConnectSyncDataTeam';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DirectConnectSyncDataTeamInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DirectConnectSyncDataTeamUser = {
  __typename?: 'DirectConnectSyncDataTeamUser';
  active: Scalars['Boolean']['output'];
  admin: Scalars['Boolean']['output'];
  billingManager: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  features: Scalars['JSON']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  permissions: Scalars['JSON']['output'];
  pinCode?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['JSON']['output']>;
  teamRole: Scalars['TeamRoleEnum']['output'];
  username: Scalars['String']['output'];
};

export type DirectConnectSyncDataTeamUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  billingManager?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Scalars['JSON']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['JSON']['input']>>;
  pinCode?: InputMaybe<Scalars['String']['input']>;
  teamRole?: InputMaybe<Scalars['TeamRoleEnum']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type DirectConnectSyncDataTenant = {
  __typename?: 'DirectConnectSyncDataTenant';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DirectConnectSyncDataTenantInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DisableMachineInput = {
  id: Scalars['ID']['input'];
};

export type DisableTeamInput = {
  id: Scalars['ID']['input'];
};

export type DisableUserInput = {
  id: Scalars['ID']['input'];
};

export type EmbeddedForm = {
  __typename?: 'EmbeddedForm';
  schema: Scalars['JSON']['output'];
  uischema: Scalars['JSON']['output'];
};

export type EmbeddedFormInput = {
  schema?: InputMaybe<Scalars['JSON']['input']>;
  uischema?: InputMaybe<Scalars['JSON']['input']>;
};

export type EnableTeamInput = {
  id: Scalars['ID']['input'];
};

export type EnableUserInput = {
  id: Scalars['ID']['input'];
};

export type EntityRelationshipInput = {
  id: Scalars['String']['input'];
};

export type EventChannel = {
  __typename?: 'EventChannel';
  active: Scalars['Boolean']['output'];
  builtin: Scalars['Boolean']['output'];
  config?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  supportedObjects: Array<Scalars['EventChannelObjectEnum']['output']>;
  type: Scalars['EventChannelTypeEnum']['output'];
};

export type EventChannelList = {
  __typename?: 'EventChannelList';
  items?: Maybe<Array<EventChannel>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum EventChannelObject {
  CHAT = 'chat',
  MACHINE = 'machine'
}

export enum EventChannelType {
  CHAT = 'chat',
  USER = 'user',
  WEBHOOK = 'webhook'
}

export type EventDefinition = {
  __typename?: 'EventDefinition';
  builtin: Scalars['Boolean']['output'];
  customMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  object: Scalars['EventChannelObjectEnum']['output'];
  parentId: Scalars['String']['output'];
  subscriptions?: Maybe<Array<EventSubscription>>;
};

export type EventDefinitionList = {
  __typename?: 'EventDefinitionList';
  items?: Maybe<Array<EventDefinition>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type EventNotification = {
  __typename?: 'EventNotification';
  body: Scalars['String']['output'];
  channelType: Scalars['EventChannelTypeEnum']['output'];
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  read: Scalars['Boolean']['output'];
  sentAt: Scalars['Date']['output'];
  source: Scalars['EventSourceEnum']['output'];
  sourceId: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type EventNotificationsList = {
  __typename?: 'EventNotificationsList';
  items?: Maybe<Array<EventNotification>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum EventSource {
  CHAT = 'chat',
  MACHINE = 'machine'
}

export type EventSubscription = {
  __typename?: 'EventSubscription';
  eventChannel: EventChannel;
  eventDefinition: EventDefinition;
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
};

export type EventSubscriptionList = {
  __typename?: 'EventSubscriptionList';
  items?: Maybe<Array<EventSubscription>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ExportChartInput = {
  id: Scalars['ID']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ExportDataInput = {
  dataTypes: Array<Scalars['ExportableDataTypeEnum']['input']>;
};

export enum ExportableDataType {
  MACHINES = 'machines',
  MACHINE_EVENTS = 'machine_events',
  SCRATCHPADS = 'scratchpads',
  TEAMS = 'teams',
  TEAM_USERS = 'team_users',
  USERS = 'users'
}

export type File = {
  __typename?: 'File';
  createdAt?: Maybe<Scalars['Date']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  latest?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  percentComplete?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type FileLink = {
  __typename?: 'FileLink';
  expiration: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};

export type FileList = {
  __typename?: 'FileList';
  items?: Maybe<Array<File>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FileUpload = {
  __typename?: 'FileUpload';
  expires: Scalars['Float']['output'];
  fields: Scalars['JSON']['output'];
  key?: Maybe<Scalars['String']['output']>;
  modifiedKey?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export enum FindRolesOptionsBaseRolesFilter {
  HIDE = 'hide',
  ONLY = 'only',
  SHOW = 'show'
}

export type ForgotPasswordRequest = {
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  username: Scalars['String']['output'];
};

export type Form = {
  __typename?: 'Form';
  id: Scalars['ID']['output'];
  schema: Scalars['JSON']['output'];
  uischema: Scalars['JSON']['output'];
};

export type GetApplicationLicenseInput = {
  licenseId: Scalars['String']['input'];
};

export type GetApplicationVersionInput = {
  applicationId: Scalars['String']['input'];
};

export type GetAssignedApplicationLicenseInput = {
  applicationId: Scalars['String']['input'];
  assignedTo: Scalars['String']['input'];
};

export type GetAttachmentInput = {
  id: Scalars['ID']['input'];
};

export type GetChartDataInput = {
  id: Scalars['ID']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type GetChartInput = {
  id: Scalars['ID']['input'];
};

export type GetChartTemplateInput = {
  id: Scalars['ID']['input'];
};

export type GetChatInput = {
  id: Scalars['ID']['input'];
};

export type GetChatMessageDraftInput = {
  chatId: Scalars['ID']['input'];
  threadId?: InputMaybe<Scalars['Float']['input']>;
};

export type GetChatMessageInput = {
  id: Scalars['ID']['input'];
};

export type GetCompatibleMachinesInput = {
  scratchpadId: Scalars['ID']['input'];
};

export type GetEventChannelInput = {
  id: Scalars['ID']['input'];
};

export type GetEventDefinitionInput = {
  id: Scalars['ID']['input'];
};

export type GetEventSubscriptionInput = {
  id: Scalars['ID']['input'];
};

export type GetFeaturesInput = {
  appVersion: Scalars['String']['input'];
  platform: Scalars['String']['input'];
};

export type GetMachineFileLinkInput = {
  expiresInSeconds?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  path: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type GetMachineInput = {
  id: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type GetPlanInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type GetPreferenceInput = {
  key: Scalars['String']['input'];
  targetId: Scalars['String']['input'];
  targetType: Scalars['PreferenceTargetTypeEnum']['input'];
};

export type GetRoleByTeamInput = {
  teamId: Scalars['ID']['input'];
};

export type GetRoleInput = {
  id: Scalars['ID']['input'];
};

export type GetRolePermissionFormDataInput = {
  roleId: Scalars['ID']['input'];
};

export type GetRolePermissionsInput = {
  roleId: Scalars['ID']['input'];
};

export type GetScratchpadBucketInput = {
  id: Scalars['String']['input'];
};

export type GetScratchpadHistoryInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  scratchpadId: Scalars['ID']['input'];
};

export type GetScratchpadInput = {
  id: Scalars['ID']['input'];
};

export type GetScratchpadPlaylistActivatedInput = {
  machineId: Scalars['String']['input'];
};

export type GetScratchpadRecommendationInput = {
  id: Scalars['ID']['input'];
};

export type GetTeamInput = {
  id: Scalars['ID']['input'];
};

export type GetUserInput = {
  id: Scalars['ID']['input'];
};

export type HealthStatus = {
  __typename?: 'HealthStatus';
  ok: Scalars['Boolean']['output'];
};

export type InitiateAuthFlowRequest = {
  email: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type InitiateAuthFlowResponse = {
  __typename?: 'InitiateAuthFlowResponse';
  authMethod?: Maybe<Scalars['AuthMethodEnum']['output']>;
  expiresIn: Scalars['Float']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type ListApplicationLicensesInput = {
  assignedTo: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};

export type ListApplicationLicensesResponse = {
  __typename?: 'ListApplicationLicensesResponse';
  items?: Maybe<Array<ApplicationLicense>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListApplicationVersionsInput = {
  applicationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};

export type ListApplicationVersionsResponse = {
  __typename?: 'ListApplicationVersionsResponse';
  items?: Maybe<Array<ApplicationVersion>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListApplicationsInput = {
  licenseType?: InputMaybe<Scalars['ApplicationLicenseTypeEnum']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};

export type ListAttachmentsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  source: Scalars['AttachmentSourceTypeEnum']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

export type ListChartTemplatesInput = {
  parentObject: Scalars['String']['input'];
};

export type ListChartsInput = {
  parentId: Scalars['String']['input'];
};

export type ListChatMessageRepliesInput = {
  chatId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
};

export type ListChatMessagesInput = {
  chatId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};

export type ListEventChannelsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  object?: InputMaybe<Scalars['EventChannelObjectEnum']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['EventChannelTypeEnum']['input']>;
};

export type ListEventDefinitionsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['String']['input'];
};

export type ListEventNotificationsInput = {
  channelType: Scalars['EventChannelTypeEnum']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListEventSubscriptionsInput = {
  eventDefinitionId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ListMachineFilesInput = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

export type ListMachinesByUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type ListMachinesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
};

export type ListPlansInput = {
  trialAvailable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListPreferencesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  targetId: Scalars['String']['input'];
  targetType: Scalars['PreferenceTargetTypeEnum']['input'];
};

export type ListRolesInput = {
  baseRolesFilter?: InputMaybe<Scalars['FindRolesOptionsBaseRolesFilterEnum']['input']>;
  includeRolePermissions?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ListScratchpadAppsInput = {
  machineId: Scalars['ID']['input'];
};

export type ListScratchpadBucketsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  appId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['ScratchpadBucketScopeEnum']['input']>;
  scratchpadAppSlug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['ScratchpadBucketTypeEnum']['input']>;
};

export type ListScratchpadHistoriesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  scratchpadId: Scalars['ID']['input'];
};

export type ListScratchpadPlaylistInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  machineId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type ListScratchpadsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  machineId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['ScratchpadSortColumnTypeEnum']['input']>;
  sortDirection?: InputMaybe<Scalars['SortDirectionTypeEnum']['input']>;
};

export type ListTeamUsersInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTeamsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ListUsersInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type LogoutRequest = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  success: Scalars['Boolean']['output'];
};

export type Machine = {
  __typename?: 'Machine';
  active: Scalars['Boolean']['output'];
  clientId: Scalars['String']['output'];
  configuration: Scalars['JSON']['output'];
  connectionType: Scalars['MachineConnectionTypeEnum']['output'];
  demo?: Maybe<Scalars['Boolean']['output']>;
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use manufacturer on machine state runtime info */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use model on machine state runtime info */
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Use serialNumber on machine state runtime info */
  serialNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use softwareVersion on machine state runtime info */
  softwareVersion?: Maybe<Scalars['String']['output']>;
  state?: Maybe<MachineState>;
  teamId: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
};

export type MachineBinding = {
  __typename?: 'MachineBinding';
  context?: Maybe<Scalars['JSON']['output']>;
  expiration?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  machineId: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
  type: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type MachineBindingInput = {
  context?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  machineId?: InputMaybe<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MachineBindingResult = {
  __typename?: 'MachineBindingResult';
  bindingId: Scalars['ID']['output'];
  data: Scalars['JSON']['output'];
  machineId: Scalars['String']['output'];
};

export enum MachineConnectionType {
  CLOUD = 'cloud',
  DIRECT = 'direct'
}

export type MachineList = {
  __typename?: 'MachineList';
  items?: Maybe<Array<Machine>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MachineMaintenancePendingUpdate = {
  __typename?: 'MachineMaintenancePendingUpdate';
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type MachineMaintenancePendingUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type MachineMaintenanceSchedule = {
  __typename?: 'MachineMaintenanceSchedule';
  dayOfWeek: Scalars['MachineMaintenanceScheduleDayOfWeekEnum']['output'];
  duration: Scalars['Float']['output'];
  startHour: Scalars['Float']['output'];
};

export enum MachineMaintenanceScheduleDayOfWeek {
  FRI = 'fri',
  MON = 'mon',
  SAT = 'sat',
  SUN = 'sun',
  THU = 'thu',
  TUE = 'tue',
  WED = 'wed'
}

export type MachineMaintenanceScheduleInput = {
  dayOfWeek?: InputMaybe<Scalars['MachineMaintenanceScheduleDayOfWeekEnum']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  startHour?: InputMaybe<Scalars['Float']['input']>;
};

export type MachineMaintenanceState = {
  __typename?: 'MachineMaintenanceState';
  enabled: Scalars['Boolean']['output'];
  reboot: Scalars['Boolean']['output'];
  rebootImmediate: Scalars['Boolean']['output'];
  schedule?: Maybe<MachineMaintenanceSchedule>;
  updates?: Maybe<Array<MachineMaintenancePendingUpdate>>;
};

export type MachineMaintenanceStateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  reboot?: InputMaybe<Scalars['Boolean']['input']>;
  rebootImmediate?: InputMaybe<Scalars['Boolean']['input']>;
  schedule?: InputMaybe<MachineMaintenanceScheduleInput>;
  updates?: InputMaybe<MachineMaintenancePendingUpdateInput>;
};

export type MachineState = {
  __typename?: 'MachineState';
  additional?: Maybe<Scalars['JSON']['output']>;
  machineId: Scalars['ID']['output'];
  maintenance?: Maybe<MachineMaintenanceState>;
  online: Scalars['Boolean']['output'];
  runtimeInfo?: Maybe<Scalars['JSON']['output']>;
  transient?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MarkEventNotificationsReadInput = {
  eventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  assignApplicationLicense: Scalars['Boolean']['output'];
  authenticateWithPassword: PasswordAuthenticationResponse;
  authenticateWithPinCode: PinCodeAuthenticationResponse;
  compileScratchpad: Scalars['JSON']['output'];
  confirmForgotPassword: PasswordAuthenticationResponse;
  createAttachment?: Maybe<Attachment>;
  createChart: Chart;
  createChatMessage: ChatMessage;
  createEventChannel?: Maybe<EventChannel>;
  createEventSubscription: EventSubscription;
  createFileUploadUrl: FileUpload;
  createLinkToManagePlanSubscription: Scalars['String']['output'];
  createLinkToSubscribeToPlan: Scalars['String']['output'];
  createRole: Role;
  createScratchpad: Scratchpad;
  createScratchpadBucket: ScratchpadBucket;
  createScratchpadPlaylist: ScratchpadPlaylist;
  createScratchpadRecommendation: ScratchpadRecommendation;
  createScratchpadRecommendationFeedback: ScratchpadRecommendationFeedback;
  createTeam: Team;
  createTenant: Tenant;
  createUser: User;
  deactivateTenant: Scalars['Boolean']['output'];
  deleteAttachment: Scalars['Boolean']['output'];
  deleteRole: Scalars['Boolean']['output'];
  disableMachine: Scalars['Boolean']['output'];
  disableTeam?: Maybe<Team>;
  disableUser: Scalars['Boolean']['output'];
  enableTeam?: Maybe<Team>;
  enableUser: Scalars['Boolean']['output'];
  exportChart: Scalars['Boolean']['output'];
  forgotPassword: ForgotPasswordResponse;
  initiateAuthFlow: InitiateAuthFlowResponse;
  logout: LogoutResponse;
  markEventNotificationsRead: Scalars['Boolean']['output'];
  provisionDirectConnectMachine: DirectConnectProvisionMachineResponse;
  provisionMachine: ProvisionedMachine;
  refreshToken: RefreshTokenResponse;
  /** @deprecated deprecated in favor of provisionMachine mutation */
  registerMachine: Machine;
  /** @deprecated Register binding using registerAndSubscribeToMachineBindingResult subscription */
  registerMachineBinding: MachineBinding;
  registerUserDevice: Scalars['Boolean']['output'];
  removeApplicationLicense: Scalars['Boolean']['output'];
  removeChart: Scalars['Boolean']['output'];
  removeEventChannel: EventChannel;
  removeEventSubscription: Scalars['Boolean']['output'];
  /** @deprecated Bindings are automatically deleted when registered through registerAndSubscribeToMachineBindingResult */
  removeMachineBinding: Scalars['Boolean']['output'];
  removeScratchpad: Scratchpad;
  removeUserDevices: Scalars['Boolean']['output'];
  replaceRolePermissions: Array<RolePermission>;
  requestExport: Scalars['Boolean']['output'];
  requestPlanFeature: Scalars['Boolean']['output'];
  respondToAuthChallenge: ResponseToAuthChallengeResponse;
  restoreScratchpad: Scratchpad;
  restoreScratchpadHistory: Scalars['Boolean']['output'];
  savePreference?: Maybe<Preference>;
  signup: InitiateAuthFlowResponse;
  syncDirectConnectData: DirectConnectSyncDataResponse;
  syncFilesToMachine: Scalars['Boolean']['output'];
  updateChart: Chart;
  updateChatMessage: ChatMessage;
  updateEventChannel: EventChannel;
  updateEventDefinition: EventDefinition;
  updateMachine: Machine;
  updateMachineBindingContext: Scalars['Boolean']['output'];
  updateMachineMaintenance: MachineMaintenanceState;
  updatePlanSubscription: Scalars['String']['output'];
  updateRole: Role;
  updateScratchpad: Scratchpad;
  updateScratchpadBucket: ScratchpadBucket;
  updateScratchpadPlaylist: ScratchpadPlaylist;
  updateTeam: Team;
  updateTeamAccess: UpdateTeamAccess;
  updateTenant: Tenant;
  updateUser: User;
};


export type MutationAssignApplicationLicenseArgs = {
  input: AssignApplicationLicenseInput;
};


export type MutationAuthenticateWithPasswordArgs = {
  input: PasswordAuthenticationRequest;
};


export type MutationAuthenticateWithPinCodeArgs = {
  input: PinCodeAuthenticationRequest;
};


export type MutationCompileScratchpadArgs = {
  input: CompileScratchpadInput;
};


export type MutationConfirmForgotPasswordArgs = {
  input: ConfirmForgotPasswordRequest;
};


export type MutationCreateAttachmentArgs = {
  input: CreateAttachmentInput;
};


export type MutationCreateChartArgs = {
  input: CreateChartInput;
};


export type MutationCreateChatMessageArgs = {
  input: CreateChatMessageInput;
};


export type MutationCreateEventChannelArgs = {
  input: CreateEventChannelInput;
};


export type MutationCreateEventSubscriptionArgs = {
  input: CreateEventSubscriptionInput;
};


export type MutationCreateFileUploadUrlArgs = {
  input: CreateFileUploadInput;
};


export type MutationCreateLinkToSubscribeToPlanArgs = {
  input: SubscribeToPlanInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateScratchpadArgs = {
  input: CreateScratchpadInput;
};


export type MutationCreateScratchpadBucketArgs = {
  input: CreateScratchpadBucketInput;
};


export type MutationCreateScratchpadPlaylistArgs = {
  input: CreateScratchpadPlaylistInput;
};


export type MutationCreateScratchpadRecommendationArgs = {
  input: CreateScratchpadRecommendationRequestInput;
};


export type MutationCreateScratchpadRecommendationFeedbackArgs = {
  input: CreateScratchpadRecommendationFeedbackInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteAttachmentArgs = {
  input: DeleteAttachmentInput;
};


export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
};


export type MutationDisableMachineArgs = {
  input: DisableMachineInput;
};


export type MutationDisableTeamArgs = {
  input: DisableTeamInput;
};


export type MutationDisableUserArgs = {
  input: DisableUserInput;
};


export type MutationEnableTeamArgs = {
  input: EnableTeamInput;
};


export type MutationEnableUserArgs = {
  input: EnableUserInput;
};


export type MutationExportChartArgs = {
  input: ExportChartInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordRequest;
};


export type MutationInitiateAuthFlowArgs = {
  input: InitiateAuthFlowRequest;
};


export type MutationLogoutArgs = {
  input?: InputMaybe<LogoutRequest>;
};


export type MutationMarkEventNotificationsReadArgs = {
  input: MarkEventNotificationsReadInput;
};


export type MutationProvisionDirectConnectMachineArgs = {
  input: DirectConnectProvisionMachineInput;
};


export type MutationProvisionMachineArgs = {
  input: ProvisionMachineInput;
};


export type MutationRefreshTokenArgs = {
  input: RefreshTokenRequest;
};


export type MutationRegisterMachineArgs = {
  input: RegisterMachineInput;
};


export type MutationRegisterMachineBindingArgs = {
  input: MachineBindingInput;
};


export type MutationRegisterUserDeviceArgs = {
  input: RegisterUserDeviceInput;
};


export type MutationRemoveApplicationLicenseArgs = {
  input: RemoveApplicationLicenseInput;
};


export type MutationRemoveChartArgs = {
  input: RemoveChartInput;
};


export type MutationRemoveEventChannelArgs = {
  input: RemoveEventChannelInput;
};


export type MutationRemoveEventSubscriptionArgs = {
  input: RemoveEventSubscriptionInput;
};


export type MutationRemoveMachineBindingArgs = {
  input: MachineBindingInput;
};


export type MutationRemoveScratchpadArgs = {
  input: RemoveScratchpadInput;
};


export type MutationRemoveUserDevicesArgs = {
  input: RemoveUserDevicesInput;
};


export type MutationReplaceRolePermissionsArgs = {
  input: ReplaceRolePermissionsInput;
};


export type MutationRequestExportArgs = {
  input: ExportDataInput;
};


export type MutationRequestPlanFeatureArgs = {
  input: RequestPlanFeatureInput;
};


export type MutationRespondToAuthChallengeArgs = {
  input: RespondToAuthChallengeRequest;
};


export type MutationRestoreScratchpadArgs = {
  input: RestoreScratchpadInput;
};


export type MutationRestoreScratchpadHistoryArgs = {
  input: RestoreScratchpadHistoryInput;
};


export type MutationSavePreferenceArgs = {
  input: SavePreferenceInput;
};


export type MutationSignupArgs = {
  input: SignupRequest;
};


export type MutationSyncDirectConnectDataArgs = {
  input: DirectConnectSyncDataInput;
};


export type MutationSyncFilesToMachineArgs = {
  input: SyncFilesToMachineInput;
};


export type MutationUpdateChartArgs = {
  input: UpdateChartInput;
};


export type MutationUpdateChatMessageArgs = {
  input: UpdateChatMessageInput;
};


export type MutationUpdateEventChannelArgs = {
  input: UpdateEventChannelInput;
};


export type MutationUpdateEventDefinitionArgs = {
  input: UpdateEventDefinitionInput;
};


export type MutationUpdateMachineArgs = {
  input: UpdateMachineInput;
};


export type MutationUpdateMachineBindingContextArgs = {
  input: UpdateMachineBindingContextInput;
};


export type MutationUpdateMachineMaintenanceArgs = {
  input: UpdateMachineMaintenanceInput;
};


export type MutationUpdatePlanSubscriptionArgs = {
  input: UpdatePlanSubscriptionInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateScratchpadArgs = {
  input: UpdateScratchpadInput;
  options?: InputMaybe<UpdateScratchpadInputOptions>;
};


export type MutationUpdateScratchpadBucketArgs = {
  input: UpdateScratchpadBucketInput;
};


export type MutationUpdateScratchpadPlaylistArgs = {
  input: UpdateScratchpadPlaylistInput;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateTeamAccessArgs = {
  input: UpdateTeamAccessInput;
};


export type MutationUpdateTenantArgs = {
  input: UpdateTenantInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type PasswordAuthenticationRequest = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type PasswordAuthenticationResponse = {
  __typename?: 'PasswordAuthenticationResponse';
  challenge?: Maybe<AuthChallenge>;
  workspace?: Maybe<Workspace>;
};

export enum PermissionType {
  AI_RECOMMENDATIONS = 'ai_recommendations',
  ALL = 'all',
  CHART = 'chart',
  CHART_TEMPLATE = 'chart_template',
  CHAT = 'chat',
  CHAT_ATTACHMENT = 'chat_attachment',
  CHAT_MESSAGE = 'chat_message',
  CHAT_MESSAGE_ATTACHMENT = 'chat_message_attachment',
  EVENT_CHANNEL = 'event_channel',
  EVENT_DEFINITION = 'event_definition',
  EVENT_INTEGRATION_TEMPLATE = 'event_integration_template',
  MACHINE = 'machine',
  PLAN = 'plan',
  PLAN_SUBSCRIPTION = 'plan_subscription',
  PREFERENCE = 'preference',
  ROLE = 'role',
  ROLE_PERMISSION = 'role_permission',
  SCRATCHPAD = 'scratchpad',
  SCRATCHPAD_ATTACHMENT = 'scratchpad_attachment',
  SCRATCHPAD_BUCKET = 'scratchpad_bucket',
  SCRATCHPAD_PLAYLIST = 'scratchpad_playlist',
  SCRATCHPAD_PLAYLIST_ITEM = 'scratchpad_playlist_item',
  TEAM = 'team',
  TEAM_USER = 'team_user',
  TENANT = 'tenant',
  USER = 'user'
}

export type PinCodeAuthenticationRequest = {
  pinCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type PinCodeAuthenticationResponse = {
  __typename?: 'PinCodeAuthenticationResponse';
  expiresAt: Scalars['Date']['output'];
  sessionId: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
};

export type Plan = {
  __typename?: 'Plan';
  billableQuantity?: Maybe<Scalars['Float']['output']>;
  default: Scalars['Boolean']['output'];
  displayOrder: Scalars['Float']['output'];
  entitlements?: Maybe<Array<PlanEntitlement>>;
  id: Scalars['ID']['output'];
  licenseType: Scalars['PlanLicenseTypeEnum']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Float']['output'];
  product?: Maybe<Product>;
  replacedBy?: Maybe<Plan>;
  sellable: Scalars['Boolean']['output'];
  sku: Scalars['String']['output'];
  synchronizeQuantityBy?: Maybe<Scalars['PlanLicenseQuantitySynchronizationTypeEnum']['output']>;
};

export type PlanDetails = {
  __typename?: 'PlanDetails';
  entitlements: Array<PlanEntitlement>;
  id: Scalars['ID']['output'];
  licenses: Array<PlanLicense>;
};

export type PlanEntitlement = {
  __typename?: 'PlanEntitlement';
  key: Scalars['PlanEntitlementKeyEnum']['output'];
  value: Scalars['String']['output'];
};

export enum PlanEntitlementKey {
  AI_RECOMMENDATIONS = 'ai_recommendations',
  ATTACHMENT_MAX_FILE_UPLOAD_SIZE = 'attachment_max_file_upload_size',
  ATTACHMENT_MAX_TENANT_STORAGE_SIZE = 'attachment_max_tenant_storage_size',
  CHART_EXPORT = 'chart_export',
  CHART_FULLSCREEN = 'chart_fullscreen',
  CHART_MAX_TIMEFRAME = 'chart_max_timeframe',
  CHART_ROW_LIMIT = 'chart_row_limit',
  ENHANCED_PLAYLIST = 'enhanced_playlist',
  ENHANCED_USER_ROLES = 'enhanced_user_roles',
  EVENT_CHANNEL_WEBHOOK_SERVICE = 'event_channel_webhook_service',
  MACHINE_FILE_VERSION_MAX_AGE = 'machine_file_version_max_age',
  SCRATCHPAD_ATTACHMENT = 'scratchpad_attachment',
  SCRATCHPAD_HISTORY_MAX_AGE = 'scratchpad_history_max_age',
  TEAM_OPERATOR_ROLE = 'team_operator_role',
  USER_PASSWORD_AUTH_METHOD = 'user_password_auth_method',
  WELDING_ENHANCED_STITCH = 'welding_enhanced_stitch',
  WELDING_FINE_TUNE = 'welding_fine_tune',
  WELDING_MULTIPASS = 'welding_multipass',
  WELDING_SEAM_TRACKING = 'welding_seam_tracking'
}

export type PlanLicense = {
  __typename?: 'PlanLicense';
  assignments?: Maybe<Array<PlanLicenseAssignment>>;
  id: Scalars['ID']['output'];
  plan: Plan;
  planId: Scalars['String']['output'];
  priceId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
};

export type PlanLicenseAssignment = {
  __typename?: 'PlanLicenseAssignment';
  assignedTo: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  planLicenseId: Scalars['String']['output'];
};

export enum PlanLicenseQuantitySynchronizationType {
  ACTIVE_MACHINES = 'active_machines'
}

export enum PlanLicenseType {
  MACHINE = 'machine',
  TENANT = 'tenant'
}

export type PlanList = {
  __typename?: 'PlanList';
  items?: Maybe<Array<Plan>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Preference = {
  __typename?: 'Preference';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  targetType: Scalars['PreferenceTargetTypeEnum']['output'];
  value: Scalars['JSON']['output'];
};

export type PreferenceList = {
  __typename?: 'PreferenceList';
  items?: Maybe<Array<Preference>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum PreferenceTargetType {
  MACHINE = 'machine',
  TEAM = 'team',
  TENANT = 'tenant',
  USER = 'user'
}

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  recurringCount: Scalars['Float']['output'];
  recurringInterval: Scalars['PriceRecurringIntervalEnum']['output'];
};

export enum PriceRecurringInterval {
  DAY = 'day',
  MONTH = 'month',
  ONCE = 'once',
  WEEK = 'week',
  YEAR = 'year'
}

export type Product = {
  __typename?: 'Product';
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  prices?: Maybe<Array<Price>>;
  sku?: Maybe<Scalars['String']['output']>;
  trialPeriodDays?: Maybe<Scalars['Float']['output']>;
};

export type ProvisionMachineContextInput = {
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  provisionOffline?: InputMaybe<Scalars['Boolean']['input']>;
  registrationId?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  softwareVersion?: InputMaybe<Scalars['String']['input']>;
  threePositionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProvisionMachineInput = {
  context: ProvisionMachineContextInput;
  machine: CreateMachineInput;
};

export type ProvisionedMachine = {
  __typename?: 'ProvisionedMachine';
  claim?: Maybe<ProvisionedMachineClaim>;
  machine: Machine;
};

export type ProvisionedMachineClaim = {
  __typename?: 'ProvisionedMachineClaim';
  certificatePem: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  privateKey: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** @deprecated deprecated in favor of mutation */
  authenticateWithPassword: PasswordAuthenticationResponse;
  buildForm: BuildFormResponse;
  /** @deprecated deprecated in favor of mutation */
  confirmForgotPassword: PasswordAuthenticationResponse;
  /** @deprecated deprecated in favor of mutation */
  forgotPassword: ForgotPasswordResponse;
  getApplicationLicense: ApplicationLicense;
  getAssignedApplicationLicense?: Maybe<ApplicationLicense>;
  getAttachment: Attachment;
  getChart: Chart;
  getChartData: ChartData;
  getChartTemplate: ChartTemplate;
  getChat: Chat;
  getChatMessage: ChatMessage;
  getChatMessageDraft?: Maybe<ChatMessage>;
  getCompatibleMachinesForScratchpad: ScratchpadCompatibleMachines;
  getDirectConnectSyncData: DirectConnectGetSyncDataResponse;
  getEventChannel: EventChannel;
  getEventDefinition: EventDefinition;
  getEventNotificationUnreadCount: Scalars['Int']['output'];
  getEventSubscription: EventSubscription;
  getFeatures: Scalars['JSON']['output'];
  getLatestApplicationVersion: ApplicationVersion;
  getMachine: Machine;
  getMachineFileLink: FileLink;
  /** @deprecated Use `getPlanDetails` instead. */
  getPlan: Plan;
  getPlanDetails: PlanDetails;
  getPreference?: Maybe<Preference>;
  getRole: Role;
  getRoleByTeam: Role;
  getRolePermissionFormData: Array<RolePermissionFormField>;
  getRolePermissions: Array<RolePermission>;
  getScratchpad: Scratchpad;
  getScratchpadBucket: ScratchpadBucket;
  getScratchpadHistory: ScratchpadHistory;
  getScratchpadPlaylistActivated?: Maybe<ScratchpadPlaylist>;
  getScratchpadRecommendation: ScratchpadRecommendation;
  getTeam: Team;
  getTenant: Tenant;
  getUser: User;
  health: HealthStatus;
  /** @deprecated deprecated in favor of mutation */
  initiateAuthFlow: InitiateAuthFlowResponse;
  listApplicationLicenses: ListApplicationLicensesResponse;
  listApplicationVersions: ListApplicationVersionsResponse;
  listApplicationsByType: ApplicationList;
  listAttachments: AttachmentList;
  listChartTemplates: ChartTemplateList;
  listCharts: ChartList;
  listChatMessageReplies: ChatMessageReplyList;
  listChatMessages: ChatMessageList;
  listEventChannels: EventChannelList;
  listEventDefinitions: EventDefinitionList;
  listEventNotifications: EventNotificationsList;
  listEventSubscriptions: EventSubscriptionList;
  listMachineFiles: FileList;
  listMachines: MachineList;
  listMachinesByUser: MachineList;
  listPlans: PlanList;
  listPreferences: PreferenceList;
  listRoles: RoleList;
  listScratchpadApps: Array<ScratchpadApp>;
  listScratchpadBuckets: ScratchpadBucketList;
  listScratchpadHistories: ScratchpadHistoryList;
  listScratchpadPlaylists: ScratchpadPlaylistList;
  listScratchpads: ScratchpadList;
  listTeamUsers: TeamUserList;
  listTeams: TeamList;
  listTenantAssignments: Array<TenantAssignment>;
  listUsers: UserList;
  /** @deprecated deprecated in favor of mutation */
  logout: LogoutResponse;
  /** @deprecated deprecated in favor of mutation */
  refreshToken: RefreshTokenResponse;
  /** @deprecated deprecated in favor of mutation */
  respondToAuthChallenge: ResponseToAuthChallengeResponse;
};


export type QueryAuthenticateWithPasswordArgs = {
  input: PasswordAuthenticationRequest;
};


export type QueryBuildFormArgs = {
  input: BuildFormInput;
};


export type QueryConfirmForgotPasswordArgs = {
  input: ConfirmForgotPasswordRequest;
};


export type QueryForgotPasswordArgs = {
  input: ForgotPasswordRequest;
};


export type QueryGetApplicationLicenseArgs = {
  input: GetApplicationLicenseInput;
};


export type QueryGetAssignedApplicationLicenseArgs = {
  input: GetAssignedApplicationLicenseInput;
};


export type QueryGetAttachmentArgs = {
  input: GetAttachmentInput;
};


export type QueryGetChartArgs = {
  input: GetChartInput;
};


export type QueryGetChartDataArgs = {
  input: GetChartDataInput;
};


export type QueryGetChartTemplateArgs = {
  input: GetChartTemplateInput;
};


export type QueryGetChatArgs = {
  input: GetChatInput;
};


export type QueryGetChatMessageArgs = {
  input: GetChatMessageInput;
};


export type QueryGetChatMessageDraftArgs = {
  input: GetChatMessageDraftInput;
};


export type QueryGetCompatibleMachinesForScratchpadArgs = {
  input: GetCompatibleMachinesInput;
};


export type QueryGetDirectConnectSyncDataArgs = {
  input: DirectConnectGetSyncDataInput;
};


export type QueryGetEventChannelArgs = {
  input: GetEventChannelInput;
};


export type QueryGetEventDefinitionArgs = {
  input: GetEventDefinitionInput;
};


export type QueryGetEventSubscriptionArgs = {
  input: GetEventSubscriptionInput;
};


export type QueryGetFeaturesArgs = {
  input: GetFeaturesInput;
};


export type QueryGetLatestApplicationVersionArgs = {
  input: GetApplicationVersionInput;
};


export type QueryGetMachineArgs = {
  input: GetMachineInput;
};


export type QueryGetMachineFileLinkArgs = {
  input: GetMachineFileLinkInput;
};


export type QueryGetPlanArgs = {
  input: GetPlanInput;
};


export type QueryGetPreferenceArgs = {
  input: GetPreferenceInput;
};


export type QueryGetRoleArgs = {
  input: GetRoleInput;
};


export type QueryGetRoleByTeamArgs = {
  input: GetRoleByTeamInput;
};


export type QueryGetRolePermissionFormDataArgs = {
  input: GetRolePermissionFormDataInput;
};


export type QueryGetRolePermissionsArgs = {
  input: GetRolePermissionsInput;
};


export type QueryGetScratchpadArgs = {
  input: GetScratchpadInput;
};


export type QueryGetScratchpadBucketArgs = {
  input: GetScratchpadBucketInput;
};


export type QueryGetScratchpadHistoryArgs = {
  input: GetScratchpadHistoryInput;
};


export type QueryGetScratchpadPlaylistActivatedArgs = {
  input: GetScratchpadPlaylistActivatedInput;
};


export type QueryGetScratchpadRecommendationArgs = {
  input: GetScratchpadRecommendationInput;
};


export type QueryGetTeamArgs = {
  input: GetTeamInput;
};


export type QueryGetUserArgs = {
  input: GetUserInput;
};


export type QueryInitiateAuthFlowArgs = {
  input: InitiateAuthFlowRequest;
};


export type QueryListApplicationLicensesArgs = {
  input: ListApplicationLicensesInput;
};


export type QueryListApplicationVersionsArgs = {
  input: ListApplicationVersionsInput;
};


export type QueryListApplicationsByTypeArgs = {
  input: ListApplicationsInput;
};


export type QueryListAttachmentsArgs = {
  input: ListAttachmentsInput;
};


export type QueryListChartTemplatesArgs = {
  input: ListChartTemplatesInput;
};


export type QueryListChartsArgs = {
  input: ListChartsInput;
};


export type QueryListChatMessageRepliesArgs = {
  input: ListChatMessageRepliesInput;
};


export type QueryListChatMessagesArgs = {
  input: ListChatMessagesInput;
};


export type QueryListEventChannelsArgs = {
  input: ListEventChannelsInput;
};


export type QueryListEventDefinitionsArgs = {
  input: ListEventDefinitionsInput;
};


export type QueryListEventNotificationsArgs = {
  input: ListEventNotificationsInput;
};


export type QueryListEventSubscriptionsArgs = {
  input: ListEventSubscriptionsInput;
};


export type QueryListMachineFilesArgs = {
  input: ListMachineFilesInput;
};


export type QueryListMachinesArgs = {
  input: ListMachinesInput;
};


export type QueryListMachinesByUserArgs = {
  input: ListMachinesByUserInput;
};


export type QueryListPlansArgs = {
  input: ListPlansInput;
};


export type QueryListPreferencesArgs = {
  input: ListPreferencesInput;
};


export type QueryListRolesArgs = {
  input: ListRolesInput;
};


export type QueryListScratchpadAppsArgs = {
  input: ListScratchpadAppsInput;
};


export type QueryListScratchpadBucketsArgs = {
  input: ListScratchpadBucketsInput;
};


export type QueryListScratchpadHistoriesArgs = {
  input: ListScratchpadHistoriesInput;
};


export type QueryListScratchpadPlaylistsArgs = {
  input: ListScratchpadPlaylistInput;
};


export type QueryListScratchpadsArgs = {
  input: ListScratchpadsInput;
};


export type QueryListTeamUsersArgs = {
  input: ListTeamUsersInput;
};


export type QueryListTeamsArgs = {
  input: ListTeamsInput;
};


export type QueryListUsersArgs = {
  input: ListUsersInput;
};


export type QueryLogoutArgs = {
  input?: InputMaybe<LogoutRequest>;
};


export type QueryRefreshTokenArgs = {
  input: RefreshTokenRequest;
};


export type QueryRespondToAuthChallengeArgs = {
  input: RespondToAuthChallengeRequest;
};

export type RefreshTokenRequest = {
  refreshToken: Scalars['String']['input'];
};

export type RefreshTokenResponse = {
  __typename?: 'RefreshTokenResponse';
  credentials?: Maybe<Credentials>;
};

export type RegisterAndSubscribeToMachineBindingInput = {
  binding: MachineBindingInput;
  machineId: Scalars['String']['input'];
};

export type RegisterMachineInput = {
  machine: CreateMachineInput;
  registrationId?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterUserDeviceInput = {
  token: Scalars['String']['input'];
  type: Scalars['UserDeviceTypeEnum']['input'];
};

export type RemoveApplicationLicenseInput = {
  licenseId: Scalars['String']['input'];
};

export type RemoveChartInput = {
  id: Scalars['ID']['input'];
};

export type RemoveEventChannelInput = {
  id: Scalars['ID']['input'];
};

export type RemoveEventSubscriptionInput = {
  id: Scalars['String']['input'];
};

export type RemoveScratchpadInput = {
  id: Scalars['ID']['input'];
};

export type RemoveUserDevicesInput = {
  type?: InputMaybe<Scalars['UserDeviceTypeEnum']['input']>;
};

export type ReplaceRolePermissionsInput = {
  roleId: Scalars['ID']['input'];
  rolePermissions: Array<RolePermissionGqlInputType>;
};

export type RequestPlanFeatureInput = {
  key?: InputMaybe<Scalars['PlanEntitlementKeyEnum']['input']>;
};

export type RespondToAuthChallengeRequest = {
  answer: Scalars['String']['input'];
  challengeName: Scalars['String']['input'];
  session: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type ResponseToAuthChallengeResponse = {
  __typename?: 'ResponseToAuthChallengeResponse';
  workspaces: Array<Workspace>;
};

export type RestoreScratchpadHistoryInput = {
  scratchpadHistoryId: Scalars['ID']['input'];
  scratchpadId: Scalars['ID']['input'];
};

export type RestoreScratchpadInput = {
  id: Scalars['ID']['input'];
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  isBaseRole: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Role>;
  permissions?: Maybe<Array<RolePermission>>;
  teams?: Maybe<Array<Team>>;
  type: Scalars['TeamRoleEnum']['output'];
};

export type RoleInputType = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  type: Scalars['TeamRoleEnum']['input'];
};

export type RoleList = {
  __typename?: 'RoleList';
  items?: Maybe<Array<Role>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  appSlug?: Maybe<Scalars['String']['output']>;
  appStoreAppId?: Maybe<Scalars['String']['output']>;
  can: Scalars['Boolean']['output'];
  conditions?: Maybe<Scalars['JSON']['output']>;
  entity: Scalars['PermissionTypeEnum']['output'];
  fieldApiName?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isBaseRolePermission: Scalars['Boolean']['output'];
  policy: Scalars['String']['output'];
  roleId: Scalars['ID']['output'];
  rolePermissionTemplate: RolePermissionTemplate;
  rolePermissionTemplateId: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
  userData?: Maybe<Scalars['JSON']['output']>;
};

export type RolePermissionFormField = {
  __typename?: 'RolePermissionFormField';
  permission?: Maybe<RolePermission>;
  template: RolePermissionTemplate;
};

export type RolePermissionGqlInputType = {
  appSlug?: InputMaybe<Scalars['String']['input']>;
  appStoreAppId?: InputMaybe<Scalars['String']['input']>;
  can: Scalars['Boolean']['input'];
  conditions?: InputMaybe<Scalars['JSON']['input']>;
  entity: Scalars['PermissionTypeEnum']['input'];
  fieldApiName?: InputMaybe<Scalars['String']['input']>;
  fieldName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  policy: Scalars['String']['input'];
  roleId: Scalars['ID']['input'];
  rolePermissionTemplateId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
  userData?: InputMaybe<Scalars['JSON']['input']>;
};

export type RolePermissionTemplate = {
  __typename?: 'RolePermissionTemplate';
  active: Scalars['Boolean']['output'];
  appSlug?: Maybe<Scalars['String']['output']>;
  appStoreAppId?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Float']['output'];
  entity: Scalars['PermissionTypeEnum']['output'];
  id: Scalars['ID']['output'];
  isInternal: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  policy: Scalars['String']['output'];
  teamRole: Scalars['TeamRoleEnum']['output'];
};

export type SavePreferenceInput = {
  key: Scalars['String']['input'];
  targetId: Scalars['String']['input'];
  targetType: Scalars['PreferenceTargetTypeEnum']['input'];
  value: Scalars['JSON']['input'];
};

export type Scratchpad = {
  __typename?: 'Scratchpad';
  active: Scalars['Boolean']['output'];
  apiName?: Maybe<Scalars['String']['output']>;
  app: ScratchpadApp;
  appData?: Maybe<Scalars['JSON']['output']>;
  appId: Scalars['String']['output'];
  bucket1Id?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  license?: Maybe<ApplicationLicense>;
  loaded?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Remove so not exposed directly to UI */
  machineData?: Maybe<ScratchpadMachineData>;
  machineId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
  versionExecutedAt?: Maybe<Scalars['Date']['output']>;
};

export type ScratchpadApp = {
  __typename?: 'ScratchpadApp';
  applicationLicense?: Maybe<ApplicationLicense>;
  id: Scalars['ID']['output'];
  licenseId?: Maybe<Scalars['String']['output']>;
  machineId: Scalars['String']['output'];
  mode: Scalars['ScratchpadAppModeEnum']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export enum ScratchpadAppMode {
  DEMO = 'demo',
  PRODUCTION = 'production'
}

export type ScratchpadBucket = {
  __typename?: 'ScratchpadBucket';
  active?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated deprecated in favor of bucket scopes */
  app?: Maybe<ScratchpadApp>;
  /** @deprecated deprecated in favor of bucket scopes */
  appId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<Scalars['String']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated deprecated in favor of bucket scopes */
  reusable?: Maybe<Scalars['Boolean']['output']>;
  scope?: Maybe<Scalars['ScratchpadBucketScopeEnum']['output']>;
  scratchpadAppSlug?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<Scalars['ScratchpadBucketTypeEnum']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type ScratchpadBucketList = {
  __typename?: 'ScratchpadBucketList';
  items?: Maybe<Array<ScratchpadBucket>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum ScratchpadBucketScope {
  MACHINE = 'machine',
  TEAM = 'team',
  TENANT = 'tenant'
}

export enum ScratchpadBucketType {
  CUT_SETTINGS = 'cut_settings',
  MULTIPASS_SCHEDULE = 'multipass_schedule',
  WELD_SETTINGS = 'weld_settings'
}

export type ScratchpadCompatibleMachines = {
  __typename?: 'ScratchpadCompatibleMachines';
  machines: Array<Machine>;
};

export type ScratchpadHistory = {
  __typename?: 'ScratchpadHistory';
  active: Scalars['Boolean']['output'];
  apiName?: Maybe<Scalars['String']['output']>;
  app: ScratchpadApp;
  appData?: Maybe<Scalars['JSON']['output']>;
  appId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  machineId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  scratchpadCreatedAt: Scalars['Date']['output'];
  scratchpadId: Scalars['String']['output'];
  scratchpadUpdatedAt: Scalars['Date']['output'];
  tenantId: Scalars['String']['output'];
  totalExecutionCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  versionExecutedAt?: Maybe<Scalars['Date']['output']>;
  versionExecutionCount?: Maybe<Scalars['Int']['output']>;
};

export type ScratchpadHistoryList = {
  __typename?: 'ScratchpadHistoryList';
  items?: Maybe<Array<ScratchpadHistory>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ScratchpadList = {
  __typename?: 'ScratchpadList';
  items?: Maybe<Array<Scratchpad>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ScratchpadMachineData = {
  __typename?: 'ScratchpadMachineData';
  data?: Maybe<Scalars['JSON']['output']>;
  executedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  totalExecutionCount?: Maybe<Scalars['Int']['output']>;
  versionExecutionCount?: Maybe<Scalars['Int']['output']>;
};

export type ScratchpadPlaylist = {
  __typename?: 'ScratchpadPlaylist';
  activated: Scalars['Boolean']['output'];
  activeIndex: Scalars['Int']['output'];
  canRestore: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items?: Maybe<Array<ScratchpadPlaylistItem>>;
  machineId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nextIndex: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ScratchpadPlaylistItem = {
  __typename?: 'ScratchpadPlaylistItem';
  autoPlayToNext?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  scratchpadId: Scalars['String']['output'];
};

export type ScratchpadPlaylistItemInput = {
  autoPlayToNext?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  scratchpadId?: InputMaybe<Scalars['String']['input']>;
};

export type ScratchpadPlaylistList = {
  __typename?: 'ScratchpadPlaylistList';
  items?: Maybe<Array<ScratchpadPlaylist>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ScratchpadRecommendation = {
  __typename?: 'ScratchpadRecommendation';
  appSlug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputs: Scalars['JSON']['output'];
  outputs: Scalars['JSON']['output'];
  type: Scalars['ScratchpadRecommendationRequestTypeEnum']['output'];
};

export type ScratchpadRecommendationFeedback = {
  __typename?: 'ScratchpadRecommendationFeedback';
  comments?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rating: Scalars['Int']['output'];
  scratchpadRecommendationId: Scalars['String']['output'];
};

export enum ScratchpadRecommendationRequestType {
  SETTINGS = 'settings'
}

export enum ScratchpadSortColumnType {
  NAME = 'name'
}

export type SignupRequest = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  orgName: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export enum SortDirectionType {
  ASC = 'asc',
  DESC = 'desc'
}

export type SubscribeToChatMessagesInput = {
  chatId: Scalars['String']['input'];
};

export type SubscribeToFilesInput = {
  parentId: Scalars['ID']['input'];
};

export type SubscribeToMachineBindingResultInput = {
  bindingId: Scalars['ID']['input'];
  machineId: Scalars['String']['input'];
};

export type SubscribeToMachineStateInput = {
  teamId: Scalars['ID']['input'];
};

export type SubscribeToPlanInput = {
  items?: InputMaybe<Array<SubscribeToPlanLineItemInput>>;
  priceId?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribeToPlanLineItemInput = {
  assignedToIds?: InputMaybe<Array<Scalars['String']['input']>>;
  priceId: Scalars['String']['input'];
};

export type SubscribeToScratchpadPlaylistActivatedInput = {
  machineId: Scalars['ID']['input'];
};

export type SubscribeToSingleMachineStateInput = {
  machineId: Scalars['ID']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  registerAndSubscribeToMachineBindingResult: MachineBindingResult;
  subscribeToChatMessages: ChatMessage;
  subscribeToEventNotificationUnreadCount: Scalars['Int']['output'];
  subscribeToFeatures: Scalars['JSON']['output'];
  subscribeToFiles: File;
  /** @deprecated Subscribe to binding using registerAndSubscribeToMachineBindingResult subscription */
  subscribeToMachineBindingResult: MachineBindingResult;
  subscribeToMachineState: Array<MachineState>;
  subscribeToPlanDetails?: Maybe<PlanDetails>;
  subscribeToScratchpadPlaylistActivated: ScratchpadPlaylist;
  subscribeToSingleMachineState: MachineState;
  subscribeToTenant: Tenant;
  subscribeToUserPermissions: Scalars['JSON']['output'];
};


export type SubscriptionRegisterAndSubscribeToMachineBindingResultArgs = {
  input: RegisterAndSubscribeToMachineBindingInput;
};


export type SubscriptionSubscribeToChatMessagesArgs = {
  input: SubscribeToChatMessagesInput;
};


export type SubscriptionSubscribeToFilesArgs = {
  input: SubscribeToFilesInput;
};


export type SubscriptionSubscribeToMachineBindingResultArgs = {
  input: SubscribeToMachineBindingResultInput;
};


export type SubscriptionSubscribeToMachineStateArgs = {
  input: SubscribeToMachineStateInput;
};


export type SubscriptionSubscribeToScratchpadPlaylistActivatedArgs = {
  input: SubscribeToScratchpadPlaylistActivatedInput;
};


export type SubscriptionSubscribeToSingleMachineStateArgs = {
  input: SubscribeToSingleMachineStateInput;
};

export type SyncFileToMachineActionInput = {
  action: Scalars['String']['input'];
  path: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type SyncFilesToMachineInput = {
  actions: Array<SyncFileToMachineActionInput>;
  id: Scalars['ID']['input'];
};

export type Team = {
  __typename?: 'Team';
  active: Scalars['Boolean']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  chatId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  role?: Maybe<Scalars['TeamRoleEnum']['output']>;
  roleId?: Maybe<Scalars['ID']['output']>;
};

export type TeamAccessCreateInput = {
  customRoleId?: InputMaybe<Scalars['ID']['input']>;
  role: Scalars['TeamRoleEnum']['input'];
  user: CreateUserInput;
};

export type TeamAccessGrantInput = {
  customRoleId?: InputMaybe<Scalars['ID']['input']>;
  role: Scalars['TeamRoleEnum']['input'];
  userId: Scalars['String']['input'];
};

export type TeamList = {
  __typename?: 'TeamList';
  items?: Maybe<Array<Team>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum TeamRole {
  EDITOR = 'editor',
  MANAGER = 'manager',
  OPERATOR = 'operator',
  VIEWER = 'viewer'
}

export type TeamUser = {
  __typename?: 'TeamUser';
  customRole?: Maybe<Role>;
  role: Scalars['TeamRoleEnum']['output'];
  roleId: Scalars['ID']['output'];
  user: User;
};

export type TeamUserList = {
  __typename?: 'TeamUserList';
  items?: Maybe<Array<TeamUser>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  planId: Scalars['String']['output'];
  planSubscriptionId?: Maybe<Scalars['String']['output']>;
};

export type TenantAssignment = {
  __typename?: 'TenantAssignment';
  tenant: Tenant;
  user: User;
};

export type UpdateChartInput = {
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  fields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateChatMessageInput = {
  chatId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  status?: InputMaybe<Scalars['ChatStatusEnum']['input']>;
};

export type UpdateEventChannelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  builtin?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  supportedObjects?: InputMaybe<Array<Scalars['EventChannelObjectEnum']['input']>>;
  type?: InputMaybe<Scalars['EventChannelTypeEnum']['input']>;
};

export type UpdateEventDefinitionInput = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMachineBindingContextInput = {
  bindingId: Scalars['ID']['input'];
  context: Scalars['JSON']['input'];
  machineId: Scalars['String']['input'];
};

export type UpdateMachineInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  connectionType?: InputMaybe<Scalars['MachineConnectionTypeEnum']['input']>;
  demo?: InputMaybe<Scalars['Boolean']['input']>;
  firmwareVersion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  softwareVersion?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMachineMaintenanceInput = {
  machineId: Scalars['ID']['input'];
  reboot?: InputMaybe<Scalars['Boolean']['input']>;
  rebootImmediate?: InputMaybe<Scalars['Boolean']['input']>;
  schedule?: InputMaybe<UpdateMachineMaintenanceScheduleInput>;
};

export type UpdateMachineMaintenanceScheduleInput = {
  dayOfWeek: Scalars['MachineMaintenanceScheduleDayOfWeekEnum']['input'];
  duration: Scalars['Float']['input'];
  startHour: Scalars['Float']['input'];
};

export type UpdatePlanSubscriptionInput = {
  items: Array<UpdatePlanSubscriptionLineItemInput>;
};

export type UpdatePlanSubscriptionLineItemInput = {
  assignedToIds?: InputMaybe<Array<Scalars['String']['input']>>;
  planId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type UpdateRoleInput = {
  role: RoleInputType;
  teamIds: Array<Scalars['ID']['input']>;
};

export type UpdateScratchpadBucketInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  reusable?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<Scalars['ScratchpadBucketScopeEnum']['input']>;
  scratchpadAppSlug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['ScratchpadBucketTypeEnum']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateScratchpadInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  appData?: InputMaybe<Scalars['JSON']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
  bucket1Id?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  executedAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  loaded?: InputMaybe<Scalars['Boolean']['input']>;
  machineId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  version: Scalars['Int']['input'];
};

export type UpdateScratchpadInputOptions = {
  forceSave?: Scalars['Boolean']['input'];
  isDelta?: Scalars['Boolean']['input'];
};

export type UpdateScratchpadPlaylistInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  canRestore?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<ScratchpadPlaylistItemInput>>;
  machineId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamAccess = {
  __typename?: 'UpdateTeamAccess';
  granted: Array<User>;
  revoked: Array<User>;
};

export type UpdateTeamAccessInput = {
  create?: Array<TeamAccessCreateInput>;
  grant?: Array<TeamAccessGrantInput>;
  id: Scalars['ID']['input'];
  revoke?: Array<Scalars['String']['input']>;
};

export type UpdateTeamInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['TeamRoleEnum']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTenantInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  authMethod?: InputMaybe<Scalars['AuthMethodEnum']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  avatarAttachment?: InputMaybe<EntityRelationshipInput>;
  billingManager?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinCode?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  activityAt?: Maybe<Scalars['Date']['output']>;
  admin: Scalars['Boolean']['output'];
  authMethod?: Maybe<Scalars['AuthMethodEnum']['output']>;
  /** @deprecated deprecated in favor of avatarAttachment */
  avatar?: Maybe<Scalars['String']['output']>;
  avatarAttachment?: Maybe<Attachment>;
  billingManager: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intercomUserHash?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['JSON']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  unreadNotifications?: Maybe<Scalars['Int']['output']>;
  username: Scalars['String']['output'];
};

export enum UserDeviceType {
  ANDROID = 'android',
  IOS = 'ios'
}

export type UserList = {
  __typename?: 'UserList';
  items?: Maybe<Array<User>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Workspace = {
  __typename?: 'Workspace';
  credentials: Credentials;
  tenant: Tenant;
  url: Scalars['String']['output'];
  user: User;
};

export type ApplicationLicenseFormPartsFragment = { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } };

export type ApplicationVersionPartsFragment = { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } };

export type ApplicationVersionWithApplicationPartsFragment = { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, application?: { __typename?: 'Application', id: string, name: string, appStoreAppId: string, licenseType: any, maxLicenseCount: number, usedLicenseCount?: number | null } | null, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } };

export type ApplicationLicensePartsFragment = { __typename?: 'ApplicationLicense', id: string, assignedTo: string, applicationVersionId: string, licenseFormValues: any, applicationVersion: { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } } };

export type ApplicationLicensePartsWithApplicationVersionPartsFragment = { __typename?: 'ApplicationLicense', id: string, assignedTo: string, applicationVersionId: string, licenseFormValues: any, applicationVersion: { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, application?: { __typename?: 'Application', id: string, name: string, appStoreAppId: string, licenseType: any, maxLicenseCount: number, usedLicenseCount?: number | null } | null, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } } };

export type ApplicationPartsFragment = { __typename?: 'Application', id: string, name: string, appStoreAppId: string, licenseType: any, maxLicenseCount: number, usedLicenseCount?: number | null };

export type GetApplicationLicenseQueryVariables = Exact<{
  input: GetApplicationLicenseInput;
}>;


export type GetApplicationLicenseQuery = { __typename?: 'Query', getApplicationLicense: { __typename?: 'ApplicationLicense', id: string, assignedTo: string, applicationVersionId: string, licenseFormValues: any, applicationVersion: { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } } } };

export type ListApplicationLicenseQueryVariables = Exact<{
  input: ListApplicationLicensesInput;
}>;


export type ListApplicationLicenseQuery = { __typename?: 'Query', listApplicationLicenses: { __typename?: 'ListApplicationLicensesResponse', total?: number | null, items?: Array<{ __typename?: 'ApplicationLicense', id: string, assignedTo: string, applicationVersionId: string, licenseFormValues: any, applicationVersion: { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, application?: { __typename?: 'Application', id: string, name: string, appStoreAppId: string, licenseType: any, maxLicenseCount: number, usedLicenseCount?: number | null } | null, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } } }> | null } };

export type ListApplicationByTypeQueryVariables = Exact<{
  input: ListApplicationsInput;
}>;


export type ListApplicationByTypeQuery = { __typename?: 'Query', listApplicationsByType: { __typename?: 'ApplicationList', total?: number | null, items?: Array<{ __typename?: 'Application', id: string, name: string, appStoreAppId: string, licenseType: any, maxLicenseCount: number, usedLicenseCount?: number | null }> | null } };

export type ListApplicationVersionsQueryVariables = Exact<{
  input: ListApplicationVersionsInput;
}>;


export type ListApplicationVersionsQuery = { __typename?: 'Query', listApplicationVersions: { __typename?: 'ListApplicationVersionsResponse', total?: number | null, items?: Array<{ __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, application?: { __typename?: 'Application', id: string, name: string, appStoreAppId: string, licenseType: any, maxLicenseCount: number, usedLicenseCount?: number | null } | null, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } }> | null } };

export type GetLatestApplicationVersionQueryVariables = Exact<{
  input: GetApplicationVersionInput;
}>;


export type GetLatestApplicationVersionQuery = { __typename?: 'Query', getLatestApplicationVersion: { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, application?: { __typename?: 'Application', id: string, name: string, appStoreAppId: string, licenseType: any, maxLicenseCount: number, usedLicenseCount?: number | null } | null, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } } };

export type GetAssignedApplicationLicenseQueryVariables = Exact<{
  input: GetAssignedApplicationLicenseInput;
}>;


export type GetAssignedApplicationLicenseQuery = { __typename?: 'Query', getAssignedApplicationLicense?: { __typename?: 'ApplicationLicense', id: string, assignedTo: string, applicationVersionId: string, licenseFormValues: any, applicationVersion: { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, application?: { __typename?: 'Application', id: string, name: string, appStoreAppId: string, licenseType: any, maxLicenseCount: number, usedLicenseCount?: number | null } | null, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } } } | null };

export type AssignApplicationLicenseMutationVariables = Exact<{
  input: AssignApplicationLicenseInput;
}>;


export type AssignApplicationLicenseMutation = { __typename?: 'Mutation', assignApplicationLicense: boolean };

export type AttachmentPartsFragment = { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null };

export type AttachmentSourcePartsFragment = { __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string };

export type GetAttachmentQueryVariables = Exact<{
  input: GetAttachmentInput;
}>;


export type GetAttachmentQuery = { __typename?: 'Query', getAttachment: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } };

export type CreateAttachmentMutationVariables = Exact<{
  input: CreateAttachmentInput;
}>;


export type CreateAttachmentMutation = { __typename?: 'Mutation', createAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null };

export type DeleteAttachmentMutationVariables = Exact<{
  input: DeleteAttachmentInput;
}>;


export type DeleteAttachmentMutation = { __typename?: 'Mutation', deleteAttachment: boolean };

export type ListAttachmentsQueryVariables = Exact<{
  input: ListAttachmentsInput;
}>;


export type ListAttachmentsQuery = { __typename?: 'Query', listAttachments: { __typename?: 'AttachmentList', total?: number | null, items?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null } };

export type CredentialsPartsFragment = { __typename?: 'Credentials', accessToken: string, expiresIn: number, idToken: string, refreshToken: string };

export type AuthChallengePartsFragment = { __typename?: 'AuthChallenge', username: string, challengeName: string, session: string };

export type WorkspacePartsFragment = { __typename?: 'Workspace', credentials: { __typename?: 'Credentials', accessToken: string, expiresIn: number, idToken: string, refreshToken: string }, user: { __typename?: 'User', id: string, admin: boolean, username: string }, tenant: { __typename?: 'Tenant', id: string, name?: string | null, planId: string, active: boolean } };

export type SignupMutationVariables = Exact<{
  input: SignupRequest;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup: { __typename?: 'InitiateAuthFlowResponse', expiresIn: number, authMethod?: any | null, username?: string | null } };

export type InitiateAuthFlowMutationVariables = Exact<{
  input: InitiateAuthFlowRequest;
}>;


export type InitiateAuthFlowMutation = { __typename?: 'Mutation', initiateAuthFlow: { __typename?: 'InitiateAuthFlowResponse', expiresIn: number, authMethod?: any | null, username?: string | null } };

export type RespondToAuthChallengeMutationVariables = Exact<{
  input: RespondToAuthChallengeRequest;
}>;


export type RespondToAuthChallengeMutation = { __typename?: 'Mutation', respondToAuthChallenge: { __typename?: 'ResponseToAuthChallengeResponse', workspaces: Array<{ __typename?: 'Workspace', credentials: { __typename?: 'Credentials', accessToken: string, expiresIn: number, idToken: string, refreshToken: string }, user: { __typename?: 'User', id: string, admin: boolean, username: string }, tenant: { __typename?: 'Tenant', id: string, name?: string | null, planId: string, active: boolean } }> } };

export type RefreshTokenQueryVariables = Exact<{
  input: RefreshTokenRequest;
}>;


export type RefreshTokenQuery = { __typename?: 'Query', refreshToken: { __typename?: 'RefreshTokenResponse', credentials?: { __typename?: 'Credentials', accessToken: string, expiresIn: number, idToken: string, refreshToken: string } | null } };

export type LogoutMutationVariables = Exact<{
  input?: InputMaybe<LogoutRequest>;
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutResponse', success: boolean } };

export type AuthenticateWithPasswordMutationVariables = Exact<{
  input: PasswordAuthenticationRequest;
}>;


export type AuthenticateWithPasswordMutation = { __typename?: 'Mutation', authenticateWithPassword: { __typename?: 'PasswordAuthenticationResponse', workspace?: { __typename?: 'Workspace', credentials: { __typename?: 'Credentials', accessToken: string, expiresIn: number, idToken: string, refreshToken: string }, user: { __typename?: 'User', id: string, admin: boolean, username: string }, tenant: { __typename?: 'Tenant', id: string, name?: string | null, planId: string, active: boolean } } | null, challenge?: { __typename?: 'AuthChallenge', username: string, challengeName: string, session: string } | null } };

export type ForgotPasswordMutationVariables = Exact<{
  input: ForgotPasswordRequest;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ForgotPasswordResponse', username: string } };

export type ConfirmForgotPasswordMutationVariables = Exact<{
  input: ConfirmForgotPasswordRequest;
}>;


export type ConfirmForgotPasswordMutation = { __typename?: 'Mutation', confirmForgotPassword: { __typename?: 'PasswordAuthenticationResponse', workspace?: { __typename?: 'Workspace', credentials: { __typename?: 'Credentials', accessToken: string, expiresIn: number, idToken: string, refreshToken: string }, user: { __typename?: 'User', id: string, admin: boolean, username: string }, tenant: { __typename?: 'Tenant', id: string, name?: string | null, planId: string, active: boolean } } | null } };

export type ChartTemplatePartsFragment = { __typename?: 'ChartTemplate', id: string, name: string, description: string, image: string, displayOrder: string, parentObject: string, form: { __typename?: 'Form', id: string, schema: any, uischema: any } };

export type ChartPartsFragment = { __typename?: 'Chart', displayOrder: number, fields: any, id: string, parentId: string, chartType: string, templateId: string, title: string };

export type ChartDataResultPartsFragment = { __typename?: 'ChartDataResult', sourceId: string, interval: string, label: string, value: number, groupBy?: string | null };

export type ChartDataPartsFragment = { __typename?: 'ChartData', id: string, timezone: string, results: Array<{ __typename?: 'ChartDataResult', sourceId: string, interval: string, label: string, value: number, groupBy?: string | null }>, options: { __typename?: 'ChartOptions', chartType: any, title: string, yAxisLabel?: string | null } };

export type ListChartTemplatesQueryVariables = Exact<{
  input: ListChartTemplatesInput;
}>;


export type ListChartTemplatesQuery = { __typename?: 'Query', listChartTemplates: { __typename?: 'ChartTemplateList', total: number, items: Array<{ __typename?: 'ChartTemplate', id: string, name: string, description: string, image: string, displayOrder: string, parentObject: string, form: { __typename?: 'Form', id: string, schema: any, uischema: any } }> } };

export type GetChartTemplateQueryVariables = Exact<{
  input: GetChartTemplateInput;
}>;


export type GetChartTemplateQuery = { __typename?: 'Query', getChartTemplate: { __typename?: 'ChartTemplate', id: string, name: string, description: string, image: string, displayOrder: string, parentObject: string, form: { __typename?: 'Form', id: string, schema: any, uischema: any } } };

export type GetChartQueryVariables = Exact<{
  input: GetChartInput;
}>;


export type GetChartQuery = { __typename?: 'Query', getChart: { __typename?: 'Chart', displayOrder: number, fields: any, id: string, parentId: string, chartType: string, templateId: string, title: string, template?: { __typename?: 'ChartTemplate', id: string, name: string, description: string, image: string, displayOrder: string, parentObject: string, form: { __typename?: 'Form', id: string, schema: any, uischema: any } } | null } };

export type GetChartDataQueryVariables = Exact<{
  input: GetChartDataInput;
}>;


export type GetChartDataQuery = { __typename?: 'Query', getChartData: { __typename?: 'ChartData', id: string, timezone: string, results: Array<{ __typename?: 'ChartDataResult', sourceId: string, interval: string, label: string, value: number, groupBy?: string | null }>, options: { __typename?: 'ChartOptions', chartType: any, title: string, yAxisLabel?: string | null } } };

export type ListChartsQueryVariables = Exact<{
  input: ListChartsInput;
}>;


export type ListChartsQuery = { __typename?: 'Query', listCharts: { __typename?: 'ChartList', total?: number | null, items?: Array<{ __typename?: 'Chart', displayOrder: number, fields: any, id: string, parentId: string, chartType: string, templateId: string, title: string }> | null } };

export type ExportChartMutationVariables = Exact<{
  input: ExportChartInput;
}>;


export type ExportChartMutation = { __typename?: 'Mutation', exportChart: boolean };

export type CreateChartMutationVariables = Exact<{
  input: CreateChartInput;
}>;


export type CreateChartMutation = { __typename?: 'Mutation', createChart: { __typename?: 'Chart', displayOrder: number, fields: any, id: string, parentId: string, chartType: string, templateId: string, title: string } };

export type UpdateChartMutationVariables = Exact<{
  input: UpdateChartInput;
}>;


export type UpdateChartMutation = { __typename?: 'Mutation', updateChart: { __typename?: 'Chart', displayOrder: number, fields: any, id: string, parentId: string, chartType: string, templateId: string, title: string } };

export type RemoveChartMutationVariables = Exact<{
  input: RemoveChartInput;
}>;


export type RemoveChartMutation = { __typename?: 'Mutation', removeChart: boolean };

export type ChatMessagePartsFragment = { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, replies?: Array<{ __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null }> | null, draft?: { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null } | null, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null };

export type AuthorPartsFragment = { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null };

export type ChatMessageFieldsFragment = { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null };

export type GetChatMessageQueryVariables = Exact<{
  input: GetChatMessageInput;
}>;


export type GetChatMessageQuery = { __typename?: 'Query', getChatMessage: { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, replies?: Array<{ __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null }> | null, draft?: { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null } | null, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null } };

export type GetChatMessageDraftQueryVariables = Exact<{
  input: GetChatMessageDraftInput;
}>;


export type GetChatMessageDraftQuery = { __typename?: 'Query', getChatMessageDraft?: { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, replies?: Array<{ __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null }> | null, draft?: { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null } | null, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null } | null };

export type GetChatQueryVariables = Exact<{
  input: GetChatInput;
}>;


export type GetChatQuery = { __typename?: 'Query', getChat: { __typename?: 'Chat', id: string, name: string, type: any, createdBy: string } };

export type ListChatMessagesQueryVariables = Exact<{
  input: ListChatMessagesInput;
}>;


export type ListChatMessagesQuery = { __typename?: 'Query', listChatMessages: { __typename?: 'ChatMessageList', nextCursor?: string | null, prevCursor?: string | null, items: Array<{ __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, replies?: Array<{ __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null }> | null, draft?: { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null } | null, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null }> } };

export type CreateChatMessageMutationVariables = Exact<{
  input: CreateChatMessageInput;
}>;


export type CreateChatMessageMutation = { __typename?: 'Mutation', createChatMessage: { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, replies?: Array<{ __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null }> | null, draft?: { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null } | null, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null } };

export type UpdateChatMessageMutationVariables = Exact<{
  input: UpdateChatMessageInput;
}>;


export type UpdateChatMessageMutation = { __typename?: 'Mutation', updateChatMessage: { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, replies?: Array<{ __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null }> | null, draft?: { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null } | null, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null } };

export type SubscribeToChatMessagesSubscriptionVariables = Exact<{
  input: SubscribeToChatMessagesInput;
}>;


export type SubscribeToChatMessagesSubscription = { __typename?: 'Subscription', subscribeToChatMessages: { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, replies?: Array<{ __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null }> | null, draft?: { __typename?: 'ChatMessage', chatId: string, createdAt: any, id: string, message?: string | null, source: any, sourceId: string, status?: any | null, threadId?: string | null, totalReplies?: number | null, editedAt?: any | null, publishedAt?: any | null, updatedAt: any, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null } | null, author: { __typename?: 'Author', id: string, name: string, url?: string | null, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null }> | null } };

export type RequestExportMutationVariables = Exact<{
  input: ExportDataInput;
}>;


export type RequestExportMutation = { __typename?: 'Mutation', requestExport: boolean };

export type DirectConnectSyncDataTenantPartsFragment = { __typename?: 'DirectConnectSyncDataTenant', id: string, name?: string | null };

export type DirectConnectSyncDataTeamPartsFragment = { __typename?: 'DirectConnectSyncDataTeam', id: string, name: string };

export type DirectConnectSyncDataMachinePartsFragment = { __typename?: 'DirectConnectSyncDataMachine', id: string, name: string, configuration?: any | null, maintenanceState?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null } | null };

export type DirectConnectSyncDataPlanPartsFragment = { __typename?: 'DirectConnectSyncDataPlan', id: string, name: string, sku: string };

export type DirectConnectSyncDataCurrentUserPartsFragment = { __typename?: 'DirectConnectSyncDataCurrentUser', id: string };

export type DirectConnectSyncDataTeamUserPartsFragment = { __typename?: 'DirectConnectSyncDataTeamUser', id: string, username: string, firstName?: string | null, lastName?: string | null, email: string, active: boolean, admin: boolean, billingManager: boolean, teamRole: any, permissions: any, features: any, pinCode?: string | null };

export type DirectConnectSyncDataScratchpadApplicationPartsFragment = { __typename?: 'DirectConnectSyncDataScratchpadApplication', scratchpadAppId: string, scratchpadAppName: string, scratchpadAppSlug: string, scratchpadCompilerSchema?: any | null, scratchpadMode: any, scratchpadProgram?: string | null, license: { __typename?: 'ApplicationLicense', id: string, assignedTo: string, applicationVersionId: string, licenseFormValues: any, applicationVersion: { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, application?: { __typename?: 'Application', id: string, name: string, appStoreAppId: string, licenseType: any, maxLicenseCount: number, usedLicenseCount?: number | null } | null, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } } } };

export type DirectConnectSyncDataEntitlementPartsFragment = { __typename?: 'DirectConnectSyncDataEntitlement', key: any, value: string };

export type DirectConnectSyncDataPreferencePartsFragment = { __typename?: 'DirectConnectSyncDataPreference', id: string, key: string, value: any, targetType: any, targetId: string };

export type DirectConnectGetSyncDataResponsePartsFragment = { __typename?: 'DirectConnectGetSyncDataResponse', tenant: { __typename?: 'DirectConnectSyncDataTenant', id: string, name?: string | null }, team: { __typename?: 'DirectConnectSyncDataTeam', id: string, name: string }, machine: { __typename?: 'DirectConnectSyncDataMachine', id: string, name: string, configuration?: any | null, maintenanceState?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null } | null }, plan: { __typename?: 'DirectConnectSyncDataPlan', id: string, name: string, sku: string }, plans: Array<{ __typename?: 'DirectConnectSyncDataPlan', id: string, name: string, sku: string }>, currentUser: { __typename?: 'DirectConnectSyncDataCurrentUser', id: string }, teamUsers: Array<{ __typename?: 'DirectConnectSyncDataTeamUser', id: string, username: string, firstName?: string | null, lastName?: string | null, email: string, active: boolean, admin: boolean, billingManager: boolean, teamRole: any, permissions: any, features: any, pinCode?: string | null }>, applications: Array<{ __typename?: 'DirectConnectSyncDataScratchpadApplication', scratchpadAppId: string, scratchpadAppName: string, scratchpadAppSlug: string, scratchpadCompilerSchema?: any | null, scratchpadMode: any, scratchpadProgram?: string | null, license: { __typename?: 'ApplicationLicense', id: string, assignedTo: string, applicationVersionId: string, licenseFormValues: any, applicationVersion: { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, application?: { __typename?: 'Application', id: string, name: string, appStoreAppId: string, licenseType: any, maxLicenseCount: number, usedLicenseCount?: number | null } | null, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } } } }>, entitlements: Array<{ __typename?: 'DirectConnectSyncDataEntitlement', key: any, value: string }>, preferences: Array<{ __typename?: 'DirectConnectSyncDataPreference', id: string, key: string, value: any, targetType: any, targetId: string }> };

export type DirectConnectProvisionMachineResponsePartsFragment = { __typename?: 'DirectConnectProvisionMachineResponse', ok: boolean };

export type DirectConnectSyncDataResponsePartsFragment = { __typename?: 'DirectConnectSyncDataResponse', ok: boolean };

export type GetDirectConnectSyncDataQueryVariables = Exact<{
  input: DirectConnectGetSyncDataInput;
}>;


export type GetDirectConnectSyncDataQuery = { __typename?: 'Query', getDirectConnectSyncData: { __typename?: 'DirectConnectGetSyncDataResponse', tenant: { __typename?: 'DirectConnectSyncDataTenant', id: string, name?: string | null }, team: { __typename?: 'DirectConnectSyncDataTeam', id: string, name: string }, machine: { __typename?: 'DirectConnectSyncDataMachine', id: string, name: string, configuration?: any | null, maintenanceState?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null } | null }, plan: { __typename?: 'DirectConnectSyncDataPlan', id: string, name: string, sku: string }, plans: Array<{ __typename?: 'DirectConnectSyncDataPlan', id: string, name: string, sku: string }>, currentUser: { __typename?: 'DirectConnectSyncDataCurrentUser', id: string }, teamUsers: Array<{ __typename?: 'DirectConnectSyncDataTeamUser', id: string, username: string, firstName?: string | null, lastName?: string | null, email: string, active: boolean, admin: boolean, billingManager: boolean, teamRole: any, permissions: any, features: any, pinCode?: string | null }>, applications: Array<{ __typename?: 'DirectConnectSyncDataScratchpadApplication', scratchpadAppId: string, scratchpadAppName: string, scratchpadAppSlug: string, scratchpadCompilerSchema?: any | null, scratchpadMode: any, scratchpadProgram?: string | null, license: { __typename?: 'ApplicationLicense', id: string, assignedTo: string, applicationVersionId: string, licenseFormValues: any, applicationVersion: { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, application?: { __typename?: 'Application', id: string, name: string, appStoreAppId: string, licenseType: any, maxLicenseCount: number, usedLicenseCount?: number | null } | null, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } } } }>, entitlements: Array<{ __typename?: 'DirectConnectSyncDataEntitlement', key: any, value: string }>, preferences: Array<{ __typename?: 'DirectConnectSyncDataPreference', id: string, key: string, value: any, targetType: any, targetId: string }> } };

export type ProvisionDirectConnectMachineMutationVariables = Exact<{
  input: DirectConnectProvisionMachineInput;
}>;


export type ProvisionDirectConnectMachineMutation = { __typename?: 'Mutation', provisionDirectConnectMachine: { __typename?: 'DirectConnectProvisionMachineResponse', ok: boolean } };

export type SyncDirectConnectDataMutationVariables = Exact<{
  input: DirectConnectSyncDataInput;
}>;


export type SyncDirectConnectDataMutation = { __typename?: 'Mutation', syncDirectConnectData: { __typename?: 'DirectConnectSyncDataResponse', ok: boolean } };

export type AuthenticateWithPinCodeMutationVariables = Exact<{
  input: PinCodeAuthenticationRequest;
}>;


export type AuthenticateWithPinCodeMutation = { __typename?: 'Mutation', authenticateWithPinCode: { __typename?: 'PinCodeAuthenticationResponse', expiresAt: any, sessionId: string, userId: string } };

export type EventNotificationPartsFragment = { __typename?: 'EventNotification', body: string, channelType: any, eventId: string, id: string, read: boolean, sentAt: any, source: any, sourceId: string, title: string, url?: string | null, userId?: string | null };

export type GetEventNotificationUnreadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventNotificationUnreadCountQuery = { __typename?: 'Query', getEventNotificationUnreadCount: number };

export type ListEventNotificationsQueryVariables = Exact<{
  input: ListEventNotificationsInput;
}>;


export type ListEventNotificationsQuery = { __typename?: 'Query', listEventNotifications: { __typename?: 'EventNotificationsList', total?: number | null, items?: Array<{ __typename?: 'EventNotification', body: string, channelType: any, eventId: string, id: string, read: boolean, sentAt: any, source: any, sourceId: string, title: string, url?: string | null, userId?: string | null }> | null } };

export type MarkEventNotificationsReadMutationVariables = Exact<{
  input: MarkEventNotificationsReadInput;
}>;


export type MarkEventNotificationsReadMutation = { __typename?: 'Mutation', markEventNotificationsRead: boolean };

export type SubscribeToEventNotificationUnreadCountSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToEventNotificationUnreadCountSubscription = { __typename?: 'Subscription', subscribeToEventNotificationUnreadCount: number };

export type EventDefinitionPartsFragment = { __typename?: 'EventDefinition', builtin: boolean, customMessage?: string | null, id: string, label?: string | null, name: string, object: any, parentId: string };

export type EventSubscriptionPartsFragment = { __typename?: 'EventSubscription', id: string, eventChannel: { __typename?: 'EventChannel', active: boolean, builtin: boolean, config?: any | null, id: string, label: string, supportedObjects: Array<any>, type: any }, eventDefinition: { __typename?: 'EventDefinition', builtin: boolean, customMessage?: string | null, id: string, label?: string | null, name: string, object: any, parentId: string }, user?: { __typename?: 'User', active: boolean, admin: boolean, billingManager: boolean, email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null, permissions?: any | null, username: string, unreadNotifications?: number | null, activityAt?: any | null, authMethod?: any | null, tenantId: string, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null } | null };

export type EventChannelPartsFragment = { __typename?: 'EventChannel', active: boolean, builtin: boolean, config?: any | null, id: string, label: string, supportedObjects: Array<any>, type: any };

export type ListEventDefinitionsQueryVariables = Exact<{
  input: ListEventDefinitionsInput;
}>;


export type ListEventDefinitionsQuery = { __typename?: 'Query', listEventDefinitions: { __typename?: 'EventDefinitionList', total?: number | null, items?: Array<{ __typename?: 'EventDefinition', builtin: boolean, customMessage?: string | null, id: string, label?: string | null, name: string, object: any, parentId: string, subscriptions?: Array<{ __typename?: 'EventSubscription', id: string }> | null }> | null } };

export type GetEventDefinitionQueryVariables = Exact<{
  input: GetEventDefinitionInput;
}>;


export type GetEventDefinitionQuery = { __typename?: 'Query', getEventDefinition: { __typename?: 'EventDefinition', builtin: boolean, customMessage?: string | null, id: string, label?: string | null, name: string, object: any, parentId: string } };

export type ListEventSubscriptionsQueryVariables = Exact<{
  input: ListEventSubscriptionsInput;
}>;


export type ListEventSubscriptionsQuery = { __typename?: 'Query', listEventSubscriptions: { __typename?: 'EventSubscriptionList', total?: number | null, items?: Array<{ __typename?: 'EventSubscription', id: string, eventChannel: { __typename?: 'EventChannel', active: boolean, builtin: boolean, config?: any | null, id: string, label: string, supportedObjects: Array<any>, type: any }, eventDefinition: { __typename?: 'EventDefinition', builtin: boolean, customMessage?: string | null, id: string, label?: string | null, name: string, object: any, parentId: string }, user?: { __typename?: 'User', active: boolean, admin: boolean, billingManager: boolean, email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null, permissions?: any | null, username: string, unreadNotifications?: number | null, activityAt?: any | null, authMethod?: any | null, tenantId: string, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null } | null }> | null } };

export type ListEventChannelsQueryVariables = Exact<{
  input: ListEventChannelsInput;
}>;


export type ListEventChannelsQuery = { __typename?: 'Query', listEventChannels: { __typename?: 'EventChannelList', total?: number | null, items?: Array<{ __typename?: 'EventChannel', active: boolean, builtin: boolean, config?: any | null, id: string, label: string, supportedObjects: Array<any>, type: any }> | null } };

export type CreateEventChannelMutationVariables = Exact<{
  input: CreateEventChannelInput;
}>;


export type CreateEventChannelMutation = { __typename?: 'Mutation', createEventChannel?: { __typename?: 'EventChannel', active: boolean, builtin: boolean, config?: any | null, id: string, label: string, supportedObjects: Array<any>, type: any } | null };

export type CreateEventSubscriptionMutationVariables = Exact<{
  input: CreateEventSubscriptionInput;
}>;


export type CreateEventSubscriptionMutation = { __typename?: 'Mutation', createEventSubscription: { __typename?: 'EventSubscription', id: string } };

export type RemoveEventSubscriptionMutationVariables = Exact<{
  input: RemoveEventSubscriptionInput;
}>;


export type RemoveEventSubscriptionMutation = { __typename?: 'Mutation', removeEventSubscription: boolean };

export type RemoveEventChannelMutationVariables = Exact<{
  input: RemoveEventChannelInput;
}>;


export type RemoveEventChannelMutation = { __typename?: 'Mutation', removeEventChannel: { __typename?: 'EventChannel', active: boolean, builtin: boolean, config?: any | null, id: string, label: string, supportedObjects: Array<any>, type: any } };

export type RegisterUserDeviceMutationVariables = Exact<{
  input: RegisterUserDeviceInput;
}>;


export type RegisterUserDeviceMutation = { __typename?: 'Mutation', registerUserDevice: boolean };

export type UpdateEventDefinitionMutationVariables = Exact<{
  input: UpdateEventDefinitionInput;
}>;


export type UpdateEventDefinitionMutation = { __typename?: 'Mutation', updateEventDefinition: { __typename?: 'EventDefinition', builtin: boolean, customMessage?: string | null, id: string, label?: string | null, name: string, object: any, parentId: string } };

export type UpdateEventChannelMutationVariables = Exact<{
  input: UpdateEventChannelInput;
}>;


export type UpdateEventChannelMutation = { __typename?: 'Mutation', updateEventChannel: { __typename?: 'EventChannel', active: boolean, builtin: boolean, config?: any | null, id: string, label: string, supportedObjects: Array<any>, type: any } };

export type GetFeaturesQueryVariables = Exact<{
  input: GetFeaturesInput;
}>;


export type GetFeaturesQuery = { __typename?: 'Query', getFeatures: any };

export type SubscribeToFeaturesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToFeaturesSubscription = { __typename?: 'Subscription', subscribeToFeatures: any };

export type CreateFileUploadUrlMutationVariables = Exact<{
  input: CreateFileUploadInput;
}>;


export type CreateFileUploadUrlMutation = { __typename?: 'Mutation', createFileUploadUrl: { __typename?: 'FileUpload', expires: number, fields: any, key?: string | null, modifiedKey?: string | null, url: string } };

export type EmbeddedFormPartsFragment = { __typename?: 'EmbeddedForm', schema: any, uischema: any };

export type FormPartsFragment = { __typename?: 'Form', id: string, schema: any, uischema: any };

export type BuildFormQueryVariables = Exact<{
  input: BuildFormInput;
}>;


export type BuildFormQuery = { __typename?: 'Query', buildForm: { __typename?: 'BuildFormResponse', values: any, form: { __typename?: 'Form', id: string, schema: any, uischema: any } } };

export type UpdateMachineBindingContextMutationVariables = Exact<{
  input: UpdateMachineBindingContextInput;
}>;


export type UpdateMachineBindingContextMutation = { __typename?: 'Mutation', updateMachineBindingContext: boolean };

export type SubscribeToMachineBindingResultSubscriptionVariables = Exact<{
  input: SubscribeToMachineBindingResultInput;
}>;


export type SubscribeToMachineBindingResultSubscription = { __typename?: 'Subscription', subscribeToMachineBindingResult: { __typename?: 'MachineBindingResult', bindingId: string, machineId: string, data: any } };

export type RegisterAndSubscribeToMachineBindingSubscriptionVariables = Exact<{
  input: RegisterAndSubscribeToMachineBindingInput;
}>;


export type RegisterAndSubscribeToMachineBindingSubscription = { __typename?: 'Subscription', registerAndSubscribeToMachineBindingResult: { __typename?: 'MachineBindingResult', bindingId: string, machineId: string, data: any } };

export type MachineFilePartsFragment = { __typename?: 'File', createdAt?: any | null, deleted?: boolean | null, id: string, latest?: boolean | null, name: string, path: string, size?: number | null, type: string, updatedAt?: any | null, version?: string | null };

export type ListMachineFilesQueryVariables = Exact<{
  input: ListMachineFilesInput;
}>;


export type ListMachineFilesQuery = { __typename?: 'Query', listMachineFiles: { __typename?: 'FileList', total?: number | null, items?: Array<{ __typename?: 'File', createdAt?: any | null, deleted?: boolean | null, id: string, latest?: boolean | null, name: string, path: string, size?: number | null, type: string, updatedAt?: any | null, version?: string | null }> | null } };

export type GetMachineFileLinkQueryVariables = Exact<{
  input: GetMachineFileLinkInput;
}>;


export type GetMachineFileLinkQuery = { __typename?: 'Query', getMachineFileLink: { __typename?: 'FileLink', expiration: number, url: string } };

export type SyncFilesToMachineMutationVariables = Exact<{
  input: SyncFilesToMachineInput;
}>;


export type SyncFilesToMachineMutation = { __typename?: 'Mutation', syncFilesToMachine: boolean };

export type SubscribeToFilesSubscriptionVariables = Exact<{
  input: SubscribeToFilesInput;
}>;


export type SubscribeToFilesSubscription = { __typename?: 'Subscription', subscribeToFiles: { __typename?: 'File', createdAt?: any | null, deleted?: boolean | null, id: string, latest?: boolean | null, name: string, path: string, size?: number | null, type: string, updatedAt?: any | null, version?: string | null } };

export type MachineMaintenanceSchedulePartsFragment = { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number };

export type MachineMaintenancePartsFragment = { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null, updates?: Array<{ __typename?: 'MachineMaintenancePendingUpdate', name: string, version: string }> | null };

export type MachineStatePartsFragment = { __typename?: 'MachineState', additional?: any | null, machineId: string, online: boolean, runtimeInfo?: any | null, transient?: any | null, updatedAt?: any | null, maintenance?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null, updates?: Array<{ __typename?: 'MachineMaintenancePendingUpdate', name: string, version: string }> | null } | null };

export type MachinePartsFragment = { __typename?: 'Machine', active: boolean, clientId: string, configuration: any, connectionType: any, demo?: boolean | null, firmwareVersion?: string | null, id: string, name: string, teamId: string, timezone?: string | null, state?: { __typename?: 'MachineState', additional?: any | null, machineId: string, online: boolean, runtimeInfo?: any | null, transient?: any | null, updatedAt?: any | null, maintenance?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null, updates?: Array<{ __typename?: 'MachineMaintenancePendingUpdate', name: string, version: string }> | null } | null } | null };

export type ProvisionedMachineClaimPartsFragment = { __typename?: 'ProvisionedMachineClaim', certificatePem: string, id: string, privateKey: string };

export type ProvisionedMachinePartsFragment = { __typename?: 'ProvisionedMachine', claim?: { __typename?: 'ProvisionedMachineClaim', certificatePem: string, id: string, privateKey: string } | null, machine: { __typename?: 'Machine', active: boolean, clientId: string, configuration: any, connectionType: any, demo?: boolean | null, firmwareVersion?: string | null, id: string, name: string, teamId: string, timezone?: string | null, state?: { __typename?: 'MachineState', additional?: any | null, machineId: string, online: boolean, runtimeInfo?: any | null, transient?: any | null, updatedAt?: any | null, maintenance?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null, updates?: Array<{ __typename?: 'MachineMaintenancePendingUpdate', name: string, version: string }> | null } | null } | null } };

export type ListMachinesQueryVariables = Exact<{
  input: ListMachinesInput;
}>;


export type ListMachinesQuery = { __typename?: 'Query', listMachines: { __typename?: 'MachineList', total?: number | null, items?: Array<{ __typename?: 'Machine', active: boolean, clientId: string, configuration: any, connectionType: any, demo?: boolean | null, firmwareVersion?: string | null, id: string, name: string, teamId: string, timezone?: string | null, state?: { __typename?: 'MachineState', additional?: any | null, machineId: string, online: boolean, runtimeInfo?: any | null, transient?: any | null, updatedAt?: any | null, maintenance?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null, updates?: Array<{ __typename?: 'MachineMaintenancePendingUpdate', name: string, version: string }> | null } | null } | null }> | null } };

export type ListMachinesByUserQueryVariables = Exact<{
  input: ListMachinesByUserInput;
}>;


export type ListMachinesByUserQuery = { __typename?: 'Query', listMachinesByUser: { __typename?: 'MachineList', total?: number | null, items?: Array<{ __typename?: 'Machine', active: boolean, clientId: string, configuration: any, connectionType: any, demo?: boolean | null, firmwareVersion?: string | null, id: string, name: string, teamId: string, timezone?: string | null, state?: { __typename?: 'MachineState', additional?: any | null, machineId: string, online: boolean, runtimeInfo?: any | null, transient?: any | null, updatedAt?: any | null, maintenance?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null, updates?: Array<{ __typename?: 'MachineMaintenancePendingUpdate', name: string, version: string }> | null } | null } | null }> | null } };

export type GetMachineQueryVariables = Exact<{
  input: GetMachineInput;
}>;


export type GetMachineQuery = { __typename?: 'Query', getMachine: { __typename?: 'Machine', active: boolean, clientId: string, configuration: any, connectionType: any, demo?: boolean | null, firmwareVersion?: string | null, id: string, name: string, teamId: string, timezone?: string | null, state?: { __typename?: 'MachineState', additional?: any | null, machineId: string, online: boolean, runtimeInfo?: any | null, transient?: any | null, updatedAt?: any | null, maintenance?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null, updates?: Array<{ __typename?: 'MachineMaintenancePendingUpdate', name: string, version: string }> | null } | null } | null } };

export type UpdateMachineMutationVariables = Exact<{
  input: UpdateMachineInput;
}>;


export type UpdateMachineMutation = { __typename?: 'Mutation', updateMachine: { __typename?: 'Machine', active: boolean, clientId: string, configuration: any, connectionType: any, demo?: boolean | null, firmwareVersion?: string | null, id: string, name: string, teamId: string, timezone?: string | null, state?: { __typename?: 'MachineState', additional?: any | null, machineId: string, online: boolean, runtimeInfo?: any | null, transient?: any | null, updatedAt?: any | null, maintenance?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null, updates?: Array<{ __typename?: 'MachineMaintenancePendingUpdate', name: string, version: string }> | null } | null } | null } };

export type UpdateMachineMaintenanceMutationVariables = Exact<{
  input: UpdateMachineMaintenanceInput;
}>;


export type UpdateMachineMaintenanceMutation = { __typename?: 'Mutation', updateMachineMaintenance: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null, updates?: Array<{ __typename?: 'MachineMaintenancePendingUpdate', name: string, version: string }> | null } };

export type DisableMachineMutationVariables = Exact<{
  input: DisableMachineInput;
}>;


export type DisableMachineMutation = { __typename?: 'Mutation', disableMachine: boolean };

export type RegisterMachineMutationVariables = Exact<{
  input: RegisterMachineInput;
}>;


export type RegisterMachineMutation = { __typename?: 'Mutation', registerMachine: { __typename?: 'Machine', active: boolean, clientId: string, configuration: any, connectionType: any, demo?: boolean | null, firmwareVersion?: string | null, id: string, name: string, teamId: string, timezone?: string | null, state?: { __typename?: 'MachineState', additional?: any | null, machineId: string, online: boolean, runtimeInfo?: any | null, transient?: any | null, updatedAt?: any | null, maintenance?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null, updates?: Array<{ __typename?: 'MachineMaintenancePendingUpdate', name: string, version: string }> | null } | null } | null } };

export type ProvisionMachineMutationVariables = Exact<{
  input: ProvisionMachineInput;
}>;


export type ProvisionMachineMutation = { __typename?: 'Mutation', provisionMachine: { __typename?: 'ProvisionedMachine', claim?: { __typename?: 'ProvisionedMachineClaim', certificatePem: string, id: string, privateKey: string } | null, machine: { __typename?: 'Machine', active: boolean, clientId: string, configuration: any, connectionType: any, demo?: boolean | null, firmwareVersion?: string | null, id: string, name: string, teamId: string, timezone?: string | null, state?: { __typename?: 'MachineState', additional?: any | null, machineId: string, online: boolean, runtimeInfo?: any | null, transient?: any | null, updatedAt?: any | null, maintenance?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null, updates?: Array<{ __typename?: 'MachineMaintenancePendingUpdate', name: string, version: string }> | null } | null } | null } } };

export type SubscribeToMachineStateSubscriptionVariables = Exact<{
  input: SubscribeToMachineStateInput;
}>;


export type SubscribeToMachineStateSubscription = { __typename?: 'Subscription', subscribeToMachineState: Array<{ __typename?: 'MachineState', additional?: any | null, machineId: string, online: boolean, runtimeInfo?: any | null, transient?: any | null, updatedAt?: any | null, maintenance?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null, updates?: Array<{ __typename?: 'MachineMaintenancePendingUpdate', name: string, version: string }> | null } | null }> };

export type SubscribeToSingleMachineStateSubscriptionVariables = Exact<{
  input: SubscribeToSingleMachineStateInput;
}>;


export type SubscribeToSingleMachineStateSubscription = { __typename?: 'Subscription', subscribeToSingleMachineState: { __typename?: 'MachineState', additional?: any | null, machineId: string, online: boolean, runtimeInfo?: any | null, transient?: any | null, updatedAt?: any | null, maintenance?: { __typename?: 'MachineMaintenanceState', enabled: boolean, reboot: boolean, rebootImmediate: boolean, schedule?: { __typename?: 'MachineMaintenanceSchedule', dayOfWeek: any, startHour: number, duration: number } | null, updates?: Array<{ __typename?: 'MachineMaintenancePendingUpdate', name: string, version: string }> | null } | null } };

export type PlanPartsFragment = { __typename?: 'Plan', id: string, name: string, parentId?: string | null, sku: string, displayOrder: number, sellable: boolean, default: boolean, priority: number, licenseType: any, synchronizeQuantityBy?: any | null, billableQuantity?: number | null, product?: { __typename?: 'Product', id: string, name: string, description?: string | null, sku?: string | null, active: boolean, trialPeriodDays?: number | null, prices?: Array<{ __typename?: 'Price', id: string, currency: string, amount: number, recurringInterval: any, recurringCount: number }> | null } | null, entitlements?: Array<{ __typename?: 'PlanEntitlement', key: any, value: string }> | null, replacedBy?: { __typename?: 'Plan', id: string, name: string, parentId?: string | null, sku: string, displayOrder: number, sellable: boolean, default: boolean, priority: number, licenseType: any, synchronizeQuantityBy?: any | null, billableQuantity?: number | null, product?: { __typename?: 'Product', id: string, name: string, description?: string | null, sku?: string | null, active: boolean, trialPeriodDays?: number | null, prices?: Array<{ __typename?: 'Price', id: string, currency: string, amount: number, recurringInterval: any, recurringCount: number }> | null } | null } | null };

export type ProductPartsFragment = { __typename?: 'Product', id: string, name: string, description?: string | null, sku?: string | null, active: boolean, trialPeriodDays?: number | null, prices?: Array<{ __typename?: 'Price', id: string, currency: string, amount: number, recurringInterval: any, recurringCount: number }> | null };

export type PricePartsFragment = { __typename?: 'Price', id: string, currency: string, amount: number, recurringInterval: any, recurringCount: number };

export type EntitlementPartsFragment = { __typename?: 'PlanEntitlement', key: any, value: string };

export type PlanLicensePartsFragment = { __typename?: 'PlanLicense', id: string, planId: string, priceId?: string | null, quantity: number, plan: { __typename?: 'Plan', id: string, name: string, licenseType: any, entitlements?: Array<{ __typename?: 'PlanEntitlement', key: any, value: string }> | null }, assignments?: Array<{ __typename?: 'PlanLicenseAssignment', id: string, planLicenseId: string, assignedTo: string }> | null };

export type PlanLicenseAssignmentPartsFragment = { __typename?: 'PlanLicenseAssignment', id: string, planLicenseId: string, assignedTo: string };

export type PlanDetailsPartsFragment = { __typename?: 'PlanDetails', id: string, entitlements: Array<{ __typename?: 'PlanEntitlement', key: any, value: string }>, licenses: Array<{ __typename?: 'PlanLicense', id: string, planId: string, priceId?: string | null, quantity: number, plan: { __typename?: 'Plan', id: string, name: string, licenseType: any, entitlements?: Array<{ __typename?: 'PlanEntitlement', key: any, value: string }> | null }, assignments?: Array<{ __typename?: 'PlanLicenseAssignment', id: string, planLicenseId: string, assignedTo: string }> | null }> };

export type GetPlanQueryVariables = Exact<{
  input: GetPlanInput;
}>;


export type GetPlanQuery = { __typename?: 'Query', getPlan: { __typename?: 'Plan', id: string, name: string, parentId?: string | null, sku: string, displayOrder: number, sellable: boolean, default: boolean, priority: number, licenseType: any, synchronizeQuantityBy?: any | null, billableQuantity?: number | null, product?: { __typename?: 'Product', id: string, name: string, description?: string | null, sku?: string | null, active: boolean, trialPeriodDays?: number | null, prices?: Array<{ __typename?: 'Price', id: string, currency: string, amount: number, recurringInterval: any, recurringCount: number }> | null } | null, entitlements?: Array<{ __typename?: 'PlanEntitlement', key: any, value: string }> | null, replacedBy?: { __typename?: 'Plan', id: string, name: string, parentId?: string | null, sku: string, displayOrder: number, sellable: boolean, default: boolean, priority: number, licenseType: any, synchronizeQuantityBy?: any | null, billableQuantity?: number | null, product?: { __typename?: 'Product', id: string, name: string, description?: string | null, sku?: string | null, active: boolean, trialPeriodDays?: number | null, prices?: Array<{ __typename?: 'Price', id: string, currency: string, amount: number, recurringInterval: any, recurringCount: number }> | null } | null } | null } };

export type ListPlansQueryVariables = Exact<{
  input: ListPlansInput;
}>;


export type ListPlansQuery = { __typename?: 'Query', listPlans: { __typename?: 'PlanList', total?: number | null, items?: Array<{ __typename?: 'Plan', id: string, name: string, parentId?: string | null, sku: string, displayOrder: number, sellable: boolean, default: boolean, priority: number, licenseType: any, synchronizeQuantityBy?: any | null, billableQuantity?: number | null, product?: { __typename?: 'Product', id: string, name: string, description?: string | null, sku?: string | null, active: boolean, trialPeriodDays?: number | null, prices?: Array<{ __typename?: 'Price', id: string, currency: string, amount: number, recurringInterval: any, recurringCount: number }> | null } | null, entitlements?: Array<{ __typename?: 'PlanEntitlement', key: any, value: string }> | null, replacedBy?: { __typename?: 'Plan', id: string, name: string, parentId?: string | null, sku: string, displayOrder: number, sellable: boolean, default: boolean, priority: number, licenseType: any, synchronizeQuantityBy?: any | null, billableQuantity?: number | null, product?: { __typename?: 'Product', id: string, name: string, description?: string | null, sku?: string | null, active: boolean, trialPeriodDays?: number | null, prices?: Array<{ __typename?: 'Price', id: string, currency: string, amount: number, recurringInterval: any, recurringCount: number }> | null } | null } | null }> | null } };

export type GetPlanDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlanDetailsQuery = { __typename?: 'Query', getPlanDetails: { __typename?: 'PlanDetails', id: string, entitlements: Array<{ __typename?: 'PlanEntitlement', key: any, value: string }>, licenses: Array<{ __typename?: 'PlanLicense', id: string, planId: string, priceId?: string | null, quantity: number, plan: { __typename?: 'Plan', id: string, name: string, licenseType: any, entitlements?: Array<{ __typename?: 'PlanEntitlement', key: any, value: string }> | null }, assignments?: Array<{ __typename?: 'PlanLicenseAssignment', id: string, planLicenseId: string, assignedTo: string }> | null }> } };

export type RequestPlanFeatureMutationVariables = Exact<{
  input: RequestPlanFeatureInput;
}>;


export type RequestPlanFeatureMutation = { __typename?: 'Mutation', requestPlanFeature: boolean };

export type CreateLinkToSubscribeToPlanMutationVariables = Exact<{
  input: SubscribeToPlanInput;
}>;


export type CreateLinkToSubscribeToPlanMutation = { __typename?: 'Mutation', createLinkToSubscribeToPlan: string };

export type CreateLinkToManagePlanSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateLinkToManagePlanSubscriptionMutation = { __typename?: 'Mutation', createLinkToManagePlanSubscription: string };

export type UpdatePlanSubscriptionMutationVariables = Exact<{
  input: UpdatePlanSubscriptionInput;
}>;


export type UpdatePlanSubscriptionMutation = { __typename?: 'Mutation', updatePlanSubscription: string };

export type SubscribeToPlanDetailsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToPlanDetailsSubscription = { __typename?: 'Subscription', subscribeToPlanDetails?: { __typename?: 'PlanDetails', id: string, entitlements: Array<{ __typename?: 'PlanEntitlement', key: any, value: string }>, licenses: Array<{ __typename?: 'PlanLicense', id: string, planId: string, priceId?: string | null, quantity: number, plan: { __typename?: 'Plan', id: string, name: string, licenseType: any, entitlements?: Array<{ __typename?: 'PlanEntitlement', key: any, value: string }> | null }, assignments?: Array<{ __typename?: 'PlanLicenseAssignment', id: string, planLicenseId: string, assignedTo: string }> | null }> } | null };

export type PreferencePartsFragment = { __typename?: 'Preference', id: string, key: string, targetId: string, targetType: any, value: any };

export type SavePreferenceMutationVariables = Exact<{
  input: SavePreferenceInput;
}>;


export type SavePreferenceMutation = { __typename?: 'Mutation', savePreference?: { __typename?: 'Preference', id: string, key: string, targetId: string, targetType: any, value: any } | null };

export type GetPreferenceQueryVariables = Exact<{
  input: GetPreferenceInput;
}>;


export type GetPreferenceQuery = { __typename?: 'Query', getPreference?: { __typename?: 'Preference', id: string, key: string, targetId: string, targetType: any, value: any } | null };

export type ListPreferencesQueryVariables = Exact<{
  input: ListPreferencesInput;
}>;


export type ListPreferencesQuery = { __typename?: 'Query', listPreferences: { __typename?: 'PreferenceList', total?: number | null, items?: Array<{ __typename?: 'Preference', id: string, key: string, targetId: string, targetType: any, value: any }> | null } };

export type RolePartsFragment = { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, parent?: { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null } | null, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null };

export type RoleFieldsFragment = { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null };

export type RolePermissionPartsFragment = { __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } };

export type RolePermissionTemplatePartsFragment = { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number };

export type RolePermissionFormFieldPartsFragment = { __typename?: 'RolePermissionFormField', template: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number }, permission?: { __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } } | null };

export type ListRolesQueryVariables = Exact<{
  input: ListRolesInput;
}>;


export type ListRolesQuery = { __typename?: 'Query', listRoles: { __typename?: 'RoleList', total?: number | null, items?: Array<{ __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, parent?: { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null } | null, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null }> | null } };

export type GetRoleQueryVariables = Exact<{
  input: GetRoleInput;
}>;


export type GetRoleQuery = { __typename?: 'Query', getRole: { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, parent?: { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null } | null, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null } };

export type GetRoleByTeamQueryVariables = Exact<{
  input: GetRoleByTeamInput;
}>;


export type GetRoleByTeamQuery = { __typename?: 'Query', getRoleByTeam: { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, parent?: { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null } | null, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null } };

export type GetRolePermissionFormDataQueryVariables = Exact<{
  input: GetRolePermissionFormDataInput;
}>;


export type GetRolePermissionFormDataQuery = { __typename?: 'Query', getRolePermissionFormData: Array<{ __typename?: 'RolePermissionFormField', template: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number }, permission?: { __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } } | null }> };

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInput;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, parent?: { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null } | null, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null } };

export type UpdateRoleMutationVariables = Exact<{
  input: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, parent?: { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null } | null, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null } };

export type ReplaceRolePermissionsMutationVariables = Exact<{
  input: ReplaceRolePermissionsInput;
}>;


export type ReplaceRolePermissionsMutation = { __typename?: 'Mutation', replaceRolePermissions: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> };

export type DeleteRoleMutationVariables = Exact<{
  input: DeleteRoleInput;
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole: boolean };

export type ScratchpadBucketPartsFragment = { __typename?: 'ScratchpadBucket', id: string, active?: boolean | null, data: any, name?: string | null, publisher?: string | null, scope?: any | null, parentId?: string | null, readonly?: boolean | null, createdAt: any, createdBy: string, updatedAt?: any | null, updatedBy?: string | null, version: number, sourceId?: string | null, tags?: any | null, notes?: string | null, type?: any | null };

export type GetScratchpadBucketQueryVariables = Exact<{
  input: GetScratchpadBucketInput;
}>;


export type GetScratchpadBucketQuery = { __typename?: 'Query', getScratchpadBucket: { __typename?: 'ScratchpadBucket', id: string, active?: boolean | null, data: any, name?: string | null, publisher?: string | null, scope?: any | null, parentId?: string | null, readonly?: boolean | null, createdAt: any, createdBy: string, updatedAt?: any | null, updatedBy?: string | null, version: number, sourceId?: string | null, tags?: any | null, notes?: string | null, type?: any | null } };

export type ListScratchpadBucketsQueryVariables = Exact<{
  input: ListScratchpadBucketsInput;
}>;


export type ListScratchpadBucketsQuery = { __typename?: 'Query', listScratchpadBuckets: { __typename?: 'ScratchpadBucketList', total?: number | null, items?: Array<{ __typename?: 'ScratchpadBucket', id: string, active?: boolean | null, data: any, name?: string | null, publisher?: string | null, scope?: any | null, parentId?: string | null, readonly?: boolean | null, createdAt: any, createdBy: string, updatedAt?: any | null, updatedBy?: string | null, version: number, sourceId?: string | null, tags?: any | null, notes?: string | null, type?: any | null }> | null } };

export type CreateScratchpadBucketMutationVariables = Exact<{
  input: CreateScratchpadBucketInput;
}>;


export type CreateScratchpadBucketMutation = { __typename?: 'Mutation', createScratchpadBucket: { __typename?: 'ScratchpadBucket', id: string, active?: boolean | null, data: any, name?: string | null, publisher?: string | null, scope?: any | null, parentId?: string | null, readonly?: boolean | null, createdAt: any, createdBy: string, updatedAt?: any | null, updatedBy?: string | null, version: number, sourceId?: string | null, tags?: any | null, notes?: string | null, type?: any | null } };

export type UpdateScratchpadBucketMutationVariables = Exact<{
  input: UpdateScratchpadBucketInput;
}>;


export type UpdateScratchpadBucketMutation = { __typename?: 'Mutation', updateScratchpadBucket: { __typename?: 'ScratchpadBucket', id: string, active?: boolean | null, data: any, name?: string | null, publisher?: string | null, scope?: any | null, parentId?: string | null, readonly?: boolean | null, createdAt: any, createdBy: string, updatedAt?: any | null, updatedBy?: string | null, version: number, sourceId?: string | null, tags?: any | null, notes?: string | null, type?: any | null } };

export type ListScratchpadHistoriesPartsFragment = { __typename?: 'ScratchpadHistory', active: boolean, appId: string, createdAt: any, createdBy: string, description?: string | null, id: string, machineId: string, name: string, scratchpadId: string, scratchpadCreatedAt: any, scratchpadUpdatedAt: any, tenantId: string, updatedAt: any, updatedBy?: string | null, executedAt?: any | null, versionExecutionCount?: number | null, versionExecutedAt?: any | null, totalExecutionCount?: number | null, app: { __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any } };

export type ListScratchpadHistoriesQueryVariables = Exact<{
  input: ListScratchpadHistoriesInput;
}>;


export type ListScratchpadHistoriesQuery = { __typename?: 'Query', listScratchpadHistories: { __typename?: 'ScratchpadHistoryList', total?: number | null, items?: Array<{ __typename?: 'ScratchpadHistory', active: boolean, appId: string, createdAt: any, createdBy: string, description?: string | null, id: string, machineId: string, name: string, scratchpadId: string, scratchpadCreatedAt: any, scratchpadUpdatedAt: any, tenantId: string, updatedAt: any, updatedBy?: string | null, executedAt?: any | null, versionExecutionCount?: number | null, versionExecutedAt?: any | null, totalExecutionCount?: number | null, app: { __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any } }> | null } };

export type GetScratchpadHistoryQueryVariables = Exact<{
  input: GetScratchpadHistoryInput;
}>;


export type GetScratchpadHistoryQuery = { __typename?: 'Query', getScratchpadHistory: { __typename?: 'ScratchpadHistory', appData?: any | null, active: boolean, appId: string, createdAt: any, createdBy: string, description?: string | null, id: string, machineId: string, name: string, scratchpadId: string, scratchpadCreatedAt: any, scratchpadUpdatedAt: any, tenantId: string, updatedAt: any, updatedBy?: string | null, executedAt?: any | null, versionExecutionCount?: number | null, versionExecutedAt?: any | null, totalExecutionCount?: number | null, app: { __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any } } };

export type RestoreScratchpadHistoryMutationVariables = Exact<{
  input: RestoreScratchpadHistoryInput;
}>;


export type RestoreScratchpadHistoryMutation = { __typename?: 'Mutation', restoreScratchpadHistory: boolean };

export type ScratchpadPlaylistItemPartsFragment = { __typename?: 'ScratchpadPlaylistItem', autoPlayToNext?: boolean | null, id: string, order: number, quantity: number, scratchpadId: string };

export type ScratchpadPlaylistPartsFragment = { __typename?: 'ScratchpadPlaylist', activated: boolean, id: string, machineId: string, name: string, activeIndex: number, nextIndex: number, canRestore: boolean, createdAt: any, createdBy: string, updatedAt?: any | null, updatedBy?: string | null, items?: Array<{ __typename?: 'ScratchpadPlaylistItem', autoPlayToNext?: boolean | null, id: string, order: number, quantity: number, scratchpadId: string }> | null };

export type ListScratchpadPlaylistsQueryVariables = Exact<{
  input: ListScratchpadPlaylistInput;
}>;


export type ListScratchpadPlaylistsQuery = { __typename?: 'Query', listScratchpadPlaylists: { __typename?: 'ScratchpadPlaylistList', total?: number | null, items?: Array<{ __typename?: 'ScratchpadPlaylist', activated: boolean, id: string, machineId: string, name: string, activeIndex: number, nextIndex: number, canRestore: boolean, createdAt: any, createdBy: string, updatedAt?: any | null, updatedBy?: string | null, items?: Array<{ __typename?: 'ScratchpadPlaylistItem', autoPlayToNext?: boolean | null, id: string, order: number, quantity: number, scratchpadId: string }> | null }> | null } };

export type GetScratchpadPlaylistActivatedQueryVariables = Exact<{
  input: GetScratchpadPlaylistActivatedInput;
}>;


export type GetScratchpadPlaylistActivatedQuery = { __typename?: 'Query', getScratchpadPlaylistActivated?: { __typename?: 'ScratchpadPlaylist', activated: boolean, id: string, machineId: string, name: string, activeIndex: number, nextIndex: number, canRestore: boolean, createdAt: any, createdBy: string, updatedAt?: any | null, updatedBy?: string | null, items?: Array<{ __typename?: 'ScratchpadPlaylistItem', autoPlayToNext?: boolean | null, id: string, order: number, quantity: number, scratchpadId: string }> | null } | null };

export type CreateScratchpadPlaylistMutationVariables = Exact<{
  input: CreateScratchpadPlaylistInput;
}>;


export type CreateScratchpadPlaylistMutation = { __typename?: 'Mutation', createScratchpadPlaylist: { __typename?: 'ScratchpadPlaylist', activated: boolean, id: string, machineId: string, name: string, activeIndex: number, nextIndex: number, canRestore: boolean, createdAt: any, createdBy: string, updatedAt?: any | null, updatedBy?: string | null, items?: Array<{ __typename?: 'ScratchpadPlaylistItem', autoPlayToNext?: boolean | null, id: string, order: number, quantity: number, scratchpadId: string }> | null } };

export type UpdateScratchpadPlaylistMutationVariables = Exact<{
  input: UpdateScratchpadPlaylistInput;
}>;


export type UpdateScratchpadPlaylistMutation = { __typename?: 'Mutation', updateScratchpadPlaylist: { __typename?: 'ScratchpadPlaylist', activated: boolean, id: string, machineId: string, name: string, activeIndex: number, nextIndex: number, canRestore: boolean, createdAt: any, createdBy: string, updatedAt?: any | null, updatedBy?: string | null, items?: Array<{ __typename?: 'ScratchpadPlaylistItem', autoPlayToNext?: boolean | null, id: string, order: number, quantity: number, scratchpadId: string }> | null } };

export type SubscribeToScratchpadPlaylistActivatedSubscriptionVariables = Exact<{
  input: SubscribeToScratchpadPlaylistActivatedInput;
}>;


export type SubscribeToScratchpadPlaylistActivatedSubscription = { __typename?: 'Subscription', subscribeToScratchpadPlaylistActivated: { __typename?: 'ScratchpadPlaylist', activated: boolean, id: string, machineId: string, name: string, activeIndex: number, nextIndex: number, canRestore: boolean, createdAt: any, createdBy: string, updatedAt?: any | null, updatedBy?: string | null, items?: Array<{ __typename?: 'ScratchpadPlaylistItem', autoPlayToNext?: boolean | null, id: string, order: number, quantity: number, scratchpadId: string }> | null } };

export type ScratchpadRecommendationPartsFragment = { __typename?: 'ScratchpadRecommendation', id: string, appSlug: string, type: any, inputs: any, outputs: any };

export type ScratchpadRecommendationFeedbackPartsFragment = { __typename?: 'ScratchpadRecommendationFeedback', id: string, scratchpadRecommendationId: string, rating: number, comments?: string | null };

export type GetScratchpadRecommendationQueryVariables = Exact<{
  input: GetScratchpadRecommendationInput;
}>;


export type GetScratchpadRecommendationQuery = { __typename?: 'Query', getScratchpadRecommendation: { __typename?: 'ScratchpadRecommendation', id: string, appSlug: string, type: any, inputs: any, outputs: any } };

export type CreateScratchpadRecommendationMutationVariables = Exact<{
  input: CreateScratchpadRecommendationRequestInput;
}>;


export type CreateScratchpadRecommendationMutation = { __typename?: 'Mutation', createScratchpadRecommendation: { __typename?: 'ScratchpadRecommendation', id: string, appSlug: string, type: any, inputs: any, outputs: any } };

export type CreateScratchpadRecommendationFeedbackMutationVariables = Exact<{
  input: CreateScratchpadRecommendationFeedbackInput;
}>;


export type CreateScratchpadRecommendationFeedbackMutation = { __typename?: 'Mutation', createScratchpadRecommendationFeedback: { __typename?: 'ScratchpadRecommendationFeedback', id: string, scratchpadRecommendationId: string, rating: number, comments?: string | null } };

export type ScratchpadAppPartsFragment = { __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any };

export type ListScratchpadPartsFragment = { __typename?: 'Scratchpad', appId: string, createdAt: any, createdBy: string, id: string, machineId: string, name: string, description?: string | null, executedAt?: any | null, version: number, updatedAt: any, updatedBy?: string | null, loaded?: boolean | null, active: boolean, bucket1Id?: string | null, app: { __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any } };

export type ScratchpadPartsFragment = { __typename?: 'Scratchpad', appData?: any | null, appId: string, createdAt: any, createdBy: string, id: string, machineId: string, name: string, description?: string | null, executedAt?: any | null, version: number, updatedAt: any, updatedBy?: string | null, loaded?: boolean | null, active: boolean, bucket1Id?: string | null, app: { __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any } };

export type ListScratchpadsQueryVariables = Exact<{
  input: ListScratchpadsInput;
}>;


export type ListScratchpadsQuery = { __typename?: 'Query', listScratchpads: { __typename?: 'ScratchpadList', total?: number | null, items?: Array<{ __typename?: 'Scratchpad', appId: string, createdAt: any, createdBy: string, id: string, machineId: string, name: string, description?: string | null, executedAt?: any | null, version: number, updatedAt: any, updatedBy?: string | null, loaded?: boolean | null, active: boolean, bucket1Id?: string | null, app: { __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any } }> | null } };

export type GetScratchpadQueryVariables = Exact<{
  input: GetScratchpadInput;
}>;


export type GetScratchpadQuery = { __typename?: 'Query', getScratchpad: { __typename?: 'Scratchpad', appData?: any | null, appId: string, createdAt: any, createdBy: string, id: string, machineId: string, name: string, description?: string | null, executedAt?: any | null, version: number, updatedAt: any, updatedBy?: string | null, loaded?: boolean | null, active: boolean, bucket1Id?: string | null, license?: { __typename?: 'ApplicationLicense', id: string, assignedTo: string, applicationVersionId: string, licenseFormValues: any, applicationVersion: { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } } } | null, app: { __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any } } };

export type ListScratchpadAppsQueryVariables = Exact<{
  input: ListScratchpadAppsInput;
}>;


export type ListScratchpadAppsQuery = { __typename?: 'Query', listScratchpadApps: Array<{ __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any, applicationLicense?: { __typename?: 'ApplicationLicense', id: string, licenseFormValues: any } | null }> };

export type ListScratchpadAppsWithApplicationVersionQueryVariables = Exact<{
  input: ListScratchpadAppsInput;
}>;


export type ListScratchpadAppsWithApplicationVersionQuery = { __typename?: 'Query', listScratchpadApps: Array<{ __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any, applicationLicense?: { __typename?: 'ApplicationLicense', id: string, assignedTo: string, applicationVersionId: string, licenseFormValues: any, applicationVersion: { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, application?: { __typename?: 'Application', id: string, name: string, appStoreAppId: string, licenseType: any, maxLicenseCount: number, usedLicenseCount?: number | null } | null, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } } } | null }> };

export type CreateScratchpadMutationVariables = Exact<{
  input: CreateScratchpadInput;
}>;


export type CreateScratchpadMutation = { __typename?: 'Mutation', createScratchpad: { __typename?: 'Scratchpad', appData?: any | null, appId: string, createdAt: any, createdBy: string, id: string, machineId: string, name: string, description?: string | null, executedAt?: any | null, version: number, updatedAt: any, updatedBy?: string | null, loaded?: boolean | null, active: boolean, bucket1Id?: string | null, license?: { __typename?: 'ApplicationLicense', id: string, assignedTo: string, applicationVersionId: string, licenseFormValues: any, applicationVersion: { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } } } | null, app: { __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any } } };

export type UpdateScratchpadMutationVariables = Exact<{
  input: UpdateScratchpadInput;
  options?: InputMaybe<UpdateScratchpadInputOptions>;
}>;


export type UpdateScratchpadMutation = { __typename?: 'Mutation', updateScratchpad: { __typename?: 'Scratchpad', appData?: any | null, appId: string, createdAt: any, createdBy: string, id: string, machineId: string, name: string, description?: string | null, executedAt?: any | null, version: number, updatedAt: any, updatedBy?: string | null, loaded?: boolean | null, active: boolean, bucket1Id?: string | null, license?: { __typename?: 'ApplicationLicense', id: string, assignedTo: string, applicationVersionId: string, licenseFormValues: any, applicationVersion: { __typename?: 'ApplicationVersion', id: string, applicationId: string, baseFilePath: string, version: string, licenseForm: { __typename?: 'ApplicationLicenseForm', type: any, form: { __typename?: 'EmbeddedForm', schema: any, uischema: any } } } } | null, app: { __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any } } };

export type RemoveScratchpadMutationVariables = Exact<{
  input: RemoveScratchpadInput;
}>;


export type RemoveScratchpadMutation = { __typename?: 'Mutation', removeScratchpad: { __typename?: 'Scratchpad', appData?: any | null, appId: string, createdAt: any, createdBy: string, id: string, machineId: string, name: string, description?: string | null, executedAt?: any | null, version: number, updatedAt: any, updatedBy?: string | null, loaded?: boolean | null, active: boolean, bucket1Id?: string | null, app: { __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any } } };

export type RestoreScratchpadMutationVariables = Exact<{
  input: RestoreScratchpadInput;
}>;


export type RestoreScratchpadMutation = { __typename?: 'Mutation', restoreScratchpad: { __typename?: 'Scratchpad', appData?: any | null, appId: string, createdAt: any, createdBy: string, id: string, machineId: string, name: string, description?: string | null, executedAt?: any | null, version: number, updatedAt: any, updatedBy?: string | null, loaded?: boolean | null, active: boolean, bucket1Id?: string | null, app: { __typename?: 'ScratchpadApp', id: string, machineId: string, licenseId?: string | null, name: string, slug: string, mode: any } } };

export type CompileScratchpadMutationVariables = Exact<{
  input: CompileScratchpadInput;
}>;


export type CompileScratchpadMutation = { __typename?: 'Mutation', compileScratchpad: any };

export type GetCompatibleMachinesForScratchpadQueryVariables = Exact<{
  input: GetCompatibleMachinesInput;
}>;


export type GetCompatibleMachinesForScratchpadQuery = { __typename?: 'Query', getCompatibleMachinesForScratchpad: { __typename?: 'ScratchpadCompatibleMachines', machines: Array<{ __typename?: 'Machine', id: string, name: string }> } };

export type TeamPartsFragment = { __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null };

export type ListTeamsQueryVariables = Exact<{
  input: ListTeamsInput;
}>;


export type ListTeamsQuery = { __typename?: 'Query', listTeams: { __typename?: 'TeamList', total?: number | null, items?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null } };

export type ListTeamUsersQueryVariables = Exact<{
  input: ListTeamUsersInput;
}>;


export type ListTeamUsersQuery = { __typename?: 'Query', listTeamUsers: { __typename?: 'TeamUserList', total?: number | null, items?: Array<{ __typename?: 'TeamUser', role: any, roleId: string, customRole?: { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, parent?: { __typename?: 'Role', id: string, name: string, type: any, isBaseRole: boolean, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null } | null, teams?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null, permissions?: Array<{ __typename?: 'RolePermission', id: string, isBaseRolePermission: boolean, rolePermissionTemplateId: string, roleId: string, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, subject: string, fieldApiName?: string | null, fieldName: string, can: boolean, userData?: any | null, rolePermissionTemplate: { __typename?: 'RolePermissionTemplate', id: string, isInternal: boolean, teamRole: any, appStoreAppId?: string | null, appSlug?: string | null, entity: any, policy: string, metadata: any, active: boolean, displayOrder: number } }> | null } | null, user: { __typename?: 'User', active: boolean, admin: boolean, billingManager: boolean, email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null, permissions?: any | null, username: string, unreadNotifications?: number | null, activityAt?: any | null, authMethod?: any | null, tenantId: string, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null } }> | null } };

export type GetTeamQueryVariables = Exact<{
  input: GetTeamInput;
}>;


export type GetTeamQuery = { __typename?: 'Query', getTeam: { __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null } };

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null } };

export type DisableTeamMutationVariables = Exact<{
  input: DisableTeamInput;
}>;


export type DisableTeamMutation = { __typename?: 'Mutation', disableTeam?: { __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null } | null };

export type EnableTeamMutationVariables = Exact<{
  input: EnableTeamInput;
}>;


export type EnableTeamMutation = { __typename?: 'Mutation', enableTeam?: { __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null } | null };

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null } };

export type UpdateTeamAccessMutationVariables = Exact<{
  input: UpdateTeamAccessInput;
}>;


export type UpdateTeamAccessMutation = { __typename?: 'Mutation', updateTeamAccess: { __typename?: 'UpdateTeamAccess', granted: Array<{ __typename?: 'User', active: boolean, admin: boolean, billingManager: boolean, email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null, permissions?: any | null, username: string, unreadNotifications?: number | null, activityAt?: any | null, authMethod?: any | null, tenantId: string, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }>, revoked: Array<{ __typename?: 'User', active: boolean, admin: boolean, billingManager: boolean, email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null, permissions?: any | null, username: string, unreadNotifications?: number | null, activityAt?: any | null, authMethod?: any | null, tenantId: string, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }> } };

export type TenantPartsFragment = { __typename?: 'Tenant', id: string, name?: string | null, planId: string, active: boolean };

export type GetTenantQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantQuery = { __typename?: 'Query', getTenant: { __typename?: 'Tenant', id: string, name?: string | null, planId: string, active: boolean } };

export type ListTenantAssignmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListTenantAssignmentsQuery = { __typename?: 'Query', listTenantAssignments: Array<{ __typename?: 'TenantAssignment', user: { __typename?: 'User', active: boolean, admin: boolean, billingManager: boolean, email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null, permissions?: any | null, username: string, unreadNotifications?: number | null, activityAt?: any | null, authMethod?: any | null, tenantId: string, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, tenant: { __typename?: 'Tenant', id: string, name?: string | null, planId: string, active: boolean } }> };

export type UpdateTenantMutationVariables = Exact<{
  input: UpdateTenantInput;
}>;


export type UpdateTenantMutation = { __typename?: 'Mutation', updateTenant: { __typename?: 'Tenant', id: string, name?: string | null, planId: string, active: boolean } };

export type DeactivateTenantMutationVariables = Exact<{ [key: string]: never; }>;


export type DeactivateTenantMutation = { __typename?: 'Mutation', deactivateTenant: boolean };

export type SubscribeToTenantSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToTenantSubscription = { __typename?: 'Subscription', subscribeToTenant: { __typename?: 'Tenant', id: string, name?: string | null, planId: string, active: boolean } };

export type UserPartsFragment = { __typename?: 'User', active: boolean, admin: boolean, billingManager: boolean, email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null, permissions?: any | null, username: string, unreadNotifications?: number | null, activityAt?: any | null, authMethod?: any | null, tenantId: string, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', active: boolean, admin: boolean, billingManager: boolean, email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null, permissions?: any | null, username: string, unreadNotifications?: number | null, activityAt?: any | null, authMethod?: any | null, tenantId: string, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', active: boolean, admin: boolean, billingManager: boolean, email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null, permissions?: any | null, username: string, unreadNotifications?: number | null, activityAt?: any | null, authMethod?: any | null, tenantId: string, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null } };

export type EnableUserMutationVariables = Exact<{
  input: EnableUserInput;
}>;


export type EnableUserMutation = { __typename?: 'Mutation', enableUser: boolean };

export type DisableUserMutationVariables = Exact<{
  input: DisableUserInput;
}>;


export type DisableUserMutation = { __typename?: 'Mutation', disableUser: boolean };

export type GetUserQueryVariables = Exact<{
  input: GetUserInput;
}>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'User', intercomUserHash?: string | null, active: boolean, admin: boolean, billingManager: boolean, email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null, permissions?: any | null, username: string, unreadNotifications?: number | null, activityAt?: any | null, authMethod?: any | null, tenantId: string, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null } };

export type ListUsersQueryVariables = Exact<{
  input: ListUsersInput;
}>;


export type ListUsersQuery = { __typename?: 'Query', listUsers: { __typename?: 'UserList', total?: number | null, items?: Array<{ __typename?: 'User', active: boolean, admin: boolean, billingManager: boolean, email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null, permissions?: any | null, username: string, unreadNotifications?: number | null, activityAt?: any | null, authMethod?: any | null, tenantId: string, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }> | null } };

export type SubscribeToUserPermissionsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToUserPermissionsSubscription = { __typename?: 'Subscription', subscribeToUserPermissions: any };

export type HydrateWorkspaceQueryVariables = Exact<{
  userInput: GetUserInput;
  teamListInput: ListTeamsInput;
  featureInput: GetFeaturesInput;
  userPreferenceListInput: ListPreferencesInput;
  tenantPreferenceListInput: ListPreferencesInput;
}>;


export type HydrateWorkspaceQuery = { __typename?: 'Query', getFeatures: any, getTenant: { __typename?: 'Tenant', id: string, name?: string | null, planId: string, active: boolean }, getUser: { __typename?: 'User', intercomUserHash?: string | null, active: boolean, admin: boolean, billingManager: boolean, email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null, permissions?: any | null, username: string, unreadNotifications?: number | null, activityAt?: any | null, authMethod?: any | null, tenantId: string, avatarAttachment?: { __typename?: 'Attachment', id: string, name: string, path: string, contentType: string, size?: number | null, status: any, createdBy: string, sources?: Array<{ __typename?: 'AttachmentSource', attachmentId: string, id: string, source: any, sourceId: string }> | null } | null }, listTeams: { __typename?: 'TeamList', total?: number | null, items?: Array<{ __typename?: 'Team', active: boolean, avatar?: string | null, chatId: string, description?: string | null, id: string, name: string, role?: any | null, roleId?: string | null }> | null }, getPlanDetails: { __typename?: 'PlanDetails', id: string, entitlements: Array<{ __typename?: 'PlanEntitlement', key: any, value: string }>, licenses: Array<{ __typename?: 'PlanLicense', id: string, planId: string, priceId?: string | null, quantity: number, plan: { __typename?: 'Plan', id: string, name: string, licenseType: any, entitlements?: Array<{ __typename?: 'PlanEntitlement', key: any, value: string }> | null }, assignments?: Array<{ __typename?: 'PlanLicenseAssignment', id: string, planLicenseId: string, assignedTo: string }> | null }> }, userPreferences: { __typename?: 'PreferenceList', total?: number | null, items?: Array<{ __typename?: 'Preference', id: string, key: string, targetId: string, targetType: any, value: any }> | null }, tenantPreferences: { __typename?: 'PreferenceList', total?: number | null, items?: Array<{ __typename?: 'Preference', id: string, key: string, targetId: string, targetType: any, value: any }> | null } };

export type CreateTenantMutationVariables = Exact<{
  input: CreateTenantInput;
}>;


export type CreateTenantMutation = { __typename?: 'Mutation', createTenant: { __typename?: 'Tenant', id: string, name?: string | null, planId: string, active: boolean } };

export const AuthChallengePartsFragmentDoc = gql`
    fragment AuthChallengeParts on AuthChallenge {
  username
  challengeName
  session
}
    `;
export const CredentialsPartsFragmentDoc = gql`
    fragment CredentialsParts on Credentials {
  accessToken
  expiresIn
  idToken
  refreshToken
}
    `;
export const TenantPartsFragmentDoc = gql`
    fragment TenantParts on Tenant {
  id
  name
  planId
  active
}
    `;
export const WorkspacePartsFragmentDoc = gql`
    fragment WorkspaceParts on Workspace {
  credentials {
    ...CredentialsParts
  }
  user {
    id
    admin
    username
  }
  tenant {
    ...TenantParts
  }
}
    ${CredentialsPartsFragmentDoc}
${TenantPartsFragmentDoc}`;
export const FormPartsFragmentDoc = gql`
    fragment FormParts on Form {
  id
  schema
  uischema
}
    `;
export const ChartTemplatePartsFragmentDoc = gql`
    fragment ChartTemplateParts on ChartTemplate {
  id
  name
  description
  image
  displayOrder
  parentObject
  form {
    ...FormParts
  }
}
    ${FormPartsFragmentDoc}`;
export const ChartPartsFragmentDoc = gql`
    fragment ChartParts on Chart {
  displayOrder
  fields
  id
  parentId
  chartType
  templateId
  title
}
    `;
export const ChartDataResultPartsFragmentDoc = gql`
    fragment ChartDataResultParts on ChartDataResult {
  sourceId
  interval
  label
  value
  groupBy
}
    `;
export const ChartDataPartsFragmentDoc = gql`
    fragment ChartDataParts on ChartData {
  id
  timezone
  results {
    ...ChartDataResultParts
  }
  options {
    chartType
    title
    yAxisLabel
  }
}
    ${ChartDataResultPartsFragmentDoc}`;
export const AttachmentSourcePartsFragmentDoc = gql`
    fragment AttachmentSourceParts on AttachmentSource {
  attachmentId
  id
  source
  sourceId
}
    `;
export const AttachmentPartsFragmentDoc = gql`
    fragment AttachmentParts on Attachment {
  id
  name
  path
  contentType
  size
  status
  createdBy
  sources {
    ...AttachmentSourceParts
  }
}
    ${AttachmentSourcePartsFragmentDoc}`;
export const AuthorPartsFragmentDoc = gql`
    fragment AuthorParts on Author {
  id
  name
  url
  avatarAttachment {
    ...AttachmentParts
  }
}
    ${AttachmentPartsFragmentDoc}`;
export const ChatMessageFieldsFragmentDoc = gql`
    fragment ChatMessageFields on ChatMessage {
  author {
    ...AuthorParts
  }
  attachments {
    ...AttachmentParts
  }
  chatId
  createdAt
  id
  message
  source
  sourceId
  status
  threadId
  totalReplies
  editedAt
  publishedAt
  updatedAt
}
    ${AuthorPartsFragmentDoc}
${AttachmentPartsFragmentDoc}`;
export const ChatMessagePartsFragmentDoc = gql`
    fragment ChatMessageParts on ChatMessage {
  ...ChatMessageFields
  replies {
    ...ChatMessageFields
  }
  draft {
    ...ChatMessageFields
  }
}
    ${ChatMessageFieldsFragmentDoc}`;
export const DirectConnectSyncDataTenantPartsFragmentDoc = gql`
    fragment DirectConnectSyncDataTenantParts on DirectConnectSyncDataTenant {
  id
  name
}
    `;
export const DirectConnectSyncDataTeamPartsFragmentDoc = gql`
    fragment DirectConnectSyncDataTeamParts on DirectConnectSyncDataTeam {
  id
  name
}
    `;
export const DirectConnectSyncDataMachinePartsFragmentDoc = gql`
    fragment DirectConnectSyncDataMachineParts on DirectConnectSyncDataMachine {
  id
  name
  configuration
  maintenanceState {
    enabled
    reboot
    rebootImmediate
    schedule {
      dayOfWeek
      startHour
      duration
    }
  }
}
    `;
export const DirectConnectSyncDataPlanPartsFragmentDoc = gql`
    fragment DirectConnectSyncDataPlanParts on DirectConnectSyncDataPlan {
  id
  name
  sku
}
    `;
export const DirectConnectSyncDataCurrentUserPartsFragmentDoc = gql`
    fragment DirectConnectSyncDataCurrentUserParts on DirectConnectSyncDataCurrentUser {
  id
}
    `;
export const DirectConnectSyncDataTeamUserPartsFragmentDoc = gql`
    fragment DirectConnectSyncDataTeamUserParts on DirectConnectSyncDataTeamUser {
  id
  username
  firstName
  lastName
  email
  active
  admin
  billingManager
  teamRole
  permissions
  features
  pinCode
}
    `;
export const EmbeddedFormPartsFragmentDoc = gql`
    fragment EmbeddedFormParts on EmbeddedForm {
  schema
  uischema
}
    `;
export const ApplicationLicenseFormPartsFragmentDoc = gql`
    fragment ApplicationLicenseFormParts on ApplicationLicenseForm {
  type
  form {
    ...EmbeddedFormParts
  }
}
    ${EmbeddedFormPartsFragmentDoc}`;
export const ApplicationVersionPartsFragmentDoc = gql`
    fragment ApplicationVersionParts on ApplicationVersion {
  id
  applicationId
  baseFilePath
  licenseForm {
    ...ApplicationLicenseFormParts
  }
  version
}
    ${ApplicationLicenseFormPartsFragmentDoc}`;
export const ApplicationLicensePartsFragmentDoc = gql`
    fragment ApplicationLicenseParts on ApplicationLicense {
  id
  assignedTo
  applicationVersion {
    ...ApplicationVersionParts
  }
  applicationVersionId
  licenseFormValues
}
    ${ApplicationVersionPartsFragmentDoc}`;
export const ApplicationPartsFragmentDoc = gql`
    fragment ApplicationParts on Application {
  id
  name
  appStoreAppId
  licenseType
  maxLicenseCount
  usedLicenseCount
}
    `;
export const ApplicationVersionWithApplicationPartsFragmentDoc = gql`
    fragment ApplicationVersionWithApplicationParts on ApplicationVersion {
  ...ApplicationVersionParts
  application {
    ...ApplicationParts
  }
}
    ${ApplicationVersionPartsFragmentDoc}
${ApplicationPartsFragmentDoc}`;
export const ApplicationLicensePartsWithApplicationVersionPartsFragmentDoc = gql`
    fragment ApplicationLicensePartsWithApplicationVersionParts on ApplicationLicense {
  ...ApplicationLicenseParts
  applicationVersion {
    ...ApplicationVersionWithApplicationParts
  }
}
    ${ApplicationLicensePartsFragmentDoc}
${ApplicationVersionWithApplicationPartsFragmentDoc}`;
export const DirectConnectSyncDataScratchpadApplicationPartsFragmentDoc = gql`
    fragment DirectConnectSyncDataScratchpadApplicationParts on DirectConnectSyncDataScratchpadApplication {
  scratchpadAppId
  scratchpadAppName
  scratchpadAppSlug
  scratchpadCompilerSchema
  scratchpadMode
  scratchpadProgram
  license {
    ...ApplicationLicensePartsWithApplicationVersionParts
  }
}
    ${ApplicationLicensePartsWithApplicationVersionPartsFragmentDoc}`;
export const DirectConnectSyncDataEntitlementPartsFragmentDoc = gql`
    fragment DirectConnectSyncDataEntitlementParts on DirectConnectSyncDataEntitlement {
  key
  value
}
    `;
export const DirectConnectSyncDataPreferencePartsFragmentDoc = gql`
    fragment DirectConnectSyncDataPreferenceParts on DirectConnectSyncDataPreference {
  id
  key
  value
  targetType
  targetId
}
    `;
export const DirectConnectGetSyncDataResponsePartsFragmentDoc = gql`
    fragment DirectConnectGetSyncDataResponseParts on DirectConnectGetSyncDataResponse {
  tenant {
    ...DirectConnectSyncDataTenantParts
  }
  team {
    ...DirectConnectSyncDataTeamParts
  }
  machine {
    ...DirectConnectSyncDataMachineParts
  }
  plan {
    ...DirectConnectSyncDataPlanParts
  }
  plans {
    ...DirectConnectSyncDataPlanParts
  }
  currentUser {
    ...DirectConnectSyncDataCurrentUserParts
  }
  teamUsers {
    ...DirectConnectSyncDataTeamUserParts
  }
  applications {
    ...DirectConnectSyncDataScratchpadApplicationParts
  }
  entitlements {
    ...DirectConnectSyncDataEntitlementParts
  }
  preferences {
    ...DirectConnectSyncDataPreferenceParts
  }
}
    ${DirectConnectSyncDataTenantPartsFragmentDoc}
${DirectConnectSyncDataTeamPartsFragmentDoc}
${DirectConnectSyncDataMachinePartsFragmentDoc}
${DirectConnectSyncDataPlanPartsFragmentDoc}
${DirectConnectSyncDataCurrentUserPartsFragmentDoc}
${DirectConnectSyncDataTeamUserPartsFragmentDoc}
${DirectConnectSyncDataScratchpadApplicationPartsFragmentDoc}
${DirectConnectSyncDataEntitlementPartsFragmentDoc}
${DirectConnectSyncDataPreferencePartsFragmentDoc}`;
export const DirectConnectProvisionMachineResponsePartsFragmentDoc = gql`
    fragment DirectConnectProvisionMachineResponseParts on DirectConnectProvisionMachineResponse {
  ok
}
    `;
export const DirectConnectSyncDataResponsePartsFragmentDoc = gql`
    fragment DirectConnectSyncDataResponseParts on DirectConnectSyncDataResponse {
  ok
}
    `;
export const EventNotificationPartsFragmentDoc = gql`
    fragment EventNotificationParts on EventNotification {
  body
  channelType
  eventId
  id
  read
  sentAt
  source
  sourceId
  title
  url
  userId
}
    `;
export const EventChannelPartsFragmentDoc = gql`
    fragment EventChannelParts on EventChannel {
  active
  builtin
  config
  id
  label
  supportedObjects
  type
}
    `;
export const EventDefinitionPartsFragmentDoc = gql`
    fragment EventDefinitionParts on EventDefinition {
  builtin
  customMessage
  id
  label
  name
  object
  parentId
}
    `;
export const UserPartsFragmentDoc = gql`
    fragment UserParts on User {
  active
  admin
  billingManager
  avatarAttachment {
    ...AttachmentParts
  }
  email
  firstName
  id
  lastName
  phone
  permissions
  username
  unreadNotifications
  activityAt
  authMethod
  tenantId
}
    ${AttachmentPartsFragmentDoc}`;
export const EventSubscriptionPartsFragmentDoc = gql`
    fragment EventSubscriptionParts on EventSubscription {
  eventChannel {
    ...EventChannelParts
  }
  eventDefinition {
    ...EventDefinitionParts
  }
  id
  user {
    ...UserParts
  }
}
    ${EventChannelPartsFragmentDoc}
${EventDefinitionPartsFragmentDoc}
${UserPartsFragmentDoc}`;
export const MachineFilePartsFragmentDoc = gql`
    fragment MachineFileParts on File {
  createdAt
  deleted
  id
  latest
  name
  path
  size
  type
  updatedAt
  version
}
    `;
export const ProvisionedMachineClaimPartsFragmentDoc = gql`
    fragment ProvisionedMachineClaimParts on ProvisionedMachineClaim {
  certificatePem
  id
  privateKey
}
    `;
export const MachineMaintenanceSchedulePartsFragmentDoc = gql`
    fragment MachineMaintenanceScheduleParts on MachineMaintenanceSchedule {
  dayOfWeek
  startHour
  duration
}
    `;
export const MachineMaintenancePartsFragmentDoc = gql`
    fragment MachineMaintenanceParts on MachineMaintenanceState {
  enabled
  reboot
  rebootImmediate
  schedule {
    ...MachineMaintenanceScheduleParts
  }
  updates {
    name
    version
  }
}
    ${MachineMaintenanceSchedulePartsFragmentDoc}`;
export const MachineStatePartsFragmentDoc = gql`
    fragment MachineStateParts on MachineState {
  additional
  machineId
  maintenance {
    ...MachineMaintenanceParts
  }
  online
  runtimeInfo
  transient
  updatedAt
}
    ${MachineMaintenancePartsFragmentDoc}`;
export const MachinePartsFragmentDoc = gql`
    fragment MachineParts on Machine {
  active
  clientId
  configuration
  connectionType
  demo
  firmwareVersion
  id
  name
  teamId
  timezone
  state {
    ...MachineStateParts
  }
}
    ${MachineStatePartsFragmentDoc}`;
export const ProvisionedMachinePartsFragmentDoc = gql`
    fragment ProvisionedMachineParts on ProvisionedMachine {
  claim {
    ...ProvisionedMachineClaimParts
  }
  machine {
    ...MachineParts
  }
}
    ${ProvisionedMachineClaimPartsFragmentDoc}
${MachinePartsFragmentDoc}`;
export const PricePartsFragmentDoc = gql`
    fragment PriceParts on Price {
  id
  currency
  amount
  recurringInterval
  recurringCount
}
    `;
export const ProductPartsFragmentDoc = gql`
    fragment ProductParts on Product {
  id
  name
  description
  sku
  active
  trialPeriodDays
  prices {
    ...PriceParts
  }
}
    ${PricePartsFragmentDoc}`;
export const EntitlementPartsFragmentDoc = gql`
    fragment EntitlementParts on PlanEntitlement {
  key
  value
}
    `;
export const PlanPartsFragmentDoc = gql`
    fragment PlanParts on Plan {
  id
  name
  parentId
  sku
  displayOrder
  sellable
  default
  priority
  licenseType
  synchronizeQuantityBy
  billableQuantity
  product {
    ...ProductParts
  }
  entitlements {
    ...EntitlementParts
  }
  replacedBy {
    id
    name
    parentId
    sku
    displayOrder
    sellable
    default
    product {
      ...ProductParts
    }
    priority
    licenseType
    synchronizeQuantityBy
    billableQuantity
  }
}
    ${ProductPartsFragmentDoc}
${EntitlementPartsFragmentDoc}`;
export const PlanLicenseAssignmentPartsFragmentDoc = gql`
    fragment PlanLicenseAssignmentParts on PlanLicenseAssignment {
  id
  planLicenseId
  assignedTo
}
    `;
export const PlanLicensePartsFragmentDoc = gql`
    fragment PlanLicenseParts on PlanLicense {
  id
  plan {
    id
    name
    licenseType
    entitlements {
      ...EntitlementParts
    }
  }
  planId
  priceId
  quantity
  assignments {
    ...PlanLicenseAssignmentParts
  }
}
    ${EntitlementPartsFragmentDoc}
${PlanLicenseAssignmentPartsFragmentDoc}`;
export const PlanDetailsPartsFragmentDoc = gql`
    fragment PlanDetailsParts on PlanDetails {
  id
  entitlements {
    ...EntitlementParts
  }
  licenses {
    ...PlanLicenseParts
  }
}
    ${EntitlementPartsFragmentDoc}
${PlanLicensePartsFragmentDoc}`;
export const PreferencePartsFragmentDoc = gql`
    fragment PreferenceParts on Preference {
  id
  key
  targetId
  targetType
  value
}
    `;
export const TeamPartsFragmentDoc = gql`
    fragment TeamParts on Team {
  active
  avatar
  chatId
  description
  id
  name
  role
  roleId
}
    `;
export const RolePermissionTemplatePartsFragmentDoc = gql`
    fragment RolePermissionTemplateParts on RolePermissionTemplate {
  id
  isInternal
  teamRole
  appStoreAppId
  appSlug
  entity
  policy
  metadata
  active
  displayOrder
}
    `;
export const RolePermissionPartsFragmentDoc = gql`
    fragment RolePermissionParts on RolePermission {
  id
  isBaseRolePermission
  rolePermissionTemplateId
  rolePermissionTemplate {
    ...RolePermissionTemplateParts
  }
  roleId
  appStoreAppId
  appSlug
  entity
  policy
  subject
  fieldApiName
  fieldName
  can
  userData
}
    ${RolePermissionTemplatePartsFragmentDoc}`;
export const RoleFieldsFragmentDoc = gql`
    fragment RoleFields on Role {
  id
  name
  type
  isBaseRole
  teams {
    ...TeamParts
  }
  permissions {
    ...RolePermissionParts
  }
}
    ${TeamPartsFragmentDoc}
${RolePermissionPartsFragmentDoc}`;
export const RolePartsFragmentDoc = gql`
    fragment RoleParts on Role {
  ...RoleFields
  parent {
    ...RoleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export const RolePermissionFormFieldPartsFragmentDoc = gql`
    fragment RolePermissionFormFieldParts on RolePermissionFormField {
  template {
    ...RolePermissionTemplateParts
  }
  permission {
    ...RolePermissionParts
  }
}
    ${RolePermissionTemplatePartsFragmentDoc}
${RolePermissionPartsFragmentDoc}`;
export const ScratchpadBucketPartsFragmentDoc = gql`
    fragment ScratchpadBucketParts on ScratchpadBucket {
  id
  active
  data
  name
  publisher
  scope
  parentId
  readonly
  active
  createdAt
  createdBy
  updatedAt
  updatedBy
  version
  sourceId
  tags
  notes
  type
}
    `;
export const ScratchpadAppPartsFragmentDoc = gql`
    fragment ScratchpadAppParts on ScratchpadApp {
  id
  machineId
  licenseId
  name
  slug
  mode
}
    `;
export const ListScratchpadHistoriesPartsFragmentDoc = gql`
    fragment ListScratchpadHistoriesParts on ScratchpadHistory {
  active
  appId
  app {
    ...ScratchpadAppParts
  }
  createdAt
  createdBy
  description
  id
  machineId
  name
  scratchpadId
  scratchpadCreatedAt
  scratchpadUpdatedAt
  tenantId
  updatedAt
  updatedBy
  executedAt
  versionExecutionCount
  versionExecutedAt
  totalExecutionCount
}
    ${ScratchpadAppPartsFragmentDoc}`;
export const ScratchpadPlaylistItemPartsFragmentDoc = gql`
    fragment ScratchpadPlaylistItemParts on ScratchpadPlaylistItem {
  autoPlayToNext
  id
  order
  quantity
  scratchpadId
}
    `;
export const ScratchpadPlaylistPartsFragmentDoc = gql`
    fragment ScratchpadPlaylistParts on ScratchpadPlaylist {
  activated
  id
  items {
    ...ScratchpadPlaylistItemParts
  }
  machineId
  name
  activeIndex
  nextIndex
  canRestore
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    ${ScratchpadPlaylistItemPartsFragmentDoc}`;
export const ScratchpadRecommendationPartsFragmentDoc = gql`
    fragment ScratchpadRecommendationParts on ScratchpadRecommendation {
  id
  appSlug
  type
  inputs
  outputs
}
    `;
export const ScratchpadRecommendationFeedbackPartsFragmentDoc = gql`
    fragment ScratchpadRecommendationFeedbackParts on ScratchpadRecommendationFeedback {
  id
  scratchpadRecommendationId
  rating
  comments
}
    `;
export const ListScratchpadPartsFragmentDoc = gql`
    fragment ListScratchpadParts on Scratchpad {
  appId
  app {
    ...ScratchpadAppParts
  }
  createdAt
  createdBy
  id
  machineId
  name
  description
  executedAt
  version
  updatedAt
  updatedBy
  loaded
  active
  bucket1Id
}
    ${ScratchpadAppPartsFragmentDoc}`;
export const ScratchpadPartsFragmentDoc = gql`
    fragment ScratchpadParts on Scratchpad {
  ...ListScratchpadParts
  appData
}
    ${ListScratchpadPartsFragmentDoc}`;
export const GetApplicationLicenseDocument = gql`
    query GetApplicationLicense($input: GetApplicationLicenseInput!) {
  getApplicationLicense(input: $input) {
    ...ApplicationLicenseParts
  }
}
    ${ApplicationLicensePartsFragmentDoc}`;

/**
 * __useGetApplicationLicenseQuery__
 *
 * To run a query within a React component, call `useGetApplicationLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationLicenseQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetApplicationLicenseQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationLicenseQuery, GetApplicationLicenseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationLicenseQuery, GetApplicationLicenseQueryVariables>(GetApplicationLicenseDocument, options);
      }
export function useGetApplicationLicenseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationLicenseQuery, GetApplicationLicenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationLicenseQuery, GetApplicationLicenseQueryVariables>(GetApplicationLicenseDocument, options);
        }
export type GetApplicationLicenseQueryHookResult = ReturnType<typeof useGetApplicationLicenseQuery>;
export type GetApplicationLicenseLazyQueryHookResult = ReturnType<typeof useGetApplicationLicenseLazyQuery>;
export type GetApplicationLicenseQueryResult = Apollo.QueryResult<GetApplicationLicenseQuery, GetApplicationLicenseQueryVariables>;
export const ListApplicationLicenseDocument = gql`
    query ListApplicationLicense($input: ListApplicationLicensesInput!) {
  listApplicationLicenses(input: $input) {
    total
    items {
      ...ApplicationLicensePartsWithApplicationVersionParts
    }
  }
}
    ${ApplicationLicensePartsWithApplicationVersionPartsFragmentDoc}`;

/**
 * __useListApplicationLicenseQuery__
 *
 * To run a query within a React component, call `useListApplicationLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApplicationLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApplicationLicenseQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListApplicationLicenseQuery(baseOptions: Apollo.QueryHookOptions<ListApplicationLicenseQuery, ListApplicationLicenseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListApplicationLicenseQuery, ListApplicationLicenseQueryVariables>(ListApplicationLicenseDocument, options);
      }
export function useListApplicationLicenseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListApplicationLicenseQuery, ListApplicationLicenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListApplicationLicenseQuery, ListApplicationLicenseQueryVariables>(ListApplicationLicenseDocument, options);
        }
export type ListApplicationLicenseQueryHookResult = ReturnType<typeof useListApplicationLicenseQuery>;
export type ListApplicationLicenseLazyQueryHookResult = ReturnType<typeof useListApplicationLicenseLazyQuery>;
export type ListApplicationLicenseQueryResult = Apollo.QueryResult<ListApplicationLicenseQuery, ListApplicationLicenseQueryVariables>;
export const ListApplicationByTypeDocument = gql`
    query ListApplicationByType($input: ListApplicationsInput!) {
  listApplicationsByType(input: $input) {
    total
    items {
      ...ApplicationParts
    }
  }
}
    ${ApplicationPartsFragmentDoc}`;

/**
 * __useListApplicationByTypeQuery__
 *
 * To run a query within a React component, call `useListApplicationByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApplicationByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApplicationByTypeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListApplicationByTypeQuery(baseOptions: Apollo.QueryHookOptions<ListApplicationByTypeQuery, ListApplicationByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListApplicationByTypeQuery, ListApplicationByTypeQueryVariables>(ListApplicationByTypeDocument, options);
      }
export function useListApplicationByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListApplicationByTypeQuery, ListApplicationByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListApplicationByTypeQuery, ListApplicationByTypeQueryVariables>(ListApplicationByTypeDocument, options);
        }
export type ListApplicationByTypeQueryHookResult = ReturnType<typeof useListApplicationByTypeQuery>;
export type ListApplicationByTypeLazyQueryHookResult = ReturnType<typeof useListApplicationByTypeLazyQuery>;
export type ListApplicationByTypeQueryResult = Apollo.QueryResult<ListApplicationByTypeQuery, ListApplicationByTypeQueryVariables>;
export const ListApplicationVersionsDocument = gql`
    query ListApplicationVersions($input: ListApplicationVersionsInput!) {
  listApplicationVersions(input: $input) {
    total
    items {
      ...ApplicationVersionWithApplicationParts
    }
  }
}
    ${ApplicationVersionWithApplicationPartsFragmentDoc}`;

/**
 * __useListApplicationVersionsQuery__
 *
 * To run a query within a React component, call `useListApplicationVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApplicationVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApplicationVersionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListApplicationVersionsQuery(baseOptions: Apollo.QueryHookOptions<ListApplicationVersionsQuery, ListApplicationVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListApplicationVersionsQuery, ListApplicationVersionsQueryVariables>(ListApplicationVersionsDocument, options);
      }
export function useListApplicationVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListApplicationVersionsQuery, ListApplicationVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListApplicationVersionsQuery, ListApplicationVersionsQueryVariables>(ListApplicationVersionsDocument, options);
        }
export type ListApplicationVersionsQueryHookResult = ReturnType<typeof useListApplicationVersionsQuery>;
export type ListApplicationVersionsLazyQueryHookResult = ReturnType<typeof useListApplicationVersionsLazyQuery>;
export type ListApplicationVersionsQueryResult = Apollo.QueryResult<ListApplicationVersionsQuery, ListApplicationVersionsQueryVariables>;
export const GetLatestApplicationVersionDocument = gql`
    query GetLatestApplicationVersion($input: GetApplicationVersionInput!) {
  getLatestApplicationVersion(input: $input) {
    ...ApplicationVersionWithApplicationParts
  }
}
    ${ApplicationVersionWithApplicationPartsFragmentDoc}`;

/**
 * __useGetLatestApplicationVersionQuery__
 *
 * To run a query within a React component, call `useGetLatestApplicationVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestApplicationVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestApplicationVersionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLatestApplicationVersionQuery(baseOptions: Apollo.QueryHookOptions<GetLatestApplicationVersionQuery, GetLatestApplicationVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestApplicationVersionQuery, GetLatestApplicationVersionQueryVariables>(GetLatestApplicationVersionDocument, options);
      }
export function useGetLatestApplicationVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestApplicationVersionQuery, GetLatestApplicationVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestApplicationVersionQuery, GetLatestApplicationVersionQueryVariables>(GetLatestApplicationVersionDocument, options);
        }
export type GetLatestApplicationVersionQueryHookResult = ReturnType<typeof useGetLatestApplicationVersionQuery>;
export type GetLatestApplicationVersionLazyQueryHookResult = ReturnType<typeof useGetLatestApplicationVersionLazyQuery>;
export type GetLatestApplicationVersionQueryResult = Apollo.QueryResult<GetLatestApplicationVersionQuery, GetLatestApplicationVersionQueryVariables>;
export const GetAssignedApplicationLicenseDocument = gql`
    query getAssignedApplicationLicense($input: GetAssignedApplicationLicenseInput!) {
  getAssignedApplicationLicense(input: $input) {
    ...ApplicationLicensePartsWithApplicationVersionParts
  }
}
    ${ApplicationLicensePartsWithApplicationVersionPartsFragmentDoc}`;

/**
 * __useGetAssignedApplicationLicenseQuery__
 *
 * To run a query within a React component, call `useGetAssignedApplicationLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedApplicationLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedApplicationLicenseQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssignedApplicationLicenseQuery(baseOptions: Apollo.QueryHookOptions<GetAssignedApplicationLicenseQuery, GetAssignedApplicationLicenseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedApplicationLicenseQuery, GetAssignedApplicationLicenseQueryVariables>(GetAssignedApplicationLicenseDocument, options);
      }
export function useGetAssignedApplicationLicenseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedApplicationLicenseQuery, GetAssignedApplicationLicenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedApplicationLicenseQuery, GetAssignedApplicationLicenseQueryVariables>(GetAssignedApplicationLicenseDocument, options);
        }
export type GetAssignedApplicationLicenseQueryHookResult = ReturnType<typeof useGetAssignedApplicationLicenseQuery>;
export type GetAssignedApplicationLicenseLazyQueryHookResult = ReturnType<typeof useGetAssignedApplicationLicenseLazyQuery>;
export type GetAssignedApplicationLicenseQueryResult = Apollo.QueryResult<GetAssignedApplicationLicenseQuery, GetAssignedApplicationLicenseQueryVariables>;
export const AssignApplicationLicenseDocument = gql`
    mutation AssignApplicationLicense($input: AssignApplicationLicenseInput!) {
  assignApplicationLicense(input: $input)
}
    `;
export type AssignApplicationLicenseMutationFn = Apollo.MutationFunction<AssignApplicationLicenseMutation, AssignApplicationLicenseMutationVariables>;

/**
 * __useAssignApplicationLicenseMutation__
 *
 * To run a mutation, you first call `useAssignApplicationLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignApplicationLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignApplicationLicenseMutation, { data, loading, error }] = useAssignApplicationLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignApplicationLicenseMutation(baseOptions?: Apollo.MutationHookOptions<AssignApplicationLicenseMutation, AssignApplicationLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignApplicationLicenseMutation, AssignApplicationLicenseMutationVariables>(AssignApplicationLicenseDocument, options);
      }
export type AssignApplicationLicenseMutationHookResult = ReturnType<typeof useAssignApplicationLicenseMutation>;
export type AssignApplicationLicenseMutationResult = Apollo.MutationResult<AssignApplicationLicenseMutation>;
export type AssignApplicationLicenseMutationOptions = Apollo.BaseMutationOptions<AssignApplicationLicenseMutation, AssignApplicationLicenseMutationVariables>;
export const GetAttachmentDocument = gql`
    query GetAttachment($input: GetAttachmentInput!) {
  getAttachment(input: $input) {
    ...AttachmentParts
  }
}
    ${AttachmentPartsFragmentDoc}`;

/**
 * __useGetAttachmentQuery__
 *
 * To run a query within a React component, call `useGetAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAttachmentQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentQuery, GetAttachmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentQuery, GetAttachmentQueryVariables>(GetAttachmentDocument, options);
      }
export function useGetAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentQuery, GetAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentQuery, GetAttachmentQueryVariables>(GetAttachmentDocument, options);
        }
export type GetAttachmentQueryHookResult = ReturnType<typeof useGetAttachmentQuery>;
export type GetAttachmentLazyQueryHookResult = ReturnType<typeof useGetAttachmentLazyQuery>;
export type GetAttachmentQueryResult = Apollo.QueryResult<GetAttachmentQuery, GetAttachmentQueryVariables>;
export const CreateAttachmentDocument = gql`
    mutation CreateAttachment($input: CreateAttachmentInput!) {
  createAttachment(input: $input) {
    ...AttachmentParts
  }
}
    ${AttachmentPartsFragmentDoc}`;
export type CreateAttachmentMutationFn = Apollo.MutationFunction<CreateAttachmentMutation, CreateAttachmentMutationVariables>;

/**
 * __useCreateAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentMutation, { data, loading, error }] = useCreateAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttachmentMutation, CreateAttachmentMutationVariables>(CreateAttachmentDocument, options);
      }
export type CreateAttachmentMutationHookResult = ReturnType<typeof useCreateAttachmentMutation>;
export type CreateAttachmentMutationResult = Apollo.MutationResult<CreateAttachmentMutation>;
export type CreateAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>;
export const DeleteAttachmentDocument = gql`
    mutation DeleteAttachment($input: DeleteAttachmentInput!) {
  deleteAttachment(input: $input)
}
    `;
export type DeleteAttachmentMutationFn = Apollo.MutationFunction<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;

/**
 * __useDeleteAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentMutation, { data, loading, error }] = useDeleteAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>(DeleteAttachmentDocument, options);
      }
export type DeleteAttachmentMutationHookResult = ReturnType<typeof useDeleteAttachmentMutation>;
export type DeleteAttachmentMutationResult = Apollo.MutationResult<DeleteAttachmentMutation>;
export type DeleteAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;
export const ListAttachmentsDocument = gql`
    query ListAttachments($input: ListAttachmentsInput!) {
  listAttachments(input: $input) {
    total
    items {
      ...AttachmentParts
    }
  }
}
    ${AttachmentPartsFragmentDoc}`;

/**
 * __useListAttachmentsQuery__
 *
 * To run a query within a React component, call `useListAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAttachmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<ListAttachmentsQuery, ListAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAttachmentsQuery, ListAttachmentsQueryVariables>(ListAttachmentsDocument, options);
      }
export function useListAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAttachmentsQuery, ListAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAttachmentsQuery, ListAttachmentsQueryVariables>(ListAttachmentsDocument, options);
        }
export type ListAttachmentsQueryHookResult = ReturnType<typeof useListAttachmentsQuery>;
export type ListAttachmentsLazyQueryHookResult = ReturnType<typeof useListAttachmentsLazyQuery>;
export type ListAttachmentsQueryResult = Apollo.QueryResult<ListAttachmentsQuery, ListAttachmentsQueryVariables>;
export const SignupDocument = gql`
    mutation Signup($input: SignupRequest!) {
  signup(input: $input) {
    expiresIn
    authMethod
    username
  }
}
    `;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const InitiateAuthFlowDocument = gql`
    mutation InitiateAuthFlow($input: InitiateAuthFlowRequest!) {
  initiateAuthFlow(input: $input) {
    expiresIn
    authMethod
    username
  }
}
    `;
export type InitiateAuthFlowMutationFn = Apollo.MutationFunction<InitiateAuthFlowMutation, InitiateAuthFlowMutationVariables>;

/**
 * __useInitiateAuthFlowMutation__
 *
 * To run a mutation, you first call `useInitiateAuthFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateAuthFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateAuthFlowMutation, { data, loading, error }] = useInitiateAuthFlowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateAuthFlowMutation(baseOptions?: Apollo.MutationHookOptions<InitiateAuthFlowMutation, InitiateAuthFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateAuthFlowMutation, InitiateAuthFlowMutationVariables>(InitiateAuthFlowDocument, options);
      }
export type InitiateAuthFlowMutationHookResult = ReturnType<typeof useInitiateAuthFlowMutation>;
export type InitiateAuthFlowMutationResult = Apollo.MutationResult<InitiateAuthFlowMutation>;
export type InitiateAuthFlowMutationOptions = Apollo.BaseMutationOptions<InitiateAuthFlowMutation, InitiateAuthFlowMutationVariables>;
export const RespondToAuthChallengeDocument = gql`
    mutation RespondToAuthChallenge($input: RespondToAuthChallengeRequest!) {
  respondToAuthChallenge(input: $input) {
    workspaces {
      ...WorkspaceParts
    }
  }
}
    ${WorkspacePartsFragmentDoc}`;
export type RespondToAuthChallengeMutationFn = Apollo.MutationFunction<RespondToAuthChallengeMutation, RespondToAuthChallengeMutationVariables>;

/**
 * __useRespondToAuthChallengeMutation__
 *
 * To run a mutation, you first call `useRespondToAuthChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToAuthChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToAuthChallengeMutation, { data, loading, error }] = useRespondToAuthChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRespondToAuthChallengeMutation(baseOptions?: Apollo.MutationHookOptions<RespondToAuthChallengeMutation, RespondToAuthChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondToAuthChallengeMutation, RespondToAuthChallengeMutationVariables>(RespondToAuthChallengeDocument, options);
      }
export type RespondToAuthChallengeMutationHookResult = ReturnType<typeof useRespondToAuthChallengeMutation>;
export type RespondToAuthChallengeMutationResult = Apollo.MutationResult<RespondToAuthChallengeMutation>;
export type RespondToAuthChallengeMutationOptions = Apollo.BaseMutationOptions<RespondToAuthChallengeMutation, RespondToAuthChallengeMutationVariables>;
export const RefreshTokenDocument = gql`
    query RefreshToken($input: RefreshTokenRequest!) {
  refreshToken(input: $input) {
    credentials {
      ...CredentialsParts
    }
  }
}
    ${CredentialsPartsFragmentDoc}`;

/**
 * __useRefreshTokenQuery__
 *
 * To run a query within a React component, call `useRefreshTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefreshTokenQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshTokenQuery(baseOptions: Apollo.QueryHookOptions<RefreshTokenQuery, RefreshTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefreshTokenQuery, RefreshTokenQueryVariables>(RefreshTokenDocument, options);
      }
export function useRefreshTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefreshTokenQuery, RefreshTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefreshTokenQuery, RefreshTokenQueryVariables>(RefreshTokenDocument, options);
        }
export type RefreshTokenQueryHookResult = ReturnType<typeof useRefreshTokenQuery>;
export type RefreshTokenLazyQueryHookResult = ReturnType<typeof useRefreshTokenLazyQuery>;
export type RefreshTokenQueryResult = Apollo.QueryResult<RefreshTokenQuery, RefreshTokenQueryVariables>;
export const LogoutDocument = gql`
    mutation Logout($input: LogoutRequest) {
  logout(input: $input) {
    success
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const AuthenticateWithPasswordDocument = gql`
    mutation AuthenticateWithPassword($input: PasswordAuthenticationRequest!) {
  authenticateWithPassword(input: $input) {
    workspace {
      ...WorkspaceParts
    }
    challenge {
      ...AuthChallengeParts
    }
  }
}
    ${WorkspacePartsFragmentDoc}
${AuthChallengePartsFragmentDoc}`;
export type AuthenticateWithPasswordMutationFn = Apollo.MutationFunction<AuthenticateWithPasswordMutation, AuthenticateWithPasswordMutationVariables>;

/**
 * __useAuthenticateWithPasswordMutation__
 *
 * To run a mutation, you first call `useAuthenticateWithPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateWithPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateWithPasswordMutation, { data, loading, error }] = useAuthenticateWithPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticateWithPasswordMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateWithPasswordMutation, AuthenticateWithPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateWithPasswordMutation, AuthenticateWithPasswordMutationVariables>(AuthenticateWithPasswordDocument, options);
      }
export type AuthenticateWithPasswordMutationHookResult = ReturnType<typeof useAuthenticateWithPasswordMutation>;
export type AuthenticateWithPasswordMutationResult = Apollo.MutationResult<AuthenticateWithPasswordMutation>;
export type AuthenticateWithPasswordMutationOptions = Apollo.BaseMutationOptions<AuthenticateWithPasswordMutation, AuthenticateWithPasswordMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($input: ForgotPasswordRequest!) {
  forgotPassword(input: $input) {
    username
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ConfirmForgotPasswordDocument = gql`
    mutation ConfirmForgotPassword($input: ConfirmForgotPasswordRequest!) {
  confirmForgotPassword(input: $input) {
    workspace {
      ...WorkspaceParts
    }
  }
}
    ${WorkspacePartsFragmentDoc}`;
export type ConfirmForgotPasswordMutationFn = Apollo.MutationFunction<ConfirmForgotPasswordMutation, ConfirmForgotPasswordMutationVariables>;

/**
 * __useConfirmForgotPasswordMutation__
 *
 * To run a mutation, you first call `useConfirmForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmForgotPasswordMutation, { data, loading, error }] = useConfirmForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmForgotPasswordMutation, ConfirmForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmForgotPasswordMutation, ConfirmForgotPasswordMutationVariables>(ConfirmForgotPasswordDocument, options);
      }
export type ConfirmForgotPasswordMutationHookResult = ReturnType<typeof useConfirmForgotPasswordMutation>;
export type ConfirmForgotPasswordMutationResult = Apollo.MutationResult<ConfirmForgotPasswordMutation>;
export type ConfirmForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ConfirmForgotPasswordMutation, ConfirmForgotPasswordMutationVariables>;
export const ListChartTemplatesDocument = gql`
    query ListChartTemplates($input: ListChartTemplatesInput!) {
  listChartTemplates(input: $input) {
    total
    items {
      ...ChartTemplateParts
      form {
        ...FormParts
      }
    }
  }
}
    ${ChartTemplatePartsFragmentDoc}
${FormPartsFragmentDoc}`;

/**
 * __useListChartTemplatesQuery__
 *
 * To run a query within a React component, call `useListChartTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChartTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChartTemplatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListChartTemplatesQuery(baseOptions: Apollo.QueryHookOptions<ListChartTemplatesQuery, ListChartTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListChartTemplatesQuery, ListChartTemplatesQueryVariables>(ListChartTemplatesDocument, options);
      }
export function useListChartTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListChartTemplatesQuery, ListChartTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListChartTemplatesQuery, ListChartTemplatesQueryVariables>(ListChartTemplatesDocument, options);
        }
export type ListChartTemplatesQueryHookResult = ReturnType<typeof useListChartTemplatesQuery>;
export type ListChartTemplatesLazyQueryHookResult = ReturnType<typeof useListChartTemplatesLazyQuery>;
export type ListChartTemplatesQueryResult = Apollo.QueryResult<ListChartTemplatesQuery, ListChartTemplatesQueryVariables>;
export const GetChartTemplateDocument = gql`
    query GetChartTemplate($input: GetChartTemplateInput!) {
  getChartTemplate(input: $input) {
    ...ChartTemplateParts
    form {
      ...FormParts
    }
  }
}
    ${ChartTemplatePartsFragmentDoc}
${FormPartsFragmentDoc}`;

/**
 * __useGetChartTemplateQuery__
 *
 * To run a query within a React component, call `useGetChartTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChartTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChartTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChartTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetChartTemplateQuery, GetChartTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChartTemplateQuery, GetChartTemplateQueryVariables>(GetChartTemplateDocument, options);
      }
export function useGetChartTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChartTemplateQuery, GetChartTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChartTemplateQuery, GetChartTemplateQueryVariables>(GetChartTemplateDocument, options);
        }
export type GetChartTemplateQueryHookResult = ReturnType<typeof useGetChartTemplateQuery>;
export type GetChartTemplateLazyQueryHookResult = ReturnType<typeof useGetChartTemplateLazyQuery>;
export type GetChartTemplateQueryResult = Apollo.QueryResult<GetChartTemplateQuery, GetChartTemplateQueryVariables>;
export const GetChartDocument = gql`
    query GetChart($input: GetChartInput!) {
  getChart(input: $input) {
    ...ChartParts
    template {
      ...ChartTemplateParts
      form {
        ...FormParts
      }
    }
  }
}
    ${ChartPartsFragmentDoc}
${ChartTemplatePartsFragmentDoc}
${FormPartsFragmentDoc}`;

/**
 * __useGetChartQuery__
 *
 * To run a query within a React component, call `useGetChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChartQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChartQuery(baseOptions: Apollo.QueryHookOptions<GetChartQuery, GetChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChartQuery, GetChartQueryVariables>(GetChartDocument, options);
      }
export function useGetChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChartQuery, GetChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChartQuery, GetChartQueryVariables>(GetChartDocument, options);
        }
export type GetChartQueryHookResult = ReturnType<typeof useGetChartQuery>;
export type GetChartLazyQueryHookResult = ReturnType<typeof useGetChartLazyQuery>;
export type GetChartQueryResult = Apollo.QueryResult<GetChartQuery, GetChartQueryVariables>;
export const GetChartDataDocument = gql`
    query GetChartData($input: GetChartDataInput!) {
  getChartData(input: $input) {
    ...ChartDataParts
  }
}
    ${ChartDataPartsFragmentDoc}`;

/**
 * __useGetChartDataQuery__
 *
 * To run a query within a React component, call `useGetChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChartDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChartDataQuery(baseOptions: Apollo.QueryHookOptions<GetChartDataQuery, GetChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChartDataQuery, GetChartDataQueryVariables>(GetChartDataDocument, options);
      }
export function useGetChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChartDataQuery, GetChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChartDataQuery, GetChartDataQueryVariables>(GetChartDataDocument, options);
        }
export type GetChartDataQueryHookResult = ReturnType<typeof useGetChartDataQuery>;
export type GetChartDataLazyQueryHookResult = ReturnType<typeof useGetChartDataLazyQuery>;
export type GetChartDataQueryResult = Apollo.QueryResult<GetChartDataQuery, GetChartDataQueryVariables>;
export const ListChartsDocument = gql`
    query ListCharts($input: ListChartsInput!) {
  listCharts(input: $input) {
    total
    items {
      ...ChartParts
    }
  }
}
    ${ChartPartsFragmentDoc}`;

/**
 * __useListChartsQuery__
 *
 * To run a query within a React component, call `useListChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChartsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListChartsQuery(baseOptions: Apollo.QueryHookOptions<ListChartsQuery, ListChartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListChartsQuery, ListChartsQueryVariables>(ListChartsDocument, options);
      }
export function useListChartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListChartsQuery, ListChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListChartsQuery, ListChartsQueryVariables>(ListChartsDocument, options);
        }
export type ListChartsQueryHookResult = ReturnType<typeof useListChartsQuery>;
export type ListChartsLazyQueryHookResult = ReturnType<typeof useListChartsLazyQuery>;
export type ListChartsQueryResult = Apollo.QueryResult<ListChartsQuery, ListChartsQueryVariables>;
export const ExportChartDocument = gql`
    mutation ExportChart($input: ExportChartInput!) {
  exportChart(input: $input)
}
    `;
export type ExportChartMutationFn = Apollo.MutationFunction<ExportChartMutation, ExportChartMutationVariables>;

/**
 * __useExportChartMutation__
 *
 * To run a mutation, you first call `useExportChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportChartMutation, { data, loading, error }] = useExportChartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportChartMutation(baseOptions?: Apollo.MutationHookOptions<ExportChartMutation, ExportChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportChartMutation, ExportChartMutationVariables>(ExportChartDocument, options);
      }
export type ExportChartMutationHookResult = ReturnType<typeof useExportChartMutation>;
export type ExportChartMutationResult = Apollo.MutationResult<ExportChartMutation>;
export type ExportChartMutationOptions = Apollo.BaseMutationOptions<ExportChartMutation, ExportChartMutationVariables>;
export const CreateChartDocument = gql`
    mutation CreateChart($input: CreateChartInput!) {
  createChart(input: $input) {
    ...ChartParts
  }
}
    ${ChartPartsFragmentDoc}`;
export type CreateChartMutationFn = Apollo.MutationFunction<CreateChartMutation, CreateChartMutationVariables>;

/**
 * __useCreateChartMutation__
 *
 * To run a mutation, you first call `useCreateChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChartMutation, { data, loading, error }] = useCreateChartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChartMutation(baseOptions?: Apollo.MutationHookOptions<CreateChartMutation, CreateChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChartMutation, CreateChartMutationVariables>(CreateChartDocument, options);
      }
export type CreateChartMutationHookResult = ReturnType<typeof useCreateChartMutation>;
export type CreateChartMutationResult = Apollo.MutationResult<CreateChartMutation>;
export type CreateChartMutationOptions = Apollo.BaseMutationOptions<CreateChartMutation, CreateChartMutationVariables>;
export const UpdateChartDocument = gql`
    mutation UpdateChart($input: UpdateChartInput!) {
  updateChart(input: $input) {
    ...ChartParts
  }
}
    ${ChartPartsFragmentDoc}`;
export type UpdateChartMutationFn = Apollo.MutationFunction<UpdateChartMutation, UpdateChartMutationVariables>;

/**
 * __useUpdateChartMutation__
 *
 * To run a mutation, you first call `useUpdateChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChartMutation, { data, loading, error }] = useUpdateChartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChartMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChartMutation, UpdateChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChartMutation, UpdateChartMutationVariables>(UpdateChartDocument, options);
      }
export type UpdateChartMutationHookResult = ReturnType<typeof useUpdateChartMutation>;
export type UpdateChartMutationResult = Apollo.MutationResult<UpdateChartMutation>;
export type UpdateChartMutationOptions = Apollo.BaseMutationOptions<UpdateChartMutation, UpdateChartMutationVariables>;
export const RemoveChartDocument = gql`
    mutation RemoveChart($input: RemoveChartInput!) {
  removeChart(input: $input)
}
    `;
export type RemoveChartMutationFn = Apollo.MutationFunction<RemoveChartMutation, RemoveChartMutationVariables>;

/**
 * __useRemoveChartMutation__
 *
 * To run a mutation, you first call `useRemoveChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChartMutation, { data, loading, error }] = useRemoveChartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveChartMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChartMutation, RemoveChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChartMutation, RemoveChartMutationVariables>(RemoveChartDocument, options);
      }
export type RemoveChartMutationHookResult = ReturnType<typeof useRemoveChartMutation>;
export type RemoveChartMutationResult = Apollo.MutationResult<RemoveChartMutation>;
export type RemoveChartMutationOptions = Apollo.BaseMutationOptions<RemoveChartMutation, RemoveChartMutationVariables>;
export const GetChatMessageDocument = gql`
    query GetChatMessage($input: GetChatMessageInput!) {
  getChatMessage(input: $input) {
    ...ChatMessageParts
  }
}
    ${ChatMessagePartsFragmentDoc}`;

/**
 * __useGetChatMessageQuery__
 *
 * To run a query within a React component, call `useGetChatMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMessageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChatMessageQuery(baseOptions: Apollo.QueryHookOptions<GetChatMessageQuery, GetChatMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatMessageQuery, GetChatMessageQueryVariables>(GetChatMessageDocument, options);
      }
export function useGetChatMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatMessageQuery, GetChatMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatMessageQuery, GetChatMessageQueryVariables>(GetChatMessageDocument, options);
        }
export type GetChatMessageQueryHookResult = ReturnType<typeof useGetChatMessageQuery>;
export type GetChatMessageLazyQueryHookResult = ReturnType<typeof useGetChatMessageLazyQuery>;
export type GetChatMessageQueryResult = Apollo.QueryResult<GetChatMessageQuery, GetChatMessageQueryVariables>;
export const GetChatMessageDraftDocument = gql`
    query GetChatMessageDraft($input: GetChatMessageDraftInput!) {
  getChatMessageDraft(input: $input) {
    ...ChatMessageParts
  }
}
    ${ChatMessagePartsFragmentDoc}`;

/**
 * __useGetChatMessageDraftQuery__
 *
 * To run a query within a React component, call `useGetChatMessageDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMessageDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMessageDraftQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChatMessageDraftQuery(baseOptions: Apollo.QueryHookOptions<GetChatMessageDraftQuery, GetChatMessageDraftQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatMessageDraftQuery, GetChatMessageDraftQueryVariables>(GetChatMessageDraftDocument, options);
      }
export function useGetChatMessageDraftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatMessageDraftQuery, GetChatMessageDraftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatMessageDraftQuery, GetChatMessageDraftQueryVariables>(GetChatMessageDraftDocument, options);
        }
export type GetChatMessageDraftQueryHookResult = ReturnType<typeof useGetChatMessageDraftQuery>;
export type GetChatMessageDraftLazyQueryHookResult = ReturnType<typeof useGetChatMessageDraftLazyQuery>;
export type GetChatMessageDraftQueryResult = Apollo.QueryResult<GetChatMessageDraftQuery, GetChatMessageDraftQueryVariables>;
export const GetChatDocument = gql`
    query GetChat($input: GetChatInput!) {
  getChat(input: $input) {
    id
    name
    type
    createdBy
  }
}
    `;

/**
 * __useGetChatQuery__
 *
 * To run a query within a React component, call `useGetChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChatQuery(baseOptions: Apollo.QueryHookOptions<GetChatQuery, GetChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
      }
export function useGetChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatQuery, GetChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
        }
export type GetChatQueryHookResult = ReturnType<typeof useGetChatQuery>;
export type GetChatLazyQueryHookResult = ReturnType<typeof useGetChatLazyQuery>;
export type GetChatQueryResult = Apollo.QueryResult<GetChatQuery, GetChatQueryVariables>;
export const ListChatMessagesDocument = gql`
    query ListChatMessages($input: ListChatMessagesInput!) {
  listChatMessages(input: $input) {
    items {
      ...ChatMessageParts
    }
    nextCursor
    prevCursor
  }
}
    ${ChatMessagePartsFragmentDoc}`;

/**
 * __useListChatMessagesQuery__
 *
 * To run a query within a React component, call `useListChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChatMessagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<ListChatMessagesQuery, ListChatMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListChatMessagesQuery, ListChatMessagesQueryVariables>(ListChatMessagesDocument, options);
      }
export function useListChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListChatMessagesQuery, ListChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListChatMessagesQuery, ListChatMessagesQueryVariables>(ListChatMessagesDocument, options);
        }
export type ListChatMessagesQueryHookResult = ReturnType<typeof useListChatMessagesQuery>;
export type ListChatMessagesLazyQueryHookResult = ReturnType<typeof useListChatMessagesLazyQuery>;
export type ListChatMessagesQueryResult = Apollo.QueryResult<ListChatMessagesQuery, ListChatMessagesQueryVariables>;
export const CreateChatMessageDocument = gql`
    mutation CreateChatMessage($input: CreateChatMessageInput!) {
  createChatMessage(input: $input) {
    ...ChatMessageParts
  }
}
    ${ChatMessagePartsFragmentDoc}`;
export type CreateChatMessageMutationFn = Apollo.MutationFunction<CreateChatMessageMutation, CreateChatMessageMutationVariables>;

/**
 * __useCreateChatMessageMutation__
 *
 * To run a mutation, you first call `useCreateChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMessageMutation, { data, loading, error }] = useCreateChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatMessageMutation, CreateChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatMessageMutation, CreateChatMessageMutationVariables>(CreateChatMessageDocument, options);
      }
export type CreateChatMessageMutationHookResult = ReturnType<typeof useCreateChatMessageMutation>;
export type CreateChatMessageMutationResult = Apollo.MutationResult<CreateChatMessageMutation>;
export type CreateChatMessageMutationOptions = Apollo.BaseMutationOptions<CreateChatMessageMutation, CreateChatMessageMutationVariables>;
export const UpdateChatMessageDocument = gql`
    mutation UpdateChatMessage($input: UpdateChatMessageInput!) {
  updateChatMessage(input: $input) {
    ...ChatMessageParts
  }
}
    ${ChatMessagePartsFragmentDoc}`;
export type UpdateChatMessageMutationFn = Apollo.MutationFunction<UpdateChatMessageMutation, UpdateChatMessageMutationVariables>;

/**
 * __useUpdateChatMessageMutation__
 *
 * To run a mutation, you first call `useUpdateChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatMessageMutation, { data, loading, error }] = useUpdateChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChatMessageMutation, UpdateChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChatMessageMutation, UpdateChatMessageMutationVariables>(UpdateChatMessageDocument, options);
      }
export type UpdateChatMessageMutationHookResult = ReturnType<typeof useUpdateChatMessageMutation>;
export type UpdateChatMessageMutationResult = Apollo.MutationResult<UpdateChatMessageMutation>;
export type UpdateChatMessageMutationOptions = Apollo.BaseMutationOptions<UpdateChatMessageMutation, UpdateChatMessageMutationVariables>;
export const SubscribeToChatMessagesDocument = gql`
    subscription SubscribeToChatMessages($input: SubscribeToChatMessagesInput!) {
  subscribeToChatMessages(input: $input) {
    ...ChatMessageParts
  }
}
    ${ChatMessagePartsFragmentDoc}`;

/**
 * __useSubscribeToChatMessagesSubscription__
 *
 * To run a query within a React component, call `useSubscribeToChatMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToChatMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToChatMessagesSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToChatMessagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToChatMessagesSubscription, SubscribeToChatMessagesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToChatMessagesSubscription, SubscribeToChatMessagesSubscriptionVariables>(SubscribeToChatMessagesDocument, options);
      }
export type SubscribeToChatMessagesSubscriptionHookResult = ReturnType<typeof useSubscribeToChatMessagesSubscription>;
export type SubscribeToChatMessagesSubscriptionResult = Apollo.SubscriptionResult<SubscribeToChatMessagesSubscription>;
export const RequestExportDocument = gql`
    mutation RequestExport($input: ExportDataInput!) {
  requestExport(input: $input)
}
    `;
export type RequestExportMutationFn = Apollo.MutationFunction<RequestExportMutation, RequestExportMutationVariables>;

/**
 * __useRequestExportMutation__
 *
 * To run a mutation, you first call `useRequestExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestExportMutation, { data, loading, error }] = useRequestExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestExportMutation(baseOptions?: Apollo.MutationHookOptions<RequestExportMutation, RequestExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestExportMutation, RequestExportMutationVariables>(RequestExportDocument, options);
      }
export type RequestExportMutationHookResult = ReturnType<typeof useRequestExportMutation>;
export type RequestExportMutationResult = Apollo.MutationResult<RequestExportMutation>;
export type RequestExportMutationOptions = Apollo.BaseMutationOptions<RequestExportMutation, RequestExportMutationVariables>;
export const GetDirectConnectSyncDataDocument = gql`
    query GetDirectConnectSyncData($input: DirectConnectGetSyncDataInput!) {
  getDirectConnectSyncData(input: $input) {
    ...DirectConnectGetSyncDataResponseParts
  }
}
    ${DirectConnectGetSyncDataResponsePartsFragmentDoc}`;

/**
 * __useGetDirectConnectSyncDataQuery__
 *
 * To run a query within a React component, call `useGetDirectConnectSyncDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectConnectSyncDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectConnectSyncDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDirectConnectSyncDataQuery(baseOptions: Apollo.QueryHookOptions<GetDirectConnectSyncDataQuery, GetDirectConnectSyncDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectConnectSyncDataQuery, GetDirectConnectSyncDataQueryVariables>(GetDirectConnectSyncDataDocument, options);
      }
export function useGetDirectConnectSyncDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectConnectSyncDataQuery, GetDirectConnectSyncDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectConnectSyncDataQuery, GetDirectConnectSyncDataQueryVariables>(GetDirectConnectSyncDataDocument, options);
        }
export type GetDirectConnectSyncDataQueryHookResult = ReturnType<typeof useGetDirectConnectSyncDataQuery>;
export type GetDirectConnectSyncDataLazyQueryHookResult = ReturnType<typeof useGetDirectConnectSyncDataLazyQuery>;
export type GetDirectConnectSyncDataQueryResult = Apollo.QueryResult<GetDirectConnectSyncDataQuery, GetDirectConnectSyncDataQueryVariables>;
export const ProvisionDirectConnectMachineDocument = gql`
    mutation ProvisionDirectConnectMachine($input: DirectConnectProvisionMachineInput!) {
  provisionDirectConnectMachine(input: $input) {
    ...DirectConnectProvisionMachineResponseParts
  }
}
    ${DirectConnectProvisionMachineResponsePartsFragmentDoc}`;
export type ProvisionDirectConnectMachineMutationFn = Apollo.MutationFunction<ProvisionDirectConnectMachineMutation, ProvisionDirectConnectMachineMutationVariables>;

/**
 * __useProvisionDirectConnectMachineMutation__
 *
 * To run a mutation, you first call `useProvisionDirectConnectMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionDirectConnectMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionDirectConnectMachineMutation, { data, loading, error }] = useProvisionDirectConnectMachineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionDirectConnectMachineMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionDirectConnectMachineMutation, ProvisionDirectConnectMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionDirectConnectMachineMutation, ProvisionDirectConnectMachineMutationVariables>(ProvisionDirectConnectMachineDocument, options);
      }
export type ProvisionDirectConnectMachineMutationHookResult = ReturnType<typeof useProvisionDirectConnectMachineMutation>;
export type ProvisionDirectConnectMachineMutationResult = Apollo.MutationResult<ProvisionDirectConnectMachineMutation>;
export type ProvisionDirectConnectMachineMutationOptions = Apollo.BaseMutationOptions<ProvisionDirectConnectMachineMutation, ProvisionDirectConnectMachineMutationVariables>;
export const SyncDirectConnectDataDocument = gql`
    mutation SyncDirectConnectData($input: DirectConnectSyncDataInput!) {
  syncDirectConnectData(input: $input) {
    ...DirectConnectSyncDataResponseParts
  }
}
    ${DirectConnectSyncDataResponsePartsFragmentDoc}`;
export type SyncDirectConnectDataMutationFn = Apollo.MutationFunction<SyncDirectConnectDataMutation, SyncDirectConnectDataMutationVariables>;

/**
 * __useSyncDirectConnectDataMutation__
 *
 * To run a mutation, you first call `useSyncDirectConnectDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncDirectConnectDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncDirectConnectDataMutation, { data, loading, error }] = useSyncDirectConnectDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncDirectConnectDataMutation(baseOptions?: Apollo.MutationHookOptions<SyncDirectConnectDataMutation, SyncDirectConnectDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncDirectConnectDataMutation, SyncDirectConnectDataMutationVariables>(SyncDirectConnectDataDocument, options);
      }
export type SyncDirectConnectDataMutationHookResult = ReturnType<typeof useSyncDirectConnectDataMutation>;
export type SyncDirectConnectDataMutationResult = Apollo.MutationResult<SyncDirectConnectDataMutation>;
export type SyncDirectConnectDataMutationOptions = Apollo.BaseMutationOptions<SyncDirectConnectDataMutation, SyncDirectConnectDataMutationVariables>;
export const AuthenticateWithPinCodeDocument = gql`
    mutation AuthenticateWithPinCode($input: PinCodeAuthenticationRequest!) {
  authenticateWithPinCode(input: $input) {
    expiresAt
    sessionId
    userId
  }
}
    `;
export type AuthenticateWithPinCodeMutationFn = Apollo.MutationFunction<AuthenticateWithPinCodeMutation, AuthenticateWithPinCodeMutationVariables>;

/**
 * __useAuthenticateWithPinCodeMutation__
 *
 * To run a mutation, you first call `useAuthenticateWithPinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateWithPinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateWithPinCodeMutation, { data, loading, error }] = useAuthenticateWithPinCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticateWithPinCodeMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateWithPinCodeMutation, AuthenticateWithPinCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateWithPinCodeMutation, AuthenticateWithPinCodeMutationVariables>(AuthenticateWithPinCodeDocument, options);
      }
export type AuthenticateWithPinCodeMutationHookResult = ReturnType<typeof useAuthenticateWithPinCodeMutation>;
export type AuthenticateWithPinCodeMutationResult = Apollo.MutationResult<AuthenticateWithPinCodeMutation>;
export type AuthenticateWithPinCodeMutationOptions = Apollo.BaseMutationOptions<AuthenticateWithPinCodeMutation, AuthenticateWithPinCodeMutationVariables>;
export const GetEventNotificationUnreadCountDocument = gql`
    query GetEventNotificationUnreadCount {
  getEventNotificationUnreadCount
}
    `;

/**
 * __useGetEventNotificationUnreadCountQuery__
 *
 * To run a query within a React component, call `useGetEventNotificationUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventNotificationUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventNotificationUnreadCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEventNotificationUnreadCountQuery(baseOptions?: Apollo.QueryHookOptions<GetEventNotificationUnreadCountQuery, GetEventNotificationUnreadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventNotificationUnreadCountQuery, GetEventNotificationUnreadCountQueryVariables>(GetEventNotificationUnreadCountDocument, options);
      }
export function useGetEventNotificationUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventNotificationUnreadCountQuery, GetEventNotificationUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventNotificationUnreadCountQuery, GetEventNotificationUnreadCountQueryVariables>(GetEventNotificationUnreadCountDocument, options);
        }
export type GetEventNotificationUnreadCountQueryHookResult = ReturnType<typeof useGetEventNotificationUnreadCountQuery>;
export type GetEventNotificationUnreadCountLazyQueryHookResult = ReturnType<typeof useGetEventNotificationUnreadCountLazyQuery>;
export type GetEventNotificationUnreadCountQueryResult = Apollo.QueryResult<GetEventNotificationUnreadCountQuery, GetEventNotificationUnreadCountQueryVariables>;
export const ListEventNotificationsDocument = gql`
    query ListEventNotifications($input: ListEventNotificationsInput!) {
  listEventNotifications(input: $input) {
    total
    items {
      ...EventNotificationParts
    }
  }
}
    ${EventNotificationPartsFragmentDoc}`;

/**
 * __useListEventNotificationsQuery__
 *
 * To run a query within a React component, call `useListEventNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventNotificationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListEventNotificationsQuery(baseOptions: Apollo.QueryHookOptions<ListEventNotificationsQuery, ListEventNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEventNotificationsQuery, ListEventNotificationsQueryVariables>(ListEventNotificationsDocument, options);
      }
export function useListEventNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEventNotificationsQuery, ListEventNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEventNotificationsQuery, ListEventNotificationsQueryVariables>(ListEventNotificationsDocument, options);
        }
export type ListEventNotificationsQueryHookResult = ReturnType<typeof useListEventNotificationsQuery>;
export type ListEventNotificationsLazyQueryHookResult = ReturnType<typeof useListEventNotificationsLazyQuery>;
export type ListEventNotificationsQueryResult = Apollo.QueryResult<ListEventNotificationsQuery, ListEventNotificationsQueryVariables>;
export const MarkEventNotificationsReadDocument = gql`
    mutation MarkEventNotificationsRead($input: MarkEventNotificationsReadInput!) {
  markEventNotificationsRead(input: $input)
}
    `;
export type MarkEventNotificationsReadMutationFn = Apollo.MutationFunction<MarkEventNotificationsReadMutation, MarkEventNotificationsReadMutationVariables>;

/**
 * __useMarkEventNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkEventNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEventNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEventNotificationsReadMutation, { data, loading, error }] = useMarkEventNotificationsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkEventNotificationsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkEventNotificationsReadMutation, MarkEventNotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkEventNotificationsReadMutation, MarkEventNotificationsReadMutationVariables>(MarkEventNotificationsReadDocument, options);
      }
export type MarkEventNotificationsReadMutationHookResult = ReturnType<typeof useMarkEventNotificationsReadMutation>;
export type MarkEventNotificationsReadMutationResult = Apollo.MutationResult<MarkEventNotificationsReadMutation>;
export type MarkEventNotificationsReadMutationOptions = Apollo.BaseMutationOptions<MarkEventNotificationsReadMutation, MarkEventNotificationsReadMutationVariables>;
export const SubscribeToEventNotificationUnreadCountDocument = gql`
    subscription SubscribeToEventNotificationUnreadCount {
  subscribeToEventNotificationUnreadCount
}
    `;

/**
 * __useSubscribeToEventNotificationUnreadCountSubscription__
 *
 * To run a query within a React component, call `useSubscribeToEventNotificationUnreadCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToEventNotificationUnreadCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToEventNotificationUnreadCountSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSubscribeToEventNotificationUnreadCountSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeToEventNotificationUnreadCountSubscription, SubscribeToEventNotificationUnreadCountSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToEventNotificationUnreadCountSubscription, SubscribeToEventNotificationUnreadCountSubscriptionVariables>(SubscribeToEventNotificationUnreadCountDocument, options);
      }
export type SubscribeToEventNotificationUnreadCountSubscriptionHookResult = ReturnType<typeof useSubscribeToEventNotificationUnreadCountSubscription>;
export type SubscribeToEventNotificationUnreadCountSubscriptionResult = Apollo.SubscriptionResult<SubscribeToEventNotificationUnreadCountSubscription>;
export const ListEventDefinitionsDocument = gql`
    query ListEventDefinitions($input: ListEventDefinitionsInput!) {
  listEventDefinitions(input: $input) {
    total
    items {
      ...EventDefinitionParts
      subscriptions {
        id
      }
    }
  }
}
    ${EventDefinitionPartsFragmentDoc}`;

/**
 * __useListEventDefinitionsQuery__
 *
 * To run a query within a React component, call `useListEventDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventDefinitionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListEventDefinitionsQuery(baseOptions: Apollo.QueryHookOptions<ListEventDefinitionsQuery, ListEventDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEventDefinitionsQuery, ListEventDefinitionsQueryVariables>(ListEventDefinitionsDocument, options);
      }
export function useListEventDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEventDefinitionsQuery, ListEventDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEventDefinitionsQuery, ListEventDefinitionsQueryVariables>(ListEventDefinitionsDocument, options);
        }
export type ListEventDefinitionsQueryHookResult = ReturnType<typeof useListEventDefinitionsQuery>;
export type ListEventDefinitionsLazyQueryHookResult = ReturnType<typeof useListEventDefinitionsLazyQuery>;
export type ListEventDefinitionsQueryResult = Apollo.QueryResult<ListEventDefinitionsQuery, ListEventDefinitionsQueryVariables>;
export const GetEventDefinitionDocument = gql`
    query GetEventDefinition($input: GetEventDefinitionInput!) {
  getEventDefinition(input: $input) {
    ...EventDefinitionParts
  }
}
    ${EventDefinitionPartsFragmentDoc}`;

/**
 * __useGetEventDefinitionQuery__
 *
 * To run a query within a React component, call `useGetEventDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventDefinitionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEventDefinitionQuery(baseOptions: Apollo.QueryHookOptions<GetEventDefinitionQuery, GetEventDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventDefinitionQuery, GetEventDefinitionQueryVariables>(GetEventDefinitionDocument, options);
      }
export function useGetEventDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventDefinitionQuery, GetEventDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventDefinitionQuery, GetEventDefinitionQueryVariables>(GetEventDefinitionDocument, options);
        }
export type GetEventDefinitionQueryHookResult = ReturnType<typeof useGetEventDefinitionQuery>;
export type GetEventDefinitionLazyQueryHookResult = ReturnType<typeof useGetEventDefinitionLazyQuery>;
export type GetEventDefinitionQueryResult = Apollo.QueryResult<GetEventDefinitionQuery, GetEventDefinitionQueryVariables>;
export const ListEventSubscriptionsDocument = gql`
    query ListEventSubscriptions($input: ListEventSubscriptionsInput!) {
  listEventSubscriptions(input: $input) {
    total
    items {
      ...EventSubscriptionParts
    }
  }
}
    ${EventSubscriptionPartsFragmentDoc}`;

/**
 * __useListEventSubscriptionsQuery__
 *
 * To run a query within a React component, call `useListEventSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventSubscriptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListEventSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<ListEventSubscriptionsQuery, ListEventSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEventSubscriptionsQuery, ListEventSubscriptionsQueryVariables>(ListEventSubscriptionsDocument, options);
      }
export function useListEventSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEventSubscriptionsQuery, ListEventSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEventSubscriptionsQuery, ListEventSubscriptionsQueryVariables>(ListEventSubscriptionsDocument, options);
        }
export type ListEventSubscriptionsQueryHookResult = ReturnType<typeof useListEventSubscriptionsQuery>;
export type ListEventSubscriptionsLazyQueryHookResult = ReturnType<typeof useListEventSubscriptionsLazyQuery>;
export type ListEventSubscriptionsQueryResult = Apollo.QueryResult<ListEventSubscriptionsQuery, ListEventSubscriptionsQueryVariables>;
export const ListEventChannelsDocument = gql`
    query ListEventChannels($input: ListEventChannelsInput!) {
  listEventChannels(input: $input) {
    total
    items {
      ...EventChannelParts
    }
  }
}
    ${EventChannelPartsFragmentDoc}`;

/**
 * __useListEventChannelsQuery__
 *
 * To run a query within a React component, call `useListEventChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventChannelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListEventChannelsQuery(baseOptions: Apollo.QueryHookOptions<ListEventChannelsQuery, ListEventChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEventChannelsQuery, ListEventChannelsQueryVariables>(ListEventChannelsDocument, options);
      }
export function useListEventChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEventChannelsQuery, ListEventChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEventChannelsQuery, ListEventChannelsQueryVariables>(ListEventChannelsDocument, options);
        }
export type ListEventChannelsQueryHookResult = ReturnType<typeof useListEventChannelsQuery>;
export type ListEventChannelsLazyQueryHookResult = ReturnType<typeof useListEventChannelsLazyQuery>;
export type ListEventChannelsQueryResult = Apollo.QueryResult<ListEventChannelsQuery, ListEventChannelsQueryVariables>;
export const CreateEventChannelDocument = gql`
    mutation CreateEventChannel($input: CreateEventChannelInput!) {
  createEventChannel(input: $input) {
    ...EventChannelParts
  }
}
    ${EventChannelPartsFragmentDoc}`;
export type CreateEventChannelMutationFn = Apollo.MutationFunction<CreateEventChannelMutation, CreateEventChannelMutationVariables>;

/**
 * __useCreateEventChannelMutation__
 *
 * To run a mutation, you first call `useCreateEventChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventChannelMutation, { data, loading, error }] = useCreateEventChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventChannelMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventChannelMutation, CreateEventChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventChannelMutation, CreateEventChannelMutationVariables>(CreateEventChannelDocument, options);
      }
export type CreateEventChannelMutationHookResult = ReturnType<typeof useCreateEventChannelMutation>;
export type CreateEventChannelMutationResult = Apollo.MutationResult<CreateEventChannelMutation>;
export type CreateEventChannelMutationOptions = Apollo.BaseMutationOptions<CreateEventChannelMutation, CreateEventChannelMutationVariables>;
export const CreateEventSubscriptionDocument = gql`
    mutation CreateEventSubscription($input: CreateEventSubscriptionInput!) {
  createEventSubscription(input: $input) {
    id
  }
}
    `;
export type CreateEventSubscriptionMutationFn = Apollo.MutationFunction<CreateEventSubscriptionMutation, CreateEventSubscriptionMutationVariables>;

/**
 * __useCreateEventSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateEventSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventSubscriptionMutation, { data, loading, error }] = useCreateEventSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventSubscriptionMutation, CreateEventSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventSubscriptionMutation, CreateEventSubscriptionMutationVariables>(CreateEventSubscriptionDocument, options);
      }
export type CreateEventSubscriptionMutationHookResult = ReturnType<typeof useCreateEventSubscriptionMutation>;
export type CreateEventSubscriptionMutationResult = Apollo.MutationResult<CreateEventSubscriptionMutation>;
export type CreateEventSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateEventSubscriptionMutation, CreateEventSubscriptionMutationVariables>;
export const RemoveEventSubscriptionDocument = gql`
    mutation RemoveEventSubscription($input: RemoveEventSubscriptionInput!) {
  removeEventSubscription(input: $input)
}
    `;
export type RemoveEventSubscriptionMutationFn = Apollo.MutationFunction<RemoveEventSubscriptionMutation, RemoveEventSubscriptionMutationVariables>;

/**
 * __useRemoveEventSubscriptionMutation__
 *
 * To run a mutation, you first call `useRemoveEventSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventSubscriptionMutation, { data, loading, error }] = useRemoveEventSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveEventSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventSubscriptionMutation, RemoveEventSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventSubscriptionMutation, RemoveEventSubscriptionMutationVariables>(RemoveEventSubscriptionDocument, options);
      }
export type RemoveEventSubscriptionMutationHookResult = ReturnType<typeof useRemoveEventSubscriptionMutation>;
export type RemoveEventSubscriptionMutationResult = Apollo.MutationResult<RemoveEventSubscriptionMutation>;
export type RemoveEventSubscriptionMutationOptions = Apollo.BaseMutationOptions<RemoveEventSubscriptionMutation, RemoveEventSubscriptionMutationVariables>;
export const RemoveEventChannelDocument = gql`
    mutation RemoveEventChannel($input: RemoveEventChannelInput!) {
  removeEventChannel(input: $input) {
    ...EventChannelParts
  }
}
    ${EventChannelPartsFragmentDoc}`;
export type RemoveEventChannelMutationFn = Apollo.MutationFunction<RemoveEventChannelMutation, RemoveEventChannelMutationVariables>;

/**
 * __useRemoveEventChannelMutation__
 *
 * To run a mutation, you first call `useRemoveEventChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventChannelMutation, { data, loading, error }] = useRemoveEventChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveEventChannelMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventChannelMutation, RemoveEventChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventChannelMutation, RemoveEventChannelMutationVariables>(RemoveEventChannelDocument, options);
      }
export type RemoveEventChannelMutationHookResult = ReturnType<typeof useRemoveEventChannelMutation>;
export type RemoveEventChannelMutationResult = Apollo.MutationResult<RemoveEventChannelMutation>;
export type RemoveEventChannelMutationOptions = Apollo.BaseMutationOptions<RemoveEventChannelMutation, RemoveEventChannelMutationVariables>;
export const RegisterUserDeviceDocument = gql`
    mutation RegisterUserDevice($input: RegisterUserDeviceInput!) {
  registerUserDevice(input: $input)
}
    `;
export type RegisterUserDeviceMutationFn = Apollo.MutationFunction<RegisterUserDeviceMutation, RegisterUserDeviceMutationVariables>;

/**
 * __useRegisterUserDeviceMutation__
 *
 * To run a mutation, you first call `useRegisterUserDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserDeviceMutation, { data, loading, error }] = useRegisterUserDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserDeviceMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserDeviceMutation, RegisterUserDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserDeviceMutation, RegisterUserDeviceMutationVariables>(RegisterUserDeviceDocument, options);
      }
export type RegisterUserDeviceMutationHookResult = ReturnType<typeof useRegisterUserDeviceMutation>;
export type RegisterUserDeviceMutationResult = Apollo.MutationResult<RegisterUserDeviceMutation>;
export type RegisterUserDeviceMutationOptions = Apollo.BaseMutationOptions<RegisterUserDeviceMutation, RegisterUserDeviceMutationVariables>;
export const UpdateEventDefinitionDocument = gql`
    mutation UpdateEventDefinition($input: UpdateEventDefinitionInput!) {
  updateEventDefinition(input: $input) {
    ...EventDefinitionParts
  }
}
    ${EventDefinitionPartsFragmentDoc}`;
export type UpdateEventDefinitionMutationFn = Apollo.MutationFunction<UpdateEventDefinitionMutation, UpdateEventDefinitionMutationVariables>;

/**
 * __useUpdateEventDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateEventDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventDefinitionMutation, { data, loading, error }] = useUpdateEventDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventDefinitionMutation, UpdateEventDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventDefinitionMutation, UpdateEventDefinitionMutationVariables>(UpdateEventDefinitionDocument, options);
      }
export type UpdateEventDefinitionMutationHookResult = ReturnType<typeof useUpdateEventDefinitionMutation>;
export type UpdateEventDefinitionMutationResult = Apollo.MutationResult<UpdateEventDefinitionMutation>;
export type UpdateEventDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdateEventDefinitionMutation, UpdateEventDefinitionMutationVariables>;
export const UpdateEventChannelDocument = gql`
    mutation UpdateEventChannel($input: UpdateEventChannelInput!) {
  updateEventChannel(input: $input) {
    ...EventChannelParts
  }
}
    ${EventChannelPartsFragmentDoc}`;
export type UpdateEventChannelMutationFn = Apollo.MutationFunction<UpdateEventChannelMutation, UpdateEventChannelMutationVariables>;

/**
 * __useUpdateEventChannelMutation__
 *
 * To run a mutation, you first call `useUpdateEventChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventChannelMutation, { data, loading, error }] = useUpdateEventChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventChannelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventChannelMutation, UpdateEventChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventChannelMutation, UpdateEventChannelMutationVariables>(UpdateEventChannelDocument, options);
      }
export type UpdateEventChannelMutationHookResult = ReturnType<typeof useUpdateEventChannelMutation>;
export type UpdateEventChannelMutationResult = Apollo.MutationResult<UpdateEventChannelMutation>;
export type UpdateEventChannelMutationOptions = Apollo.BaseMutationOptions<UpdateEventChannelMutation, UpdateEventChannelMutationVariables>;
export const GetFeaturesDocument = gql`
    query GetFeatures($input: GetFeaturesInput!) {
  getFeatures(input: $input)
}
    `;

/**
 * __useGetFeaturesQuery__
 *
 * To run a query within a React component, call `useGetFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFeaturesQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
      }
export function useGetFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
        }
export type GetFeaturesQueryHookResult = ReturnType<typeof useGetFeaturesQuery>;
export type GetFeaturesLazyQueryHookResult = ReturnType<typeof useGetFeaturesLazyQuery>;
export type GetFeaturesQueryResult = Apollo.QueryResult<GetFeaturesQuery, GetFeaturesQueryVariables>;
export const SubscribeToFeaturesDocument = gql`
    subscription SubscribeToFeatures {
  subscribeToFeatures
}
    `;

/**
 * __useSubscribeToFeaturesSubscription__
 *
 * To run a query within a React component, call `useSubscribeToFeaturesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToFeaturesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToFeaturesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSubscribeToFeaturesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeToFeaturesSubscription, SubscribeToFeaturesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToFeaturesSubscription, SubscribeToFeaturesSubscriptionVariables>(SubscribeToFeaturesDocument, options);
      }
export type SubscribeToFeaturesSubscriptionHookResult = ReturnType<typeof useSubscribeToFeaturesSubscription>;
export type SubscribeToFeaturesSubscriptionResult = Apollo.SubscriptionResult<SubscribeToFeaturesSubscription>;
export const CreateFileUploadUrlDocument = gql`
    mutation CreateFileUploadUrl($input: CreateFileUploadInput!) {
  createFileUploadUrl(input: $input) {
    expires
    fields
    key
    modifiedKey
    url
  }
}
    `;
export type CreateFileUploadUrlMutationFn = Apollo.MutationFunction<CreateFileUploadUrlMutation, CreateFileUploadUrlMutationVariables>;

/**
 * __useCreateFileUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateFileUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileUploadUrlMutation, { data, loading, error }] = useCreateFileUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFileUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileUploadUrlMutation, CreateFileUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileUploadUrlMutation, CreateFileUploadUrlMutationVariables>(CreateFileUploadUrlDocument, options);
      }
export type CreateFileUploadUrlMutationHookResult = ReturnType<typeof useCreateFileUploadUrlMutation>;
export type CreateFileUploadUrlMutationResult = Apollo.MutationResult<CreateFileUploadUrlMutation>;
export type CreateFileUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateFileUploadUrlMutation, CreateFileUploadUrlMutationVariables>;
export const BuildFormDocument = gql`
    query BuildForm($input: BuildFormInput!) {
  buildForm(input: $input) {
    form {
      ...FormParts
    }
    values
  }
}
    ${FormPartsFragmentDoc}`;

/**
 * __useBuildFormQuery__
 *
 * To run a query within a React component, call `useBuildFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildFormQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuildFormQuery(baseOptions: Apollo.QueryHookOptions<BuildFormQuery, BuildFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildFormQuery, BuildFormQueryVariables>(BuildFormDocument, options);
      }
export function useBuildFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildFormQuery, BuildFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildFormQuery, BuildFormQueryVariables>(BuildFormDocument, options);
        }
export type BuildFormQueryHookResult = ReturnType<typeof useBuildFormQuery>;
export type BuildFormLazyQueryHookResult = ReturnType<typeof useBuildFormLazyQuery>;
export type BuildFormQueryResult = Apollo.QueryResult<BuildFormQuery, BuildFormQueryVariables>;
export const UpdateMachineBindingContextDocument = gql`
    mutation UpdateMachineBindingContext($input: UpdateMachineBindingContextInput!) {
  updateMachineBindingContext(input: $input)
}
    `;
export type UpdateMachineBindingContextMutationFn = Apollo.MutationFunction<UpdateMachineBindingContextMutation, UpdateMachineBindingContextMutationVariables>;

/**
 * __useUpdateMachineBindingContextMutation__
 *
 * To run a mutation, you first call `useUpdateMachineBindingContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMachineBindingContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMachineBindingContextMutation, { data, loading, error }] = useUpdateMachineBindingContextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMachineBindingContextMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMachineBindingContextMutation, UpdateMachineBindingContextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMachineBindingContextMutation, UpdateMachineBindingContextMutationVariables>(UpdateMachineBindingContextDocument, options);
      }
export type UpdateMachineBindingContextMutationHookResult = ReturnType<typeof useUpdateMachineBindingContextMutation>;
export type UpdateMachineBindingContextMutationResult = Apollo.MutationResult<UpdateMachineBindingContextMutation>;
export type UpdateMachineBindingContextMutationOptions = Apollo.BaseMutationOptions<UpdateMachineBindingContextMutation, UpdateMachineBindingContextMutationVariables>;
export const SubscribeToMachineBindingResultDocument = gql`
    subscription SubscribeToMachineBindingResult($input: SubscribeToMachineBindingResultInput!) {
  subscribeToMachineBindingResult(input: $input) {
    bindingId
    machineId
    data
  }
}
    `;

/**
 * __useSubscribeToMachineBindingResultSubscription__
 *
 * To run a query within a React component, call `useSubscribeToMachineBindingResultSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToMachineBindingResultSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToMachineBindingResultSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToMachineBindingResultSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToMachineBindingResultSubscription, SubscribeToMachineBindingResultSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToMachineBindingResultSubscription, SubscribeToMachineBindingResultSubscriptionVariables>(SubscribeToMachineBindingResultDocument, options);
      }
export type SubscribeToMachineBindingResultSubscriptionHookResult = ReturnType<typeof useSubscribeToMachineBindingResultSubscription>;
export type SubscribeToMachineBindingResultSubscriptionResult = Apollo.SubscriptionResult<SubscribeToMachineBindingResultSubscription>;
export const RegisterAndSubscribeToMachineBindingDocument = gql`
    subscription RegisterAndSubscribeToMachineBinding($input: RegisterAndSubscribeToMachineBindingInput!) {
  registerAndSubscribeToMachineBindingResult(input: $input) {
    bindingId
    machineId
    data
  }
}
    `;

/**
 * __useRegisterAndSubscribeToMachineBindingSubscription__
 *
 * To run a query within a React component, call `useRegisterAndSubscribeToMachineBindingSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRegisterAndSubscribeToMachineBindingSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterAndSubscribeToMachineBindingSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterAndSubscribeToMachineBindingSubscription(baseOptions: Apollo.SubscriptionHookOptions<RegisterAndSubscribeToMachineBindingSubscription, RegisterAndSubscribeToMachineBindingSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RegisterAndSubscribeToMachineBindingSubscription, RegisterAndSubscribeToMachineBindingSubscriptionVariables>(RegisterAndSubscribeToMachineBindingDocument, options);
      }
export type RegisterAndSubscribeToMachineBindingSubscriptionHookResult = ReturnType<typeof useRegisterAndSubscribeToMachineBindingSubscription>;
export type RegisterAndSubscribeToMachineBindingSubscriptionResult = Apollo.SubscriptionResult<RegisterAndSubscribeToMachineBindingSubscription>;
export const ListMachineFilesDocument = gql`
    query ListMachineFiles($input: ListMachineFilesInput!) {
  listMachineFiles(input: $input) {
    total
    items {
      ...MachineFileParts
    }
  }
}
    ${MachineFilePartsFragmentDoc}`;

/**
 * __useListMachineFilesQuery__
 *
 * To run a query within a React component, call `useListMachineFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMachineFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMachineFilesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListMachineFilesQuery(baseOptions: Apollo.QueryHookOptions<ListMachineFilesQuery, ListMachineFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMachineFilesQuery, ListMachineFilesQueryVariables>(ListMachineFilesDocument, options);
      }
export function useListMachineFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMachineFilesQuery, ListMachineFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMachineFilesQuery, ListMachineFilesQueryVariables>(ListMachineFilesDocument, options);
        }
export type ListMachineFilesQueryHookResult = ReturnType<typeof useListMachineFilesQuery>;
export type ListMachineFilesLazyQueryHookResult = ReturnType<typeof useListMachineFilesLazyQuery>;
export type ListMachineFilesQueryResult = Apollo.QueryResult<ListMachineFilesQuery, ListMachineFilesQueryVariables>;
export const GetMachineFileLinkDocument = gql`
    query GetMachineFileLink($input: GetMachineFileLinkInput!) {
  getMachineFileLink(input: $input) {
    expiration
    url
  }
}
    `;

/**
 * __useGetMachineFileLinkQuery__
 *
 * To run a query within a React component, call `useGetMachineFileLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineFileLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineFileLinkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMachineFileLinkQuery(baseOptions: Apollo.QueryHookOptions<GetMachineFileLinkQuery, GetMachineFileLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMachineFileLinkQuery, GetMachineFileLinkQueryVariables>(GetMachineFileLinkDocument, options);
      }
export function useGetMachineFileLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachineFileLinkQuery, GetMachineFileLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMachineFileLinkQuery, GetMachineFileLinkQueryVariables>(GetMachineFileLinkDocument, options);
        }
export type GetMachineFileLinkQueryHookResult = ReturnType<typeof useGetMachineFileLinkQuery>;
export type GetMachineFileLinkLazyQueryHookResult = ReturnType<typeof useGetMachineFileLinkLazyQuery>;
export type GetMachineFileLinkQueryResult = Apollo.QueryResult<GetMachineFileLinkQuery, GetMachineFileLinkQueryVariables>;
export const SyncFilesToMachineDocument = gql`
    mutation SyncFilesToMachine($input: SyncFilesToMachineInput!) {
  syncFilesToMachine(input: $input)
}
    `;
export type SyncFilesToMachineMutationFn = Apollo.MutationFunction<SyncFilesToMachineMutation, SyncFilesToMachineMutationVariables>;

/**
 * __useSyncFilesToMachineMutation__
 *
 * To run a mutation, you first call `useSyncFilesToMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncFilesToMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncFilesToMachineMutation, { data, loading, error }] = useSyncFilesToMachineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncFilesToMachineMutation(baseOptions?: Apollo.MutationHookOptions<SyncFilesToMachineMutation, SyncFilesToMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncFilesToMachineMutation, SyncFilesToMachineMutationVariables>(SyncFilesToMachineDocument, options);
      }
export type SyncFilesToMachineMutationHookResult = ReturnType<typeof useSyncFilesToMachineMutation>;
export type SyncFilesToMachineMutationResult = Apollo.MutationResult<SyncFilesToMachineMutation>;
export type SyncFilesToMachineMutationOptions = Apollo.BaseMutationOptions<SyncFilesToMachineMutation, SyncFilesToMachineMutationVariables>;
export const SubscribeToFilesDocument = gql`
    subscription SubscribeToFiles($input: SubscribeToFilesInput!) {
  subscribeToFiles(input: $input) {
    ...MachineFileParts
  }
}
    ${MachineFilePartsFragmentDoc}`;

/**
 * __useSubscribeToFilesSubscription__
 *
 * To run a query within a React component, call `useSubscribeToFilesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToFilesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToFilesSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToFilesSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToFilesSubscription, SubscribeToFilesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToFilesSubscription, SubscribeToFilesSubscriptionVariables>(SubscribeToFilesDocument, options);
      }
export type SubscribeToFilesSubscriptionHookResult = ReturnType<typeof useSubscribeToFilesSubscription>;
export type SubscribeToFilesSubscriptionResult = Apollo.SubscriptionResult<SubscribeToFilesSubscription>;
export const ListMachinesDocument = gql`
    query ListMachines($input: ListMachinesInput!) {
  listMachines(input: $input) {
    total
    items {
      ...MachineParts
    }
  }
}
    ${MachinePartsFragmentDoc}`;

/**
 * __useListMachinesQuery__
 *
 * To run a query within a React component, call `useListMachinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMachinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMachinesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListMachinesQuery(baseOptions: Apollo.QueryHookOptions<ListMachinesQuery, ListMachinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMachinesQuery, ListMachinesQueryVariables>(ListMachinesDocument, options);
      }
export function useListMachinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMachinesQuery, ListMachinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMachinesQuery, ListMachinesQueryVariables>(ListMachinesDocument, options);
        }
export type ListMachinesQueryHookResult = ReturnType<typeof useListMachinesQuery>;
export type ListMachinesLazyQueryHookResult = ReturnType<typeof useListMachinesLazyQuery>;
export type ListMachinesQueryResult = Apollo.QueryResult<ListMachinesQuery, ListMachinesQueryVariables>;
export const ListMachinesByUserDocument = gql`
    query ListMachinesByUser($input: ListMachinesByUserInput!) {
  listMachinesByUser(input: $input) {
    total
    items {
      ...MachineParts
    }
  }
}
    ${MachinePartsFragmentDoc}`;

/**
 * __useListMachinesByUserQuery__
 *
 * To run a query within a React component, call `useListMachinesByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMachinesByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMachinesByUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListMachinesByUserQuery(baseOptions: Apollo.QueryHookOptions<ListMachinesByUserQuery, ListMachinesByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMachinesByUserQuery, ListMachinesByUserQueryVariables>(ListMachinesByUserDocument, options);
      }
export function useListMachinesByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMachinesByUserQuery, ListMachinesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMachinesByUserQuery, ListMachinesByUserQueryVariables>(ListMachinesByUserDocument, options);
        }
export type ListMachinesByUserQueryHookResult = ReturnType<typeof useListMachinesByUserQuery>;
export type ListMachinesByUserLazyQueryHookResult = ReturnType<typeof useListMachinesByUserLazyQuery>;
export type ListMachinesByUserQueryResult = Apollo.QueryResult<ListMachinesByUserQuery, ListMachinesByUserQueryVariables>;
export const GetMachineDocument = gql`
    query GetMachine($input: GetMachineInput!) {
  getMachine(input: $input) {
    ...MachineParts
  }
}
    ${MachinePartsFragmentDoc}`;

/**
 * __useGetMachineQuery__
 *
 * To run a query within a React component, call `useGetMachineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMachineQuery(baseOptions: Apollo.QueryHookOptions<GetMachineQuery, GetMachineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMachineQuery, GetMachineQueryVariables>(GetMachineDocument, options);
      }
export function useGetMachineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachineQuery, GetMachineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMachineQuery, GetMachineQueryVariables>(GetMachineDocument, options);
        }
export type GetMachineQueryHookResult = ReturnType<typeof useGetMachineQuery>;
export type GetMachineLazyQueryHookResult = ReturnType<typeof useGetMachineLazyQuery>;
export type GetMachineQueryResult = Apollo.QueryResult<GetMachineQuery, GetMachineQueryVariables>;
export const UpdateMachineDocument = gql`
    mutation UpdateMachine($input: UpdateMachineInput!) {
  updateMachine(input: $input) {
    ...MachineParts
  }
}
    ${MachinePartsFragmentDoc}`;
export type UpdateMachineMutationFn = Apollo.MutationFunction<UpdateMachineMutation, UpdateMachineMutationVariables>;

/**
 * __useUpdateMachineMutation__
 *
 * To run a mutation, you first call `useUpdateMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMachineMutation, { data, loading, error }] = useUpdateMachineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMachineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMachineMutation, UpdateMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMachineMutation, UpdateMachineMutationVariables>(UpdateMachineDocument, options);
      }
export type UpdateMachineMutationHookResult = ReturnType<typeof useUpdateMachineMutation>;
export type UpdateMachineMutationResult = Apollo.MutationResult<UpdateMachineMutation>;
export type UpdateMachineMutationOptions = Apollo.BaseMutationOptions<UpdateMachineMutation, UpdateMachineMutationVariables>;
export const UpdateMachineMaintenanceDocument = gql`
    mutation UpdateMachineMaintenance($input: UpdateMachineMaintenanceInput!) {
  updateMachineMaintenance(input: $input) {
    ...MachineMaintenanceParts
  }
}
    ${MachineMaintenancePartsFragmentDoc}`;
export type UpdateMachineMaintenanceMutationFn = Apollo.MutationFunction<UpdateMachineMaintenanceMutation, UpdateMachineMaintenanceMutationVariables>;

/**
 * __useUpdateMachineMaintenanceMutation__
 *
 * To run a mutation, you first call `useUpdateMachineMaintenanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMachineMaintenanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMachineMaintenanceMutation, { data, loading, error }] = useUpdateMachineMaintenanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMachineMaintenanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMachineMaintenanceMutation, UpdateMachineMaintenanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMachineMaintenanceMutation, UpdateMachineMaintenanceMutationVariables>(UpdateMachineMaintenanceDocument, options);
      }
export type UpdateMachineMaintenanceMutationHookResult = ReturnType<typeof useUpdateMachineMaintenanceMutation>;
export type UpdateMachineMaintenanceMutationResult = Apollo.MutationResult<UpdateMachineMaintenanceMutation>;
export type UpdateMachineMaintenanceMutationOptions = Apollo.BaseMutationOptions<UpdateMachineMaintenanceMutation, UpdateMachineMaintenanceMutationVariables>;
export const DisableMachineDocument = gql`
    mutation DisableMachine($input: DisableMachineInput!) {
  disableMachine(input: $input)
}
    `;
export type DisableMachineMutationFn = Apollo.MutationFunction<DisableMachineMutation, DisableMachineMutationVariables>;

/**
 * __useDisableMachineMutation__
 *
 * To run a mutation, you first call `useDisableMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableMachineMutation, { data, loading, error }] = useDisableMachineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableMachineMutation(baseOptions?: Apollo.MutationHookOptions<DisableMachineMutation, DisableMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableMachineMutation, DisableMachineMutationVariables>(DisableMachineDocument, options);
      }
export type DisableMachineMutationHookResult = ReturnType<typeof useDisableMachineMutation>;
export type DisableMachineMutationResult = Apollo.MutationResult<DisableMachineMutation>;
export type DisableMachineMutationOptions = Apollo.BaseMutationOptions<DisableMachineMutation, DisableMachineMutationVariables>;
export const RegisterMachineDocument = gql`
    mutation RegisterMachine($input: RegisterMachineInput!) {
  registerMachine(input: $input) {
    ...MachineParts
  }
}
    ${MachinePartsFragmentDoc}`;
export type RegisterMachineMutationFn = Apollo.MutationFunction<RegisterMachineMutation, RegisterMachineMutationVariables>;

/**
 * __useRegisterMachineMutation__
 *
 * To run a mutation, you first call `useRegisterMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMachineMutation, { data, loading, error }] = useRegisterMachineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMachineMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMachineMutation, RegisterMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMachineMutation, RegisterMachineMutationVariables>(RegisterMachineDocument, options);
      }
export type RegisterMachineMutationHookResult = ReturnType<typeof useRegisterMachineMutation>;
export type RegisterMachineMutationResult = Apollo.MutationResult<RegisterMachineMutation>;
export type RegisterMachineMutationOptions = Apollo.BaseMutationOptions<RegisterMachineMutation, RegisterMachineMutationVariables>;
export const ProvisionMachineDocument = gql`
    mutation ProvisionMachine($input: ProvisionMachineInput!) {
  provisionMachine(input: $input) {
    ...ProvisionedMachineParts
  }
}
    ${ProvisionedMachinePartsFragmentDoc}`;
export type ProvisionMachineMutationFn = Apollo.MutationFunction<ProvisionMachineMutation, ProvisionMachineMutationVariables>;

/**
 * __useProvisionMachineMutation__
 *
 * To run a mutation, you first call `useProvisionMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionMachineMutation, { data, loading, error }] = useProvisionMachineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionMachineMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionMachineMutation, ProvisionMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionMachineMutation, ProvisionMachineMutationVariables>(ProvisionMachineDocument, options);
      }
export type ProvisionMachineMutationHookResult = ReturnType<typeof useProvisionMachineMutation>;
export type ProvisionMachineMutationResult = Apollo.MutationResult<ProvisionMachineMutation>;
export type ProvisionMachineMutationOptions = Apollo.BaseMutationOptions<ProvisionMachineMutation, ProvisionMachineMutationVariables>;
export const SubscribeToMachineStateDocument = gql`
    subscription SubscribeToMachineState($input: SubscribeToMachineStateInput!) {
  subscribeToMachineState(input: $input) {
    ...MachineStateParts
  }
}
    ${MachineStatePartsFragmentDoc}`;

/**
 * __useSubscribeToMachineStateSubscription__
 *
 * To run a query within a React component, call `useSubscribeToMachineStateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToMachineStateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToMachineStateSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToMachineStateSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToMachineStateSubscription, SubscribeToMachineStateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToMachineStateSubscription, SubscribeToMachineStateSubscriptionVariables>(SubscribeToMachineStateDocument, options);
      }
export type SubscribeToMachineStateSubscriptionHookResult = ReturnType<typeof useSubscribeToMachineStateSubscription>;
export type SubscribeToMachineStateSubscriptionResult = Apollo.SubscriptionResult<SubscribeToMachineStateSubscription>;
export const SubscribeToSingleMachineStateDocument = gql`
    subscription SubscribeToSingleMachineState($input: SubscribeToSingleMachineStateInput!) {
  subscribeToSingleMachineState(input: $input) {
    ...MachineStateParts
  }
}
    ${MachineStatePartsFragmentDoc}`;

/**
 * __useSubscribeToSingleMachineStateSubscription__
 *
 * To run a query within a React component, call `useSubscribeToSingleMachineStateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToSingleMachineStateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToSingleMachineStateSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToSingleMachineStateSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToSingleMachineStateSubscription, SubscribeToSingleMachineStateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToSingleMachineStateSubscription, SubscribeToSingleMachineStateSubscriptionVariables>(SubscribeToSingleMachineStateDocument, options);
      }
export type SubscribeToSingleMachineStateSubscriptionHookResult = ReturnType<typeof useSubscribeToSingleMachineStateSubscription>;
export type SubscribeToSingleMachineStateSubscriptionResult = Apollo.SubscriptionResult<SubscribeToSingleMachineStateSubscription>;
export const GetPlanDocument = gql`
    query GetPlan($input: GetPlanInput!) {
  getPlan(input: $input) {
    ...PlanParts
  }
}
    ${PlanPartsFragmentDoc}`;

/**
 * __useGetPlanQuery__
 *
 * To run a query within a React component, call `useGetPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPlanQuery(baseOptions: Apollo.QueryHookOptions<GetPlanQuery, GetPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanQuery, GetPlanQueryVariables>(GetPlanDocument, options);
      }
export function useGetPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanQuery, GetPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanQuery, GetPlanQueryVariables>(GetPlanDocument, options);
        }
export type GetPlanQueryHookResult = ReturnType<typeof useGetPlanQuery>;
export type GetPlanLazyQueryHookResult = ReturnType<typeof useGetPlanLazyQuery>;
export type GetPlanQueryResult = Apollo.QueryResult<GetPlanQuery, GetPlanQueryVariables>;
export const ListPlansDocument = gql`
    query ListPlans($input: ListPlansInput!) {
  listPlans(input: $input) {
    total
    items {
      ...PlanParts
    }
  }
}
    ${PlanPartsFragmentDoc}`;

/**
 * __useListPlansQuery__
 *
 * To run a query within a React component, call `useListPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPlansQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListPlansQuery(baseOptions: Apollo.QueryHookOptions<ListPlansQuery, ListPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPlansQuery, ListPlansQueryVariables>(ListPlansDocument, options);
      }
export function useListPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPlansQuery, ListPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPlansQuery, ListPlansQueryVariables>(ListPlansDocument, options);
        }
export type ListPlansQueryHookResult = ReturnType<typeof useListPlansQuery>;
export type ListPlansLazyQueryHookResult = ReturnType<typeof useListPlansLazyQuery>;
export type ListPlansQueryResult = Apollo.QueryResult<ListPlansQuery, ListPlansQueryVariables>;
export const GetPlanDetailsDocument = gql`
    query GetPlanDetails {
  getPlanDetails {
    ...PlanDetailsParts
  }
}
    ${PlanDetailsPartsFragmentDoc}`;

/**
 * __useGetPlanDetailsQuery__
 *
 * To run a query within a React component, call `useGetPlanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlanDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetPlanDetailsQuery, GetPlanDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanDetailsQuery, GetPlanDetailsQueryVariables>(GetPlanDetailsDocument, options);
      }
export function useGetPlanDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanDetailsQuery, GetPlanDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanDetailsQuery, GetPlanDetailsQueryVariables>(GetPlanDetailsDocument, options);
        }
export type GetPlanDetailsQueryHookResult = ReturnType<typeof useGetPlanDetailsQuery>;
export type GetPlanDetailsLazyQueryHookResult = ReturnType<typeof useGetPlanDetailsLazyQuery>;
export type GetPlanDetailsQueryResult = Apollo.QueryResult<GetPlanDetailsQuery, GetPlanDetailsQueryVariables>;
export const RequestPlanFeatureDocument = gql`
    mutation RequestPlanFeature($input: RequestPlanFeatureInput!) {
  requestPlanFeature(input: $input)
}
    `;
export type RequestPlanFeatureMutationFn = Apollo.MutationFunction<RequestPlanFeatureMutation, RequestPlanFeatureMutationVariables>;

/**
 * __useRequestPlanFeatureMutation__
 *
 * To run a mutation, you first call `useRequestPlanFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPlanFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPlanFeatureMutation, { data, loading, error }] = useRequestPlanFeatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPlanFeatureMutation(baseOptions?: Apollo.MutationHookOptions<RequestPlanFeatureMutation, RequestPlanFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPlanFeatureMutation, RequestPlanFeatureMutationVariables>(RequestPlanFeatureDocument, options);
      }
export type RequestPlanFeatureMutationHookResult = ReturnType<typeof useRequestPlanFeatureMutation>;
export type RequestPlanFeatureMutationResult = Apollo.MutationResult<RequestPlanFeatureMutation>;
export type RequestPlanFeatureMutationOptions = Apollo.BaseMutationOptions<RequestPlanFeatureMutation, RequestPlanFeatureMutationVariables>;
export const CreateLinkToSubscribeToPlanDocument = gql`
    mutation CreateLinkToSubscribeToPlan($input: SubscribeToPlanInput!) {
  createLinkToSubscribeToPlan(input: $input)
}
    `;
export type CreateLinkToSubscribeToPlanMutationFn = Apollo.MutationFunction<CreateLinkToSubscribeToPlanMutation, CreateLinkToSubscribeToPlanMutationVariables>;

/**
 * __useCreateLinkToSubscribeToPlanMutation__
 *
 * To run a mutation, you first call `useCreateLinkToSubscribeToPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkToSubscribeToPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkToSubscribeToPlanMutation, { data, loading, error }] = useCreateLinkToSubscribeToPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLinkToSubscribeToPlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateLinkToSubscribeToPlanMutation, CreateLinkToSubscribeToPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLinkToSubscribeToPlanMutation, CreateLinkToSubscribeToPlanMutationVariables>(CreateLinkToSubscribeToPlanDocument, options);
      }
export type CreateLinkToSubscribeToPlanMutationHookResult = ReturnType<typeof useCreateLinkToSubscribeToPlanMutation>;
export type CreateLinkToSubscribeToPlanMutationResult = Apollo.MutationResult<CreateLinkToSubscribeToPlanMutation>;
export type CreateLinkToSubscribeToPlanMutationOptions = Apollo.BaseMutationOptions<CreateLinkToSubscribeToPlanMutation, CreateLinkToSubscribeToPlanMutationVariables>;
export const CreateLinkToManagePlanSubscriptionDocument = gql`
    mutation CreateLinkToManagePlanSubscription {
  createLinkToManagePlanSubscription
}
    `;
export type CreateLinkToManagePlanSubscriptionMutationFn = Apollo.MutationFunction<CreateLinkToManagePlanSubscriptionMutation, CreateLinkToManagePlanSubscriptionMutationVariables>;

/**
 * __useCreateLinkToManagePlanSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateLinkToManagePlanSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkToManagePlanSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkToManagePlanSubscriptionMutation, { data, loading, error }] = useCreateLinkToManagePlanSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateLinkToManagePlanSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateLinkToManagePlanSubscriptionMutation, CreateLinkToManagePlanSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLinkToManagePlanSubscriptionMutation, CreateLinkToManagePlanSubscriptionMutationVariables>(CreateLinkToManagePlanSubscriptionDocument, options);
      }
export type CreateLinkToManagePlanSubscriptionMutationHookResult = ReturnType<typeof useCreateLinkToManagePlanSubscriptionMutation>;
export type CreateLinkToManagePlanSubscriptionMutationResult = Apollo.MutationResult<CreateLinkToManagePlanSubscriptionMutation>;
export type CreateLinkToManagePlanSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateLinkToManagePlanSubscriptionMutation, CreateLinkToManagePlanSubscriptionMutationVariables>;
export const UpdatePlanSubscriptionDocument = gql`
    mutation UpdatePlanSubscription($input: UpdatePlanSubscriptionInput!) {
  updatePlanSubscription(input: $input)
}
    `;
export type UpdatePlanSubscriptionMutationFn = Apollo.MutationFunction<UpdatePlanSubscriptionMutation, UpdatePlanSubscriptionMutationVariables>;

/**
 * __useUpdatePlanSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdatePlanSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanSubscriptionMutation, { data, loading, error }] = useUpdatePlanSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlanSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanSubscriptionMutation, UpdatePlanSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanSubscriptionMutation, UpdatePlanSubscriptionMutationVariables>(UpdatePlanSubscriptionDocument, options);
      }
export type UpdatePlanSubscriptionMutationHookResult = ReturnType<typeof useUpdatePlanSubscriptionMutation>;
export type UpdatePlanSubscriptionMutationResult = Apollo.MutationResult<UpdatePlanSubscriptionMutation>;
export type UpdatePlanSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdatePlanSubscriptionMutation, UpdatePlanSubscriptionMutationVariables>;
export const SubscribeToPlanDetailsDocument = gql`
    subscription SubscribeToPlanDetails {
  subscribeToPlanDetails {
    ...PlanDetailsParts
  }
}
    ${PlanDetailsPartsFragmentDoc}`;

/**
 * __useSubscribeToPlanDetailsSubscription__
 *
 * To run a query within a React component, call `useSubscribeToPlanDetailsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToPlanDetailsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToPlanDetailsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSubscribeToPlanDetailsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeToPlanDetailsSubscription, SubscribeToPlanDetailsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToPlanDetailsSubscription, SubscribeToPlanDetailsSubscriptionVariables>(SubscribeToPlanDetailsDocument, options);
      }
export type SubscribeToPlanDetailsSubscriptionHookResult = ReturnType<typeof useSubscribeToPlanDetailsSubscription>;
export type SubscribeToPlanDetailsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToPlanDetailsSubscription>;
export const SavePreferenceDocument = gql`
    mutation SavePreference($input: SavePreferenceInput!) {
  savePreference(input: $input) {
    ...PreferenceParts
  }
}
    ${PreferencePartsFragmentDoc}`;
export type SavePreferenceMutationFn = Apollo.MutationFunction<SavePreferenceMutation, SavePreferenceMutationVariables>;

/**
 * __useSavePreferenceMutation__
 *
 * To run a mutation, you first call `useSavePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePreferenceMutation, { data, loading, error }] = useSavePreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePreferenceMutation(baseOptions?: Apollo.MutationHookOptions<SavePreferenceMutation, SavePreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePreferenceMutation, SavePreferenceMutationVariables>(SavePreferenceDocument, options);
      }
export type SavePreferenceMutationHookResult = ReturnType<typeof useSavePreferenceMutation>;
export type SavePreferenceMutationResult = Apollo.MutationResult<SavePreferenceMutation>;
export type SavePreferenceMutationOptions = Apollo.BaseMutationOptions<SavePreferenceMutation, SavePreferenceMutationVariables>;
export const GetPreferenceDocument = gql`
    query GetPreference($input: GetPreferenceInput!) {
  getPreference(input: $input) {
    ...PreferenceParts
  }
}
    ${PreferencePartsFragmentDoc}`;

/**
 * __useGetPreferenceQuery__
 *
 * To run a query within a React component, call `useGetPreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferenceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPreferenceQuery(baseOptions: Apollo.QueryHookOptions<GetPreferenceQuery, GetPreferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreferenceQuery, GetPreferenceQueryVariables>(GetPreferenceDocument, options);
      }
export function useGetPreferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreferenceQuery, GetPreferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreferenceQuery, GetPreferenceQueryVariables>(GetPreferenceDocument, options);
        }
export type GetPreferenceQueryHookResult = ReturnType<typeof useGetPreferenceQuery>;
export type GetPreferenceLazyQueryHookResult = ReturnType<typeof useGetPreferenceLazyQuery>;
export type GetPreferenceQueryResult = Apollo.QueryResult<GetPreferenceQuery, GetPreferenceQueryVariables>;
export const ListPreferencesDocument = gql`
    query ListPreferences($input: ListPreferencesInput!) {
  listPreferences(input: $input) {
    total
    items {
      ...PreferenceParts
    }
  }
}
    ${PreferencePartsFragmentDoc}`;

/**
 * __useListPreferencesQuery__
 *
 * To run a query within a React component, call `useListPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPreferencesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListPreferencesQuery(baseOptions: Apollo.QueryHookOptions<ListPreferencesQuery, ListPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPreferencesQuery, ListPreferencesQueryVariables>(ListPreferencesDocument, options);
      }
export function useListPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPreferencesQuery, ListPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPreferencesQuery, ListPreferencesQueryVariables>(ListPreferencesDocument, options);
        }
export type ListPreferencesQueryHookResult = ReturnType<typeof useListPreferencesQuery>;
export type ListPreferencesLazyQueryHookResult = ReturnType<typeof useListPreferencesLazyQuery>;
export type ListPreferencesQueryResult = Apollo.QueryResult<ListPreferencesQuery, ListPreferencesQueryVariables>;
export const ListRolesDocument = gql`
    query ListRoles($input: ListRolesInput!) {
  listRoles(input: $input) {
    total
    items {
      ...RoleParts
    }
  }
}
    ${RolePartsFragmentDoc}`;

/**
 * __useListRolesQuery__
 *
 * To run a query within a React component, call `useListRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRolesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListRolesQuery(baseOptions: Apollo.QueryHookOptions<ListRolesQuery, ListRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRolesQuery, ListRolesQueryVariables>(ListRolesDocument, options);
      }
export function useListRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRolesQuery, ListRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRolesQuery, ListRolesQueryVariables>(ListRolesDocument, options);
        }
export type ListRolesQueryHookResult = ReturnType<typeof useListRolesQuery>;
export type ListRolesLazyQueryHookResult = ReturnType<typeof useListRolesLazyQuery>;
export type ListRolesQueryResult = Apollo.QueryResult<ListRolesQuery, ListRolesQueryVariables>;
export const GetRoleDocument = gql`
    query GetRole($input: GetRoleInput!) {
  getRole(input: $input) {
    ...RoleParts
  }
}
    ${RolePartsFragmentDoc}`;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRoleQuery(baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
      }
export function useGetRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>;
export const GetRoleByTeamDocument = gql`
    query GetRoleByTeam($input: GetRoleByTeamInput!) {
  getRoleByTeam(input: $input) {
    ...RoleParts
  }
}
    ${RolePartsFragmentDoc}`;

/**
 * __useGetRoleByTeamQuery__
 *
 * To run a query within a React component, call `useGetRoleByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleByTeamQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRoleByTeamQuery(baseOptions: Apollo.QueryHookOptions<GetRoleByTeamQuery, GetRoleByTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleByTeamQuery, GetRoleByTeamQueryVariables>(GetRoleByTeamDocument, options);
      }
export function useGetRoleByTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleByTeamQuery, GetRoleByTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleByTeamQuery, GetRoleByTeamQueryVariables>(GetRoleByTeamDocument, options);
        }
export type GetRoleByTeamQueryHookResult = ReturnType<typeof useGetRoleByTeamQuery>;
export type GetRoleByTeamLazyQueryHookResult = ReturnType<typeof useGetRoleByTeamLazyQuery>;
export type GetRoleByTeamQueryResult = Apollo.QueryResult<GetRoleByTeamQuery, GetRoleByTeamQueryVariables>;
export const GetRolePermissionFormDataDocument = gql`
    query GetRolePermissionFormData($input: GetRolePermissionFormDataInput!) {
  getRolePermissionFormData(input: $input) {
    ...RolePermissionFormFieldParts
  }
}
    ${RolePermissionFormFieldPartsFragmentDoc}`;

/**
 * __useGetRolePermissionFormDataQuery__
 *
 * To run a query within a React component, call `useGetRolePermissionFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolePermissionFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolePermissionFormDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRolePermissionFormDataQuery(baseOptions: Apollo.QueryHookOptions<GetRolePermissionFormDataQuery, GetRolePermissionFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolePermissionFormDataQuery, GetRolePermissionFormDataQueryVariables>(GetRolePermissionFormDataDocument, options);
      }
export function useGetRolePermissionFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolePermissionFormDataQuery, GetRolePermissionFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolePermissionFormDataQuery, GetRolePermissionFormDataQueryVariables>(GetRolePermissionFormDataDocument, options);
        }
export type GetRolePermissionFormDataQueryHookResult = ReturnType<typeof useGetRolePermissionFormDataQuery>;
export type GetRolePermissionFormDataLazyQueryHookResult = ReturnType<typeof useGetRolePermissionFormDataLazyQuery>;
export type GetRolePermissionFormDataQueryResult = Apollo.QueryResult<GetRolePermissionFormDataQuery, GetRolePermissionFormDataQueryVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($input: CreateRoleInput!) {
  createRole(input: $input) {
    ...RoleParts
  }
}
    ${RolePartsFragmentDoc}`;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($input: UpdateRoleInput!) {
  updateRole(input: $input) {
    ...RoleParts
  }
}
    ${RolePartsFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const ReplaceRolePermissionsDocument = gql`
    mutation replaceRolePermissions($input: ReplaceRolePermissionsInput!) {
  replaceRolePermissions(input: $input) {
    ...RolePermissionParts
  }
}
    ${RolePermissionPartsFragmentDoc}`;
export type ReplaceRolePermissionsMutationFn = Apollo.MutationFunction<ReplaceRolePermissionsMutation, ReplaceRolePermissionsMutationVariables>;

/**
 * __useReplaceRolePermissionsMutation__
 *
 * To run a mutation, you first call `useReplaceRolePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceRolePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceRolePermissionsMutation, { data, loading, error }] = useReplaceRolePermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceRolePermissionsMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceRolePermissionsMutation, ReplaceRolePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceRolePermissionsMutation, ReplaceRolePermissionsMutationVariables>(ReplaceRolePermissionsDocument, options);
      }
export type ReplaceRolePermissionsMutationHookResult = ReturnType<typeof useReplaceRolePermissionsMutation>;
export type ReplaceRolePermissionsMutationResult = Apollo.MutationResult<ReplaceRolePermissionsMutation>;
export type ReplaceRolePermissionsMutationOptions = Apollo.BaseMutationOptions<ReplaceRolePermissionsMutation, ReplaceRolePermissionsMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation deleteRole($input: DeleteRoleInput!) {
  deleteRole(input: $input)
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const GetScratchpadBucketDocument = gql`
    query GetScratchpadBucket($input: GetScratchpadBucketInput!) {
  getScratchpadBucket(input: $input) {
    ...ScratchpadBucketParts
  }
}
    ${ScratchpadBucketPartsFragmentDoc}`;

/**
 * __useGetScratchpadBucketQuery__
 *
 * To run a query within a React component, call `useGetScratchpadBucketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScratchpadBucketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScratchpadBucketQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetScratchpadBucketQuery(baseOptions: Apollo.QueryHookOptions<GetScratchpadBucketQuery, GetScratchpadBucketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScratchpadBucketQuery, GetScratchpadBucketQueryVariables>(GetScratchpadBucketDocument, options);
      }
export function useGetScratchpadBucketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScratchpadBucketQuery, GetScratchpadBucketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScratchpadBucketQuery, GetScratchpadBucketQueryVariables>(GetScratchpadBucketDocument, options);
        }
export type GetScratchpadBucketQueryHookResult = ReturnType<typeof useGetScratchpadBucketQuery>;
export type GetScratchpadBucketLazyQueryHookResult = ReturnType<typeof useGetScratchpadBucketLazyQuery>;
export type GetScratchpadBucketQueryResult = Apollo.QueryResult<GetScratchpadBucketQuery, GetScratchpadBucketQueryVariables>;
export const ListScratchpadBucketsDocument = gql`
    query ListScratchpadBuckets($input: ListScratchpadBucketsInput!) {
  listScratchpadBuckets(input: $input) {
    total
    items {
      ...ScratchpadBucketParts
    }
  }
}
    ${ScratchpadBucketPartsFragmentDoc}`;

/**
 * __useListScratchpadBucketsQuery__
 *
 * To run a query within a React component, call `useListScratchpadBucketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListScratchpadBucketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListScratchpadBucketsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListScratchpadBucketsQuery(baseOptions: Apollo.QueryHookOptions<ListScratchpadBucketsQuery, ListScratchpadBucketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListScratchpadBucketsQuery, ListScratchpadBucketsQueryVariables>(ListScratchpadBucketsDocument, options);
      }
export function useListScratchpadBucketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListScratchpadBucketsQuery, ListScratchpadBucketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListScratchpadBucketsQuery, ListScratchpadBucketsQueryVariables>(ListScratchpadBucketsDocument, options);
        }
export type ListScratchpadBucketsQueryHookResult = ReturnType<typeof useListScratchpadBucketsQuery>;
export type ListScratchpadBucketsLazyQueryHookResult = ReturnType<typeof useListScratchpadBucketsLazyQuery>;
export type ListScratchpadBucketsQueryResult = Apollo.QueryResult<ListScratchpadBucketsQuery, ListScratchpadBucketsQueryVariables>;
export const CreateScratchpadBucketDocument = gql`
    mutation CreateScratchpadBucket($input: CreateScratchpadBucketInput!) {
  createScratchpadBucket(input: $input) {
    ...ScratchpadBucketParts
  }
}
    ${ScratchpadBucketPartsFragmentDoc}`;
export type CreateScratchpadBucketMutationFn = Apollo.MutationFunction<CreateScratchpadBucketMutation, CreateScratchpadBucketMutationVariables>;

/**
 * __useCreateScratchpadBucketMutation__
 *
 * To run a mutation, you first call `useCreateScratchpadBucketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScratchpadBucketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScratchpadBucketMutation, { data, loading, error }] = useCreateScratchpadBucketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScratchpadBucketMutation(baseOptions?: Apollo.MutationHookOptions<CreateScratchpadBucketMutation, CreateScratchpadBucketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScratchpadBucketMutation, CreateScratchpadBucketMutationVariables>(CreateScratchpadBucketDocument, options);
      }
export type CreateScratchpadBucketMutationHookResult = ReturnType<typeof useCreateScratchpadBucketMutation>;
export type CreateScratchpadBucketMutationResult = Apollo.MutationResult<CreateScratchpadBucketMutation>;
export type CreateScratchpadBucketMutationOptions = Apollo.BaseMutationOptions<CreateScratchpadBucketMutation, CreateScratchpadBucketMutationVariables>;
export const UpdateScratchpadBucketDocument = gql`
    mutation UpdateScratchpadBucket($input: UpdateScratchpadBucketInput!) {
  updateScratchpadBucket(input: $input) {
    ...ScratchpadBucketParts
  }
}
    ${ScratchpadBucketPartsFragmentDoc}`;
export type UpdateScratchpadBucketMutationFn = Apollo.MutationFunction<UpdateScratchpadBucketMutation, UpdateScratchpadBucketMutationVariables>;

/**
 * __useUpdateScratchpadBucketMutation__
 *
 * To run a mutation, you first call `useUpdateScratchpadBucketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScratchpadBucketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScratchpadBucketMutation, { data, loading, error }] = useUpdateScratchpadBucketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScratchpadBucketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScratchpadBucketMutation, UpdateScratchpadBucketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScratchpadBucketMutation, UpdateScratchpadBucketMutationVariables>(UpdateScratchpadBucketDocument, options);
      }
export type UpdateScratchpadBucketMutationHookResult = ReturnType<typeof useUpdateScratchpadBucketMutation>;
export type UpdateScratchpadBucketMutationResult = Apollo.MutationResult<UpdateScratchpadBucketMutation>;
export type UpdateScratchpadBucketMutationOptions = Apollo.BaseMutationOptions<UpdateScratchpadBucketMutation, UpdateScratchpadBucketMutationVariables>;
export const ListScratchpadHistoriesDocument = gql`
    query ListScratchpadHistories($input: ListScratchpadHistoriesInput!) {
  listScratchpadHistories(input: $input) {
    total
    items {
      ...ListScratchpadHistoriesParts
    }
  }
}
    ${ListScratchpadHistoriesPartsFragmentDoc}`;

/**
 * __useListScratchpadHistoriesQuery__
 *
 * To run a query within a React component, call `useListScratchpadHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListScratchpadHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListScratchpadHistoriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListScratchpadHistoriesQuery(baseOptions: Apollo.QueryHookOptions<ListScratchpadHistoriesQuery, ListScratchpadHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListScratchpadHistoriesQuery, ListScratchpadHistoriesQueryVariables>(ListScratchpadHistoriesDocument, options);
      }
export function useListScratchpadHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListScratchpadHistoriesQuery, ListScratchpadHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListScratchpadHistoriesQuery, ListScratchpadHistoriesQueryVariables>(ListScratchpadHistoriesDocument, options);
        }
export type ListScratchpadHistoriesQueryHookResult = ReturnType<typeof useListScratchpadHistoriesQuery>;
export type ListScratchpadHistoriesLazyQueryHookResult = ReturnType<typeof useListScratchpadHistoriesLazyQuery>;
export type ListScratchpadHistoriesQueryResult = Apollo.QueryResult<ListScratchpadHistoriesQuery, ListScratchpadHistoriesQueryVariables>;
export const GetScratchpadHistoryDocument = gql`
    query GetScratchpadHistory($input: GetScratchpadHistoryInput!) {
  getScratchpadHistory(input: $input) {
    ...ListScratchpadHistoriesParts
    app {
      ...ScratchpadAppParts
    }
    appData
  }
}
    ${ListScratchpadHistoriesPartsFragmentDoc}
${ScratchpadAppPartsFragmentDoc}`;

/**
 * __useGetScratchpadHistoryQuery__
 *
 * To run a query within a React component, call `useGetScratchpadHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScratchpadHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScratchpadHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetScratchpadHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetScratchpadHistoryQuery, GetScratchpadHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScratchpadHistoryQuery, GetScratchpadHistoryQueryVariables>(GetScratchpadHistoryDocument, options);
      }
export function useGetScratchpadHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScratchpadHistoryQuery, GetScratchpadHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScratchpadHistoryQuery, GetScratchpadHistoryQueryVariables>(GetScratchpadHistoryDocument, options);
        }
export type GetScratchpadHistoryQueryHookResult = ReturnType<typeof useGetScratchpadHistoryQuery>;
export type GetScratchpadHistoryLazyQueryHookResult = ReturnType<typeof useGetScratchpadHistoryLazyQuery>;
export type GetScratchpadHistoryQueryResult = Apollo.QueryResult<GetScratchpadHistoryQuery, GetScratchpadHistoryQueryVariables>;
export const RestoreScratchpadHistoryDocument = gql`
    mutation RestoreScratchpadHistory($input: RestoreScratchpadHistoryInput!) {
  restoreScratchpadHistory(input: $input)
}
    `;
export type RestoreScratchpadHistoryMutationFn = Apollo.MutationFunction<RestoreScratchpadHistoryMutation, RestoreScratchpadHistoryMutationVariables>;

/**
 * __useRestoreScratchpadHistoryMutation__
 *
 * To run a mutation, you first call `useRestoreScratchpadHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreScratchpadHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreScratchpadHistoryMutation, { data, loading, error }] = useRestoreScratchpadHistoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreScratchpadHistoryMutation(baseOptions?: Apollo.MutationHookOptions<RestoreScratchpadHistoryMutation, RestoreScratchpadHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreScratchpadHistoryMutation, RestoreScratchpadHistoryMutationVariables>(RestoreScratchpadHistoryDocument, options);
      }
export type RestoreScratchpadHistoryMutationHookResult = ReturnType<typeof useRestoreScratchpadHistoryMutation>;
export type RestoreScratchpadHistoryMutationResult = Apollo.MutationResult<RestoreScratchpadHistoryMutation>;
export type RestoreScratchpadHistoryMutationOptions = Apollo.BaseMutationOptions<RestoreScratchpadHistoryMutation, RestoreScratchpadHistoryMutationVariables>;
export const ListScratchpadPlaylistsDocument = gql`
    query ListScratchpadPlaylists($input: ListScratchpadPlaylistInput!) {
  listScratchpadPlaylists(input: $input) {
    total
    items {
      ...ScratchpadPlaylistParts
    }
  }
}
    ${ScratchpadPlaylistPartsFragmentDoc}`;

/**
 * __useListScratchpadPlaylistsQuery__
 *
 * To run a query within a React component, call `useListScratchpadPlaylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListScratchpadPlaylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListScratchpadPlaylistsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListScratchpadPlaylistsQuery(baseOptions: Apollo.QueryHookOptions<ListScratchpadPlaylistsQuery, ListScratchpadPlaylistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListScratchpadPlaylistsQuery, ListScratchpadPlaylistsQueryVariables>(ListScratchpadPlaylistsDocument, options);
      }
export function useListScratchpadPlaylistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListScratchpadPlaylistsQuery, ListScratchpadPlaylistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListScratchpadPlaylistsQuery, ListScratchpadPlaylistsQueryVariables>(ListScratchpadPlaylistsDocument, options);
        }
export type ListScratchpadPlaylistsQueryHookResult = ReturnType<typeof useListScratchpadPlaylistsQuery>;
export type ListScratchpadPlaylistsLazyQueryHookResult = ReturnType<typeof useListScratchpadPlaylistsLazyQuery>;
export type ListScratchpadPlaylistsQueryResult = Apollo.QueryResult<ListScratchpadPlaylistsQuery, ListScratchpadPlaylistsQueryVariables>;
export const GetScratchpadPlaylistActivatedDocument = gql`
    query GetScratchpadPlaylistActivated($input: GetScratchpadPlaylistActivatedInput!) {
  getScratchpadPlaylistActivated(input: $input) {
    ...ScratchpadPlaylistParts
  }
}
    ${ScratchpadPlaylistPartsFragmentDoc}`;

/**
 * __useGetScratchpadPlaylistActivatedQuery__
 *
 * To run a query within a React component, call `useGetScratchpadPlaylistActivatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScratchpadPlaylistActivatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScratchpadPlaylistActivatedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetScratchpadPlaylistActivatedQuery(baseOptions: Apollo.QueryHookOptions<GetScratchpadPlaylistActivatedQuery, GetScratchpadPlaylistActivatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScratchpadPlaylistActivatedQuery, GetScratchpadPlaylistActivatedQueryVariables>(GetScratchpadPlaylistActivatedDocument, options);
      }
export function useGetScratchpadPlaylistActivatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScratchpadPlaylistActivatedQuery, GetScratchpadPlaylistActivatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScratchpadPlaylistActivatedQuery, GetScratchpadPlaylistActivatedQueryVariables>(GetScratchpadPlaylistActivatedDocument, options);
        }
export type GetScratchpadPlaylistActivatedQueryHookResult = ReturnType<typeof useGetScratchpadPlaylistActivatedQuery>;
export type GetScratchpadPlaylistActivatedLazyQueryHookResult = ReturnType<typeof useGetScratchpadPlaylistActivatedLazyQuery>;
export type GetScratchpadPlaylistActivatedQueryResult = Apollo.QueryResult<GetScratchpadPlaylistActivatedQuery, GetScratchpadPlaylistActivatedQueryVariables>;
export const CreateScratchpadPlaylistDocument = gql`
    mutation CreateScratchpadPlaylist($input: CreateScratchpadPlaylistInput!) {
  createScratchpadPlaylist(input: $input) {
    ...ScratchpadPlaylistParts
  }
}
    ${ScratchpadPlaylistPartsFragmentDoc}`;
export type CreateScratchpadPlaylistMutationFn = Apollo.MutationFunction<CreateScratchpadPlaylistMutation, CreateScratchpadPlaylistMutationVariables>;

/**
 * __useCreateScratchpadPlaylistMutation__
 *
 * To run a mutation, you first call `useCreateScratchpadPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScratchpadPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScratchpadPlaylistMutation, { data, loading, error }] = useCreateScratchpadPlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScratchpadPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<CreateScratchpadPlaylistMutation, CreateScratchpadPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScratchpadPlaylistMutation, CreateScratchpadPlaylistMutationVariables>(CreateScratchpadPlaylistDocument, options);
      }
export type CreateScratchpadPlaylistMutationHookResult = ReturnType<typeof useCreateScratchpadPlaylistMutation>;
export type CreateScratchpadPlaylistMutationResult = Apollo.MutationResult<CreateScratchpadPlaylistMutation>;
export type CreateScratchpadPlaylistMutationOptions = Apollo.BaseMutationOptions<CreateScratchpadPlaylistMutation, CreateScratchpadPlaylistMutationVariables>;
export const UpdateScratchpadPlaylistDocument = gql`
    mutation UpdateScratchpadPlaylist($input: UpdateScratchpadPlaylistInput!) {
  updateScratchpadPlaylist(input: $input) {
    ...ScratchpadPlaylistParts
  }
}
    ${ScratchpadPlaylistPartsFragmentDoc}`;
export type UpdateScratchpadPlaylistMutationFn = Apollo.MutationFunction<UpdateScratchpadPlaylistMutation, UpdateScratchpadPlaylistMutationVariables>;

/**
 * __useUpdateScratchpadPlaylistMutation__
 *
 * To run a mutation, you first call `useUpdateScratchpadPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScratchpadPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScratchpadPlaylistMutation, { data, loading, error }] = useUpdateScratchpadPlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScratchpadPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScratchpadPlaylistMutation, UpdateScratchpadPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScratchpadPlaylistMutation, UpdateScratchpadPlaylistMutationVariables>(UpdateScratchpadPlaylistDocument, options);
      }
export type UpdateScratchpadPlaylistMutationHookResult = ReturnType<typeof useUpdateScratchpadPlaylistMutation>;
export type UpdateScratchpadPlaylistMutationResult = Apollo.MutationResult<UpdateScratchpadPlaylistMutation>;
export type UpdateScratchpadPlaylistMutationOptions = Apollo.BaseMutationOptions<UpdateScratchpadPlaylistMutation, UpdateScratchpadPlaylistMutationVariables>;
export const SubscribeToScratchpadPlaylistActivatedDocument = gql`
    subscription SubscribeToScratchpadPlaylistActivated($input: SubscribeToScratchpadPlaylistActivatedInput!) {
  subscribeToScratchpadPlaylistActivated(input: $input) {
    ...ScratchpadPlaylistParts
  }
}
    ${ScratchpadPlaylistPartsFragmentDoc}`;

/**
 * __useSubscribeToScratchpadPlaylistActivatedSubscription__
 *
 * To run a query within a React component, call `useSubscribeToScratchpadPlaylistActivatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToScratchpadPlaylistActivatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToScratchpadPlaylistActivatedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToScratchpadPlaylistActivatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToScratchpadPlaylistActivatedSubscription, SubscribeToScratchpadPlaylistActivatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToScratchpadPlaylistActivatedSubscription, SubscribeToScratchpadPlaylistActivatedSubscriptionVariables>(SubscribeToScratchpadPlaylistActivatedDocument, options);
      }
export type SubscribeToScratchpadPlaylistActivatedSubscriptionHookResult = ReturnType<typeof useSubscribeToScratchpadPlaylistActivatedSubscription>;
export type SubscribeToScratchpadPlaylistActivatedSubscriptionResult = Apollo.SubscriptionResult<SubscribeToScratchpadPlaylistActivatedSubscription>;
export const GetScratchpadRecommendationDocument = gql`
    query GetScratchpadRecommendation($input: GetScratchpadRecommendationInput!) {
  getScratchpadRecommendation(input: $input) {
    ...ScratchpadRecommendationParts
  }
}
    ${ScratchpadRecommendationPartsFragmentDoc}`;

/**
 * __useGetScratchpadRecommendationQuery__
 *
 * To run a query within a React component, call `useGetScratchpadRecommendationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScratchpadRecommendationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScratchpadRecommendationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetScratchpadRecommendationQuery(baseOptions: Apollo.QueryHookOptions<GetScratchpadRecommendationQuery, GetScratchpadRecommendationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScratchpadRecommendationQuery, GetScratchpadRecommendationQueryVariables>(GetScratchpadRecommendationDocument, options);
      }
export function useGetScratchpadRecommendationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScratchpadRecommendationQuery, GetScratchpadRecommendationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScratchpadRecommendationQuery, GetScratchpadRecommendationQueryVariables>(GetScratchpadRecommendationDocument, options);
        }
export type GetScratchpadRecommendationQueryHookResult = ReturnType<typeof useGetScratchpadRecommendationQuery>;
export type GetScratchpadRecommendationLazyQueryHookResult = ReturnType<typeof useGetScratchpadRecommendationLazyQuery>;
export type GetScratchpadRecommendationQueryResult = Apollo.QueryResult<GetScratchpadRecommendationQuery, GetScratchpadRecommendationQueryVariables>;
export const CreateScratchpadRecommendationDocument = gql`
    mutation CreateScratchpadRecommendation($input: CreateScratchpadRecommendationRequestInput!) {
  createScratchpadRecommendation(input: $input) {
    ...ScratchpadRecommendationParts
  }
}
    ${ScratchpadRecommendationPartsFragmentDoc}`;
export type CreateScratchpadRecommendationMutationFn = Apollo.MutationFunction<CreateScratchpadRecommendationMutation, CreateScratchpadRecommendationMutationVariables>;

/**
 * __useCreateScratchpadRecommendationMutation__
 *
 * To run a mutation, you first call `useCreateScratchpadRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScratchpadRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScratchpadRecommendationMutation, { data, loading, error }] = useCreateScratchpadRecommendationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScratchpadRecommendationMutation(baseOptions?: Apollo.MutationHookOptions<CreateScratchpadRecommendationMutation, CreateScratchpadRecommendationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScratchpadRecommendationMutation, CreateScratchpadRecommendationMutationVariables>(CreateScratchpadRecommendationDocument, options);
      }
export type CreateScratchpadRecommendationMutationHookResult = ReturnType<typeof useCreateScratchpadRecommendationMutation>;
export type CreateScratchpadRecommendationMutationResult = Apollo.MutationResult<CreateScratchpadRecommendationMutation>;
export type CreateScratchpadRecommendationMutationOptions = Apollo.BaseMutationOptions<CreateScratchpadRecommendationMutation, CreateScratchpadRecommendationMutationVariables>;
export const CreateScratchpadRecommendationFeedbackDocument = gql`
    mutation CreateScratchpadRecommendationFeedback($input: CreateScratchpadRecommendationFeedbackInput!) {
  createScratchpadRecommendationFeedback(input: $input) {
    ...ScratchpadRecommendationFeedbackParts
  }
}
    ${ScratchpadRecommendationFeedbackPartsFragmentDoc}`;
export type CreateScratchpadRecommendationFeedbackMutationFn = Apollo.MutationFunction<CreateScratchpadRecommendationFeedbackMutation, CreateScratchpadRecommendationFeedbackMutationVariables>;

/**
 * __useCreateScratchpadRecommendationFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateScratchpadRecommendationFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScratchpadRecommendationFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScratchpadRecommendationFeedbackMutation, { data, loading, error }] = useCreateScratchpadRecommendationFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScratchpadRecommendationFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateScratchpadRecommendationFeedbackMutation, CreateScratchpadRecommendationFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScratchpadRecommendationFeedbackMutation, CreateScratchpadRecommendationFeedbackMutationVariables>(CreateScratchpadRecommendationFeedbackDocument, options);
      }
export type CreateScratchpadRecommendationFeedbackMutationHookResult = ReturnType<typeof useCreateScratchpadRecommendationFeedbackMutation>;
export type CreateScratchpadRecommendationFeedbackMutationResult = Apollo.MutationResult<CreateScratchpadRecommendationFeedbackMutation>;
export type CreateScratchpadRecommendationFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateScratchpadRecommendationFeedbackMutation, CreateScratchpadRecommendationFeedbackMutationVariables>;
export const ListScratchpadsDocument = gql`
    query ListScratchpads($input: ListScratchpadsInput!) {
  listScratchpads(input: $input) {
    total
    items {
      ...ListScratchpadParts
    }
  }
}
    ${ListScratchpadPartsFragmentDoc}`;

/**
 * __useListScratchpadsQuery__
 *
 * To run a query within a React component, call `useListScratchpadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListScratchpadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListScratchpadsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListScratchpadsQuery(baseOptions: Apollo.QueryHookOptions<ListScratchpadsQuery, ListScratchpadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListScratchpadsQuery, ListScratchpadsQueryVariables>(ListScratchpadsDocument, options);
      }
export function useListScratchpadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListScratchpadsQuery, ListScratchpadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListScratchpadsQuery, ListScratchpadsQueryVariables>(ListScratchpadsDocument, options);
        }
export type ListScratchpadsQueryHookResult = ReturnType<typeof useListScratchpadsQuery>;
export type ListScratchpadsLazyQueryHookResult = ReturnType<typeof useListScratchpadsLazyQuery>;
export type ListScratchpadsQueryResult = Apollo.QueryResult<ListScratchpadsQuery, ListScratchpadsQueryVariables>;
export const GetScratchpadDocument = gql`
    query GetScratchpad($input: GetScratchpadInput!) {
  getScratchpad(input: $input) {
    ...ScratchpadParts
    license {
      ...ApplicationLicenseParts
    }
  }
}
    ${ScratchpadPartsFragmentDoc}
${ApplicationLicensePartsFragmentDoc}`;

/**
 * __useGetScratchpadQuery__
 *
 * To run a query within a React component, call `useGetScratchpadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScratchpadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScratchpadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetScratchpadQuery(baseOptions: Apollo.QueryHookOptions<GetScratchpadQuery, GetScratchpadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScratchpadQuery, GetScratchpadQueryVariables>(GetScratchpadDocument, options);
      }
export function useGetScratchpadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScratchpadQuery, GetScratchpadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScratchpadQuery, GetScratchpadQueryVariables>(GetScratchpadDocument, options);
        }
export type GetScratchpadQueryHookResult = ReturnType<typeof useGetScratchpadQuery>;
export type GetScratchpadLazyQueryHookResult = ReturnType<typeof useGetScratchpadLazyQuery>;
export type GetScratchpadQueryResult = Apollo.QueryResult<GetScratchpadQuery, GetScratchpadQueryVariables>;
export const ListScratchpadAppsDocument = gql`
    query ListScratchpadApps($input: ListScratchpadAppsInput!) {
  listScratchpadApps(input: $input) {
    ...ScratchpadAppParts
    applicationLicense {
      id
      licenseFormValues
    }
  }
}
    ${ScratchpadAppPartsFragmentDoc}`;

/**
 * __useListScratchpadAppsQuery__
 *
 * To run a query within a React component, call `useListScratchpadAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListScratchpadAppsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListScratchpadAppsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListScratchpadAppsQuery(baseOptions: Apollo.QueryHookOptions<ListScratchpadAppsQuery, ListScratchpadAppsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListScratchpadAppsQuery, ListScratchpadAppsQueryVariables>(ListScratchpadAppsDocument, options);
      }
export function useListScratchpadAppsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListScratchpadAppsQuery, ListScratchpadAppsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListScratchpadAppsQuery, ListScratchpadAppsQueryVariables>(ListScratchpadAppsDocument, options);
        }
export type ListScratchpadAppsQueryHookResult = ReturnType<typeof useListScratchpadAppsQuery>;
export type ListScratchpadAppsLazyQueryHookResult = ReturnType<typeof useListScratchpadAppsLazyQuery>;
export type ListScratchpadAppsQueryResult = Apollo.QueryResult<ListScratchpadAppsQuery, ListScratchpadAppsQueryVariables>;
export const ListScratchpadAppsWithApplicationVersionDocument = gql`
    query ListScratchpadAppsWithApplicationVersion($input: ListScratchpadAppsInput!) {
  listScratchpadApps(input: $input) {
    ...ScratchpadAppParts
    applicationLicense {
      ...ApplicationLicensePartsWithApplicationVersionParts
    }
  }
}
    ${ScratchpadAppPartsFragmentDoc}
${ApplicationLicensePartsWithApplicationVersionPartsFragmentDoc}`;

/**
 * __useListScratchpadAppsWithApplicationVersionQuery__
 *
 * To run a query within a React component, call `useListScratchpadAppsWithApplicationVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useListScratchpadAppsWithApplicationVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListScratchpadAppsWithApplicationVersionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListScratchpadAppsWithApplicationVersionQuery(baseOptions: Apollo.QueryHookOptions<ListScratchpadAppsWithApplicationVersionQuery, ListScratchpadAppsWithApplicationVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListScratchpadAppsWithApplicationVersionQuery, ListScratchpadAppsWithApplicationVersionQueryVariables>(ListScratchpadAppsWithApplicationVersionDocument, options);
      }
export function useListScratchpadAppsWithApplicationVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListScratchpadAppsWithApplicationVersionQuery, ListScratchpadAppsWithApplicationVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListScratchpadAppsWithApplicationVersionQuery, ListScratchpadAppsWithApplicationVersionQueryVariables>(ListScratchpadAppsWithApplicationVersionDocument, options);
        }
export type ListScratchpadAppsWithApplicationVersionQueryHookResult = ReturnType<typeof useListScratchpadAppsWithApplicationVersionQuery>;
export type ListScratchpadAppsWithApplicationVersionLazyQueryHookResult = ReturnType<typeof useListScratchpadAppsWithApplicationVersionLazyQuery>;
export type ListScratchpadAppsWithApplicationVersionQueryResult = Apollo.QueryResult<ListScratchpadAppsWithApplicationVersionQuery, ListScratchpadAppsWithApplicationVersionQueryVariables>;
export const CreateScratchpadDocument = gql`
    mutation CreateScratchpad($input: CreateScratchpadInput!) {
  createScratchpad(input: $input) {
    ...ScratchpadParts
    license {
      ...ApplicationLicenseParts
    }
  }
}
    ${ScratchpadPartsFragmentDoc}
${ApplicationLicensePartsFragmentDoc}`;
export type CreateScratchpadMutationFn = Apollo.MutationFunction<CreateScratchpadMutation, CreateScratchpadMutationVariables>;

/**
 * __useCreateScratchpadMutation__
 *
 * To run a mutation, you first call `useCreateScratchpadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScratchpadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScratchpadMutation, { data, loading, error }] = useCreateScratchpadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScratchpadMutation(baseOptions?: Apollo.MutationHookOptions<CreateScratchpadMutation, CreateScratchpadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScratchpadMutation, CreateScratchpadMutationVariables>(CreateScratchpadDocument, options);
      }
export type CreateScratchpadMutationHookResult = ReturnType<typeof useCreateScratchpadMutation>;
export type CreateScratchpadMutationResult = Apollo.MutationResult<CreateScratchpadMutation>;
export type CreateScratchpadMutationOptions = Apollo.BaseMutationOptions<CreateScratchpadMutation, CreateScratchpadMutationVariables>;
export const UpdateScratchpadDocument = gql`
    mutation UpdateScratchpad($input: UpdateScratchpadInput!, $options: UpdateScratchpadInputOptions) {
  updateScratchpad(input: $input, options: $options) {
    ...ScratchpadParts
    license {
      ...ApplicationLicenseParts
    }
  }
}
    ${ScratchpadPartsFragmentDoc}
${ApplicationLicensePartsFragmentDoc}`;
export type UpdateScratchpadMutationFn = Apollo.MutationFunction<UpdateScratchpadMutation, UpdateScratchpadMutationVariables>;

/**
 * __useUpdateScratchpadMutation__
 *
 * To run a mutation, you first call `useUpdateScratchpadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScratchpadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScratchpadMutation, { data, loading, error }] = useUpdateScratchpadMutation({
 *   variables: {
 *      input: // value for 'input'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUpdateScratchpadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScratchpadMutation, UpdateScratchpadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScratchpadMutation, UpdateScratchpadMutationVariables>(UpdateScratchpadDocument, options);
      }
export type UpdateScratchpadMutationHookResult = ReturnType<typeof useUpdateScratchpadMutation>;
export type UpdateScratchpadMutationResult = Apollo.MutationResult<UpdateScratchpadMutation>;
export type UpdateScratchpadMutationOptions = Apollo.BaseMutationOptions<UpdateScratchpadMutation, UpdateScratchpadMutationVariables>;
export const RemoveScratchpadDocument = gql`
    mutation RemoveScratchpad($input: RemoveScratchpadInput!) {
  removeScratchpad(input: $input) {
    ...ScratchpadParts
  }
}
    ${ScratchpadPartsFragmentDoc}`;
export type RemoveScratchpadMutationFn = Apollo.MutationFunction<RemoveScratchpadMutation, RemoveScratchpadMutationVariables>;

/**
 * __useRemoveScratchpadMutation__
 *
 * To run a mutation, you first call `useRemoveScratchpadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveScratchpadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeScratchpadMutation, { data, loading, error }] = useRemoveScratchpadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveScratchpadMutation(baseOptions?: Apollo.MutationHookOptions<RemoveScratchpadMutation, RemoveScratchpadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveScratchpadMutation, RemoveScratchpadMutationVariables>(RemoveScratchpadDocument, options);
      }
export type RemoveScratchpadMutationHookResult = ReturnType<typeof useRemoveScratchpadMutation>;
export type RemoveScratchpadMutationResult = Apollo.MutationResult<RemoveScratchpadMutation>;
export type RemoveScratchpadMutationOptions = Apollo.BaseMutationOptions<RemoveScratchpadMutation, RemoveScratchpadMutationVariables>;
export const RestoreScratchpadDocument = gql`
    mutation RestoreScratchpad($input: RestoreScratchpadInput!) {
  restoreScratchpad(input: $input) {
    ...ScratchpadParts
  }
}
    ${ScratchpadPartsFragmentDoc}`;
export type RestoreScratchpadMutationFn = Apollo.MutationFunction<RestoreScratchpadMutation, RestoreScratchpadMutationVariables>;

/**
 * __useRestoreScratchpadMutation__
 *
 * To run a mutation, you first call `useRestoreScratchpadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreScratchpadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreScratchpadMutation, { data, loading, error }] = useRestoreScratchpadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreScratchpadMutation(baseOptions?: Apollo.MutationHookOptions<RestoreScratchpadMutation, RestoreScratchpadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreScratchpadMutation, RestoreScratchpadMutationVariables>(RestoreScratchpadDocument, options);
      }
export type RestoreScratchpadMutationHookResult = ReturnType<typeof useRestoreScratchpadMutation>;
export type RestoreScratchpadMutationResult = Apollo.MutationResult<RestoreScratchpadMutation>;
export type RestoreScratchpadMutationOptions = Apollo.BaseMutationOptions<RestoreScratchpadMutation, RestoreScratchpadMutationVariables>;
export const CompileScratchpadDocument = gql`
    mutation CompileScratchpad($input: CompileScratchpadInput!) {
  compileScratchpad(input: $input)
}
    `;
export type CompileScratchpadMutationFn = Apollo.MutationFunction<CompileScratchpadMutation, CompileScratchpadMutationVariables>;

/**
 * __useCompileScratchpadMutation__
 *
 * To run a mutation, you first call `useCompileScratchpadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompileScratchpadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [compileScratchpadMutation, { data, loading, error }] = useCompileScratchpadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompileScratchpadMutation(baseOptions?: Apollo.MutationHookOptions<CompileScratchpadMutation, CompileScratchpadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompileScratchpadMutation, CompileScratchpadMutationVariables>(CompileScratchpadDocument, options);
      }
export type CompileScratchpadMutationHookResult = ReturnType<typeof useCompileScratchpadMutation>;
export type CompileScratchpadMutationResult = Apollo.MutationResult<CompileScratchpadMutation>;
export type CompileScratchpadMutationOptions = Apollo.BaseMutationOptions<CompileScratchpadMutation, CompileScratchpadMutationVariables>;
export const GetCompatibleMachinesForScratchpadDocument = gql`
    query GetCompatibleMachinesForScratchpad($input: GetCompatibleMachinesInput!) {
  getCompatibleMachinesForScratchpad(input: $input) {
    machines {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCompatibleMachinesForScratchpadQuery__
 *
 * To run a query within a React component, call `useGetCompatibleMachinesForScratchpadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompatibleMachinesForScratchpadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompatibleMachinesForScratchpadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCompatibleMachinesForScratchpadQuery(baseOptions: Apollo.QueryHookOptions<GetCompatibleMachinesForScratchpadQuery, GetCompatibleMachinesForScratchpadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompatibleMachinesForScratchpadQuery, GetCompatibleMachinesForScratchpadQueryVariables>(GetCompatibleMachinesForScratchpadDocument, options);
      }
export function useGetCompatibleMachinesForScratchpadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompatibleMachinesForScratchpadQuery, GetCompatibleMachinesForScratchpadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompatibleMachinesForScratchpadQuery, GetCompatibleMachinesForScratchpadQueryVariables>(GetCompatibleMachinesForScratchpadDocument, options);
        }
export type GetCompatibleMachinesForScratchpadQueryHookResult = ReturnType<typeof useGetCompatibleMachinesForScratchpadQuery>;
export type GetCompatibleMachinesForScratchpadLazyQueryHookResult = ReturnType<typeof useGetCompatibleMachinesForScratchpadLazyQuery>;
export type GetCompatibleMachinesForScratchpadQueryResult = Apollo.QueryResult<GetCompatibleMachinesForScratchpadQuery, GetCompatibleMachinesForScratchpadQueryVariables>;
export const ListTeamsDocument = gql`
    query ListTeams($input: ListTeamsInput!) {
  listTeams(input: $input) @connection(key: "listTeams") {
    total
    items {
      ...TeamParts
    }
  }
}
    ${TeamPartsFragmentDoc}`;

/**
 * __useListTeamsQuery__
 *
 * To run a query within a React component, call `useListTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListTeamsQuery(baseOptions: Apollo.QueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTeamsQuery, ListTeamsQueryVariables>(ListTeamsDocument, options);
      }
export function useListTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTeamsQuery, ListTeamsQueryVariables>(ListTeamsDocument, options);
        }
export type ListTeamsQueryHookResult = ReturnType<typeof useListTeamsQuery>;
export type ListTeamsLazyQueryHookResult = ReturnType<typeof useListTeamsLazyQuery>;
export type ListTeamsQueryResult = Apollo.QueryResult<ListTeamsQuery, ListTeamsQueryVariables>;
export const ListTeamUsersDocument = gql`
    query ListTeamUsers($input: ListTeamUsersInput!) {
  listTeamUsers(input: $input) {
    total
    items {
      customRole {
        ...RoleParts
      }
      role
      roleId
      user {
        ...UserParts
      }
    }
  }
}
    ${RolePartsFragmentDoc}
${UserPartsFragmentDoc}`;

/**
 * __useListTeamUsersQuery__
 *
 * To run a query within a React component, call `useListTeamUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListTeamUsersQuery(baseOptions: Apollo.QueryHookOptions<ListTeamUsersQuery, ListTeamUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTeamUsersQuery, ListTeamUsersQueryVariables>(ListTeamUsersDocument, options);
      }
export function useListTeamUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTeamUsersQuery, ListTeamUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTeamUsersQuery, ListTeamUsersQueryVariables>(ListTeamUsersDocument, options);
        }
export type ListTeamUsersQueryHookResult = ReturnType<typeof useListTeamUsersQuery>;
export type ListTeamUsersLazyQueryHookResult = ReturnType<typeof useListTeamUsersLazyQuery>;
export type ListTeamUsersQueryResult = Apollo.QueryResult<ListTeamUsersQuery, ListTeamUsersQueryVariables>;
export const GetTeamDocument = gql`
    query GetTeam($input: GetTeamInput!) {
  getTeam(input: $input) {
    ...TeamParts
  }
}
    ${TeamPartsFragmentDoc}`;

/**
 * __useGetTeamQuery__
 *
 * To run a query within a React component, call `useGetTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTeamQuery(baseOptions: Apollo.QueryHookOptions<GetTeamQuery, GetTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
      }
export function useGetTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
        }
export type GetTeamQueryHookResult = ReturnType<typeof useGetTeamQuery>;
export type GetTeamLazyQueryHookResult = ReturnType<typeof useGetTeamLazyQuery>;
export type GetTeamQueryResult = Apollo.QueryResult<GetTeamQuery, GetTeamQueryVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    ...TeamParts
  }
}
    ${TeamPartsFragmentDoc}`;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const DisableTeamDocument = gql`
    mutation DisableTeam($input: DisableTeamInput!) {
  disableTeam(input: $input) {
    ...TeamParts
  }
}
    ${TeamPartsFragmentDoc}`;
export type DisableTeamMutationFn = Apollo.MutationFunction<DisableTeamMutation, DisableTeamMutationVariables>;

/**
 * __useDisableTeamMutation__
 *
 * To run a mutation, you first call `useDisableTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTeamMutation, { data, loading, error }] = useDisableTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableTeamMutation(baseOptions?: Apollo.MutationHookOptions<DisableTeamMutation, DisableTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableTeamMutation, DisableTeamMutationVariables>(DisableTeamDocument, options);
      }
export type DisableTeamMutationHookResult = ReturnType<typeof useDisableTeamMutation>;
export type DisableTeamMutationResult = Apollo.MutationResult<DisableTeamMutation>;
export type DisableTeamMutationOptions = Apollo.BaseMutationOptions<DisableTeamMutation, DisableTeamMutationVariables>;
export const EnableTeamDocument = gql`
    mutation EnableTeam($input: EnableTeamInput!) {
  enableTeam(input: $input) {
    ...TeamParts
  }
}
    ${TeamPartsFragmentDoc}`;
export type EnableTeamMutationFn = Apollo.MutationFunction<EnableTeamMutation, EnableTeamMutationVariables>;

/**
 * __useEnableTeamMutation__
 *
 * To run a mutation, you first call `useEnableTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableTeamMutation, { data, loading, error }] = useEnableTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableTeamMutation(baseOptions?: Apollo.MutationHookOptions<EnableTeamMutation, EnableTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableTeamMutation, EnableTeamMutationVariables>(EnableTeamDocument, options);
      }
export type EnableTeamMutationHookResult = ReturnType<typeof useEnableTeamMutation>;
export type EnableTeamMutationResult = Apollo.MutationResult<EnableTeamMutation>;
export type EnableTeamMutationOptions = Apollo.BaseMutationOptions<EnableTeamMutation, EnableTeamMutationVariables>;
export const UpdateTeamDocument = gql`
    mutation UpdateTeam($input: UpdateTeamInput!) {
  updateTeam(input: $input) {
    ...TeamParts
  }
}
    ${TeamPartsFragmentDoc}`;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const UpdateTeamAccessDocument = gql`
    mutation UpdateTeamAccess($input: UpdateTeamAccessInput!) {
  updateTeamAccess(input: $input) {
    granted {
      ...UserParts
    }
    revoked {
      ...UserParts
    }
  }
}
    ${UserPartsFragmentDoc}`;
export type UpdateTeamAccessMutationFn = Apollo.MutationFunction<UpdateTeamAccessMutation, UpdateTeamAccessMutationVariables>;

/**
 * __useUpdateTeamAccessMutation__
 *
 * To run a mutation, you first call `useUpdateTeamAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamAccessMutation, { data, loading, error }] = useUpdateTeamAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamAccessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamAccessMutation, UpdateTeamAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamAccessMutation, UpdateTeamAccessMutationVariables>(UpdateTeamAccessDocument, options);
      }
export type UpdateTeamAccessMutationHookResult = ReturnType<typeof useUpdateTeamAccessMutation>;
export type UpdateTeamAccessMutationResult = Apollo.MutationResult<UpdateTeamAccessMutation>;
export type UpdateTeamAccessMutationOptions = Apollo.BaseMutationOptions<UpdateTeamAccessMutation, UpdateTeamAccessMutationVariables>;
export const GetTenantDocument = gql`
    query GetTenant {
  getTenant {
    ...TenantParts
  }
}
    ${TenantPartsFragmentDoc}`;

/**
 * __useGetTenantQuery__
 *
 * To run a query within a React component, call `useGetTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantQuery, GetTenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
      }
export function useGetTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantQuery, GetTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
        }
export type GetTenantQueryHookResult = ReturnType<typeof useGetTenantQuery>;
export type GetTenantLazyQueryHookResult = ReturnType<typeof useGetTenantLazyQuery>;
export type GetTenantQueryResult = Apollo.QueryResult<GetTenantQuery, GetTenantQueryVariables>;
export const ListTenantAssignmentsDocument = gql`
    query ListTenantAssignments {
  listTenantAssignments {
    user {
      ...UserParts
    }
    tenant {
      ...TenantParts
    }
  }
}
    ${UserPartsFragmentDoc}
${TenantPartsFragmentDoc}`;

/**
 * __useListTenantAssignmentsQuery__
 *
 * To run a query within a React component, call `useListTenantAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTenantAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTenantAssignmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListTenantAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<ListTenantAssignmentsQuery, ListTenantAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTenantAssignmentsQuery, ListTenantAssignmentsQueryVariables>(ListTenantAssignmentsDocument, options);
      }
export function useListTenantAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTenantAssignmentsQuery, ListTenantAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTenantAssignmentsQuery, ListTenantAssignmentsQueryVariables>(ListTenantAssignmentsDocument, options);
        }
export type ListTenantAssignmentsQueryHookResult = ReturnType<typeof useListTenantAssignmentsQuery>;
export type ListTenantAssignmentsLazyQueryHookResult = ReturnType<typeof useListTenantAssignmentsLazyQuery>;
export type ListTenantAssignmentsQueryResult = Apollo.QueryResult<ListTenantAssignmentsQuery, ListTenantAssignmentsQueryVariables>;
export const UpdateTenantDocument = gql`
    mutation UpdateTenant($input: UpdateTenantInput!) {
  updateTenant(input: $input) {
    ...TenantParts
  }
}
    ${TenantPartsFragmentDoc}`;
export type UpdateTenantMutationFn = Apollo.MutationFunction<UpdateTenantMutation, UpdateTenantMutationVariables>;

/**
 * __useUpdateTenantMutation__
 *
 * To run a mutation, you first call `useUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantMutation, { data, loading, error }] = useUpdateTenantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTenantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantMutation, UpdateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument, options);
      }
export type UpdateTenantMutationHookResult = ReturnType<typeof useUpdateTenantMutation>;
export type UpdateTenantMutationResult = Apollo.MutationResult<UpdateTenantMutation>;
export type UpdateTenantMutationOptions = Apollo.BaseMutationOptions<UpdateTenantMutation, UpdateTenantMutationVariables>;
export const DeactivateTenantDocument = gql`
    mutation DeactivateTenant {
  deactivateTenant
}
    `;
export type DeactivateTenantMutationFn = Apollo.MutationFunction<DeactivateTenantMutation, DeactivateTenantMutationVariables>;

/**
 * __useDeactivateTenantMutation__
 *
 * To run a mutation, you first call `useDeactivateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateTenantMutation, { data, loading, error }] = useDeactivateTenantMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeactivateTenantMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateTenantMutation, DeactivateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateTenantMutation, DeactivateTenantMutationVariables>(DeactivateTenantDocument, options);
      }
export type DeactivateTenantMutationHookResult = ReturnType<typeof useDeactivateTenantMutation>;
export type DeactivateTenantMutationResult = Apollo.MutationResult<DeactivateTenantMutation>;
export type DeactivateTenantMutationOptions = Apollo.BaseMutationOptions<DeactivateTenantMutation, DeactivateTenantMutationVariables>;
export const SubscribeToTenantDocument = gql`
    subscription SubscribeToTenant {
  subscribeToTenant {
    ...TenantParts
  }
}
    ${TenantPartsFragmentDoc}`;

/**
 * __useSubscribeToTenantSubscription__
 *
 * To run a query within a React component, call `useSubscribeToTenantSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToTenantSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToTenantSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSubscribeToTenantSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeToTenantSubscription, SubscribeToTenantSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToTenantSubscription, SubscribeToTenantSubscriptionVariables>(SubscribeToTenantDocument, options);
      }
export type SubscribeToTenantSubscriptionHookResult = ReturnType<typeof useSubscribeToTenantSubscription>;
export type SubscribeToTenantSubscriptionResult = Apollo.SubscriptionResult<SubscribeToTenantSubscription>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    ...UserParts
  }
}
    ${UserPartsFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    ...UserParts
  }
}
    ${UserPartsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const EnableUserDocument = gql`
    mutation EnableUser($input: EnableUserInput!) {
  enableUser(input: $input)
}
    `;
export type EnableUserMutationFn = Apollo.MutationFunction<EnableUserMutation, EnableUserMutationVariables>;

/**
 * __useEnableUserMutation__
 *
 * To run a mutation, you first call `useEnableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableUserMutation, { data, loading, error }] = useEnableUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableUserMutation(baseOptions?: Apollo.MutationHookOptions<EnableUserMutation, EnableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableUserMutation, EnableUserMutationVariables>(EnableUserDocument, options);
      }
export type EnableUserMutationHookResult = ReturnType<typeof useEnableUserMutation>;
export type EnableUserMutationResult = Apollo.MutationResult<EnableUserMutation>;
export type EnableUserMutationOptions = Apollo.BaseMutationOptions<EnableUserMutation, EnableUserMutationVariables>;
export const DisableUserDocument = gql`
    mutation DisableUser($input: DisableUserInput!) {
  disableUser(input: $input)
}
    `;
export type DisableUserMutationFn = Apollo.MutationFunction<DisableUserMutation, DisableUserMutationVariables>;

/**
 * __useDisableUserMutation__
 *
 * To run a mutation, you first call `useDisableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableUserMutation, { data, loading, error }] = useDisableUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableUserMutation(baseOptions?: Apollo.MutationHookOptions<DisableUserMutation, DisableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableUserMutation, DisableUserMutationVariables>(DisableUserDocument, options);
      }
export type DisableUserMutationHookResult = ReturnType<typeof useDisableUserMutation>;
export type DisableUserMutationResult = Apollo.MutationResult<DisableUserMutation>;
export type DisableUserMutationOptions = Apollo.BaseMutationOptions<DisableUserMutation, DisableUserMutationVariables>;
export const GetUserDocument = gql`
    query GetUser($input: GetUserInput!) {
  getUser(input: $input) {
    ...UserParts
    intercomUserHash
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const ListUsersDocument = gql`
    query ListUsers($input: ListUsersInput!) {
  listUsers(input: $input) {
    total
    items {
      ...UserParts
    }
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const SubscribeToUserPermissionsDocument = gql`
    subscription SubscribeToUserPermissions {
  subscribeToUserPermissions
}
    `;

/**
 * __useSubscribeToUserPermissionsSubscription__
 *
 * To run a query within a React component, call `useSubscribeToUserPermissionsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToUserPermissionsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToUserPermissionsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSubscribeToUserPermissionsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeToUserPermissionsSubscription, SubscribeToUserPermissionsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToUserPermissionsSubscription, SubscribeToUserPermissionsSubscriptionVariables>(SubscribeToUserPermissionsDocument, options);
      }
export type SubscribeToUserPermissionsSubscriptionHookResult = ReturnType<typeof useSubscribeToUserPermissionsSubscription>;
export type SubscribeToUserPermissionsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToUserPermissionsSubscription>;
export const HydrateWorkspaceDocument = gql`
    query HydrateWorkspace($userInput: GetUserInput!, $teamListInput: ListTeamsInput!, $featureInput: GetFeaturesInput!, $userPreferenceListInput: ListPreferencesInput!, $tenantPreferenceListInput: ListPreferencesInput!) {
  getFeatures(input: $featureInput)
  getTenant {
    ...TenantParts
  }
  getUser(input: $userInput) {
    ...UserParts
    intercomUserHash
  }
  listTeams(input: $teamListInput) @connection(key: "listTeams") {
    total
    items {
      ...TeamParts
    }
  }
  getPlanDetails {
    ...PlanDetailsParts
  }
  userPreferences: listPreferences(input: $userPreferenceListInput) {
    total
    items {
      ...PreferenceParts
    }
  }
  tenantPreferences: listPreferences(input: $tenantPreferenceListInput) {
    total
    items {
      ...PreferenceParts
    }
  }
}
    ${TenantPartsFragmentDoc}
${UserPartsFragmentDoc}
${TeamPartsFragmentDoc}
${PlanDetailsPartsFragmentDoc}
${PreferencePartsFragmentDoc}`;

/**
 * __useHydrateWorkspaceQuery__
 *
 * To run a query within a React component, call `useHydrateWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useHydrateWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHydrateWorkspaceQuery({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      teamListInput: // value for 'teamListInput'
 *      featureInput: // value for 'featureInput'
 *      userPreferenceListInput: // value for 'userPreferenceListInput'
 *      tenantPreferenceListInput: // value for 'tenantPreferenceListInput'
 *   },
 * });
 */
export function useHydrateWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<HydrateWorkspaceQuery, HydrateWorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HydrateWorkspaceQuery, HydrateWorkspaceQueryVariables>(HydrateWorkspaceDocument, options);
      }
export function useHydrateWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HydrateWorkspaceQuery, HydrateWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HydrateWorkspaceQuery, HydrateWorkspaceQueryVariables>(HydrateWorkspaceDocument, options);
        }
export type HydrateWorkspaceQueryHookResult = ReturnType<typeof useHydrateWorkspaceQuery>;
export type HydrateWorkspaceLazyQueryHookResult = ReturnType<typeof useHydrateWorkspaceLazyQuery>;
export type HydrateWorkspaceQueryResult = Apollo.QueryResult<HydrateWorkspaceQuery, HydrateWorkspaceQueryVariables>;
export const CreateTenantDocument = gql`
    mutation CreateTenant($input: CreateTenantInput!) {
  createTenant(input: $input) {
    ...TenantParts
  }
}
    ${TenantPartsFragmentDoc}`;
export type CreateTenantMutationFn = Apollo.MutationFunction<CreateTenantMutation, CreateTenantMutationVariables>;

/**
 * __useCreateTenantMutation__
 *
 * To run a mutation, you first call `useCreateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantMutation, { data, loading, error }] = useCreateTenantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTenantMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenantMutation, CreateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenantMutation, CreateTenantMutationVariables>(CreateTenantDocument, options);
      }
export type CreateTenantMutationHookResult = ReturnType<typeof useCreateTenantMutation>;
export type CreateTenantMutationResult = Apollo.MutationResult<CreateTenantMutation>;
export type CreateTenantMutationOptions = Apollo.BaseMutationOptions<CreateTenantMutation, CreateTenantMutationVariables>;